/* eslint-disable */
// This file is generated by graphql-codegen. Do not edit it manually.

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateString: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  JSON: { input: any; output: any; }
  TimeString: { input: any; output: any; }
  URL: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddressType = {
  __typename?: 'Address';
  apartment?: Maybe<Scalars['String']['output']>;
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  fiasId?: Maybe<Scalars['String']['output']>;
  flat?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  settlement?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AmountType = {
  __typename?: 'Amount';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  valueUSD?: Maybe<Scalars['Float']['output']>;
};

export type AmountInputType = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type AnalyticsChartType = {
  __typename?: 'AnalyticsChart';
  calendarInterval: CalendarIntervalType;
  items: Array<AnalyticsChartItemType>;
};

export type AnalyticsChartItemType = {
  __typename?: 'AnalyticsChartItem';
  data: Array<AnalyticsChartPointType>;
  displayCurrency?: Maybe<PaymentCurrencyType>;
  label: Scalars['String']['output'];
};

export type AnalyticsChartPointType = {
  __typename?: 'AnalyticsChartPoint';
  x: Scalars['DateTime']['output'];
  y: Scalars['Float']['output'];
};

export type AnalyticsCityBreakdownType = {
  __typename?: 'AnalyticsCityBreakdown';
  city: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsContentBreakdownType = {
  __typename?: 'AnalyticsContentBreakdown';
  contentId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsCountryBreakdownType = {
  __typename?: 'AnalyticsCountryBreakdown';
  countryCode: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsDeviceBreakdownType = {
  __typename?: 'AnalyticsDeviceBreakdown';
  label: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type AnalyticsLinkBreakdownType = {
  __typename?: 'AnalyticsLinkBreakdown';
  linkId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsProductBreakdownType = {
  __typename?: 'AnalyticsProductBreakdown';
  productId: Scalars['ID']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AnalyticsPromocodeBreakdownType = {
  __typename?: 'AnalyticsPromocodeBreakdown';
  promocodeId: Scalars['ID']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AnalyticsProviderBreakdownType = {
  __typename?: 'AnalyticsProviderBreakdown';
  provider: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
};

export type AnalyticsSalesCityBreakdownType = {
  __typename?: 'AnalyticsSalesCityBreakdown';
  city: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
};

export type AnalyticsSalesCountryBreakdownType = {
  __typename?: 'AnalyticsSalesCountryBreakdown';
  countryCode: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
};

export type AnalyticsSalesDeviceBreakdownType = {
  __typename?: 'AnalyticsSalesDeviceBreakdown';
  label: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
};

export type AnalyticsSalesEmailCampaignBreakdownType = {
  __typename?: 'AnalyticsSalesEmailCampaignBreakdown';
  automationId: Scalars['ID']['output'];
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  /** Пусто: сценарий удалён */
  title: Scalars['String']['output'];
};

export type AnalyticsSalesFilterInputType = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<PaymentCurrencyType>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  /** Сценарий рассылки касания платежа (Payment.utm.email) */
  emailAutomationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  promocodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userDeviceOss?: InputMaybe<Array<Scalars['String']['input']>>;
  userDeviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  utmCampaigns?: InputMaybe<Array<Scalars['String']['input']>>;
  utmContents?: InputMaybe<Array<Scalars['String']['input']>>;
  utmMediums?: InputMaybe<Array<Scalars['String']['input']>>;
  utmSources?: InputMaybe<Array<Scalars['String']['input']>>;
  utmTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnalyticsSalesLinkBreakdownType = {
  __typename?: 'AnalyticsSalesLinkBreakdown';
  linkId: Scalars['ID']['output'];
  revenue: Scalars['Float']['output'];
  reward: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AnalyticsSalesResultType = {
  __typename?: 'AnalyticsSalesResult';
  currency: PaymentCurrencyType;
  purchasers: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  revenueByDate: AnalyticsChartType;
  sales: Scalars['Int']['output'];
  salesByCity: Array<AnalyticsSalesCityBreakdownType>;
  salesByCountry: Array<AnalyticsSalesCountryBreakdownType>;
  salesByDate: AnalyticsChartType;
  salesByDeviceOs: Array<AnalyticsSalesDeviceBreakdownType>;
  salesByDeviceType: Array<AnalyticsSalesDeviceBreakdownType>;
  /** Продажи по письму касания; includeRenewals: false только первые покупки */
  salesByEmailCampaign: Array<AnalyticsSalesEmailCampaignBreakdownType>;
  salesByLink: Array<AnalyticsSalesLinkBreakdownType>;
  salesByProduct: Array<AnalyticsProductBreakdownType>;
  salesByPromocode: Array<AnalyticsPromocodeBreakdownType>;
  salesByProvider: Array<AnalyticsProviderBreakdownType>;
  salesByUtm: Array<AnalyticsSalesUtmBreakdownType>;
};


export type AnalyticsSalesResultRevenueByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};


export type AnalyticsSalesResultSalesByCityArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByCountryArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};


export type AnalyticsSalesResultSalesByEmailCampaignArgsType = {
  includeRenewals?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByLinkArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByProductArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByPromocodeArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsSalesResultSalesByUtmArgsType = {
  dimension: UtmDimensionType;
};

export type AnalyticsSalesUtmBreakdownType = {
  __typename?: 'AnalyticsSalesUtmBreakdown';
  revenue: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type AnalyticsTagBreakdownType = {
  __typename?: 'AnalyticsTagBreakdown';
  tagId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsUsersCountryBreakdownType = {
  __typename?: 'AnalyticsUsersCountryBreakdown';
  countryCode: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AnalyticsUsersEmailCampaignBreakdownType = {
  __typename?: 'AnalyticsUsersEmailCampaignBreakdown';
  automationId: Scalars['ID']['output'];
  /** Пусто: сценарий удалён */
  title: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AnalyticsUsersFilterInputType = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  emailAutomationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  linkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  utmCampaigns?: InputMaybe<Array<Scalars['String']['input']>>;
  utmContents?: InputMaybe<Array<Scalars['String']['input']>>;
  utmMediums?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Касание регистрации (User.registrationUtm), спека attribution */
  utmSources?: InputMaybe<Array<Scalars['String']['input']>>;
  utmTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnalyticsUsersLanguageBreakdownType = {
  __typename?: 'AnalyticsUsersLanguageBreakdown';
  language: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AnalyticsUsersLinkBreakdownType = {
  __typename?: 'AnalyticsUsersLinkBreakdown';
  linkId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type AnalyticsUsersResultType = {
  __typename?: 'AnalyticsUsersResult';
  newUsers: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  usersByCountry: Array<AnalyticsUsersCountryBreakdownType>;
  usersByDate: AnalyticsChartType;
  usersByEmailCampaign: Array<AnalyticsUsersEmailCampaignBreakdownType>;
  usersByLanguage: Array<AnalyticsUsersLanguageBreakdownType>;
  usersByLink: Array<AnalyticsUsersLinkBreakdownType>;
  /** Регистрации по первому касанию: источник, канал, кампания, content, term */
  usersByUtm: Array<AnalyticsUsersUtmBreakdownType>;
};


export type AnalyticsUsersResultUsersByCountryArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsUsersResultUsersByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};


export type AnalyticsUsersResultUsersByEmailCampaignArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsUsersResultUsersByLinkArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsUsersResultUsersByUtmArgsType = {
  dimension: UtmDimensionType;
};

export type AnalyticsUsersUtmBreakdownType = {
  __typename?: 'AnalyticsUsersUtmBreakdown';
  users: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type AnalyticsUtmBreakdownType = {
  __typename?: 'AnalyticsUtmBreakdown';
  value: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type AnalyticsViewsEmailCampaignBreakdownType = {
  __typename?: 'AnalyticsViewsEmailCampaignBreakdown';
  automationId: Scalars['ID']['output'];
  /** Пусто: сценарий удалён */
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type AnalyticsViewsFilterInputType = {
  contentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentTypes?: InputMaybe<Array<ContentTypeType>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  /** Сценарий рассылки касания просмотра (View.utm.email) */
  emailAutomationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userDeviceOss?: InputMaybe<Array<Scalars['String']['input']>>;
  userDeviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  utmCampaigns?: InputMaybe<Array<Scalars['String']['input']>>;
  utmContents?: InputMaybe<Array<Scalars['String']['input']>>;
  utmMediums?: InputMaybe<Array<Scalars['String']['input']>>;
  utmSources?: InputMaybe<Array<Scalars['String']['input']>>;
  utmTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnalyticsViewsResultType = {
  __typename?: 'AnalyticsViewsResult';
  duration: Scalars['Float']['output'];
  durationByDate: AnalyticsChartType;
  views: Scalars['Int']['output'];
  viewsByCity: Array<AnalyticsCityBreakdownType>;
  viewsByContent: Array<AnalyticsContentBreakdownType>;
  viewsByCountry: Array<AnalyticsCountryBreakdownType>;
  viewsByDate: AnalyticsChartType;
  viewsByDeviceOs: Array<AnalyticsDeviceBreakdownType>;
  viewsByDeviceType: Array<AnalyticsDeviceBreakdownType>;
  viewsByEmailCampaign: Array<AnalyticsViewsEmailCampaignBreakdownType>;
  viewsByLink: Array<AnalyticsLinkBreakdownType>;
  viewsByTag: Array<AnalyticsTagBreakdownType>;
  viewsByUtm: Array<AnalyticsUtmBreakdownType>;
  visitors: Scalars['Int']['output'];
  visitorsByDate: AnalyticsChartType;
};


export type AnalyticsViewsResultDurationByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};


export type AnalyticsViewsResultViewsByCityArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByContentArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByCountryArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};


export type AnalyticsViewsResultViewsByEmailCampaignArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByLinkArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByTagArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsViewsResultViewsByUtmArgsType = {
  dimension: UtmDimensionType;
};


export type AnalyticsViewsResultVisitorsByDateArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
};

export enum AnalyticsWidgetType {
  DurationByDateType = 'DURATION_BY_DATE',
  RevenueByDateType = 'REVENUE_BY_DATE',
  SalesByCityType = 'SALES_BY_CITY',
  SalesByCountryType = 'SALES_BY_COUNTRY',
  SalesByDateType = 'SALES_BY_DATE',
  SalesByDeviceOsType = 'SALES_BY_DEVICE_OS',
  SalesByDeviceTypeType = 'SALES_BY_DEVICE_TYPE',
  SalesByEmailCampaignType = 'SALES_BY_EMAIL_CAMPAIGN',
  SalesByLinkType = 'SALES_BY_LINK',
  SalesByProductType = 'SALES_BY_PRODUCT',
  SalesByPromocodeType = 'SALES_BY_PROMOCODE',
  SalesByProviderType = 'SALES_BY_PROVIDER',
  SalesByUtmType = 'SALES_BY_UTM',
  UsersByCountryType = 'USERS_BY_COUNTRY',
  UsersByDateType = 'USERS_BY_DATE',
  UsersByEmailCampaignType = 'USERS_BY_EMAIL_CAMPAIGN',
  UsersByLanguageType = 'USERS_BY_LANGUAGE',
  UsersByLinkType = 'USERS_BY_LINK',
  UsersByUtmType = 'USERS_BY_UTM',
  ViewsByCityType = 'VIEWS_BY_CITY',
  ViewsByContentType = 'VIEWS_BY_CONTENT',
  ViewsByCountryType = 'VIEWS_BY_COUNTRY',
  ViewsByDateType = 'VIEWS_BY_DATE',
  ViewsByDeviceOsType = 'VIEWS_BY_DEVICE_OS',
  ViewsByDeviceTypeType = 'VIEWS_BY_DEVICE_TYPE',
  ViewsByEmailCampaignType = 'VIEWS_BY_EMAIL_CAMPAIGN',
  ViewsByLinkType = 'VIEWS_BY_LINK',
  ViewsByTagType = 'VIEWS_BY_TAG',
  ViewsByUtmType = 'VIEWS_BY_UTM',
  VisitorsByDateType = 'VISITORS_BY_DATE'
}

export enum AnnotationPositionType {
  BottomLeftType = 'BOTTOM_LEFT',
  BottomRightType = 'BOTTOM_RIGHT',
  TopLeftType = 'TOP_LEFT',
  TopRightType = 'TOP_RIGHT'
}

export enum ApplicationPlatformType {
  AndroidType = 'ANDROID',
  IosType = 'IOS',
  RokuType = 'ROKU',
  WebType = 'WEB'
}

export type AssistantAttachmentType = {
  __typename?: 'AssistantAttachment';
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type AssistantConversationType = {
  __typename?: 'AssistantConversation';
  createdAt: Scalars['DateTime']['output'];
  hasRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastMessageAt: Scalars['DateTime']['output'];
  messageCount: Scalars['Int']['output'];
  messages: Array<AssistantMessageType>;
  platform?: Maybe<PlatformType>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<ConversationTopicType>;
  user?: Maybe<UserType>;
  /** Касание зрителя на момент начала диалога (у обращения: касание его диалога) */
  utm?: Maybe<AttributionTouchType>;
};

export type AssistantConversationConnectionType = {
  __typename?: 'AssistantConversationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AssistantConversationType>;
};

export type AssistantConversationsFilterInputType = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasRequest?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<ConversationTopicType>;
};

export type AssistantMessageType = {
  __typename?: 'AssistantMessage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: AssistantMessageKindType;
  rating?: Maybe<AssistantMessageRatingType>;
  role: AssistantMessageRoleType;
  text: Scalars['String']['output'];
};

export enum AssistantMessageKindType {
  BlockedType = 'BLOCKED',
  ErrorType = 'ERROR',
  OffTopicType = 'OFF_TOPIC',
  PlanResultType = 'PLAN_RESULT',
  TextType = 'TEXT'
}

export enum AssistantMessageRatingType {
  DownType = 'DOWN',
  UpType = 'UP'
}

export enum AssistantMessageRoleType {
  AssistantType = 'ASSISTANT',
  UserType = 'USER'
}

export type AssistantPlanType = {
  __typename?: 'AssistantPlan';
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes: Array<Scalars['String']['output']>;
  previews: Scalars['JSON']['output'];
  sources: Array<Scalars['String']['output']>;
  status: AssistantPlanStatusType;
  steps: Array<AssistantPlanStepType>;
  title: Scalars['String']['output'];
};

/** Почему шаг плана опасен (plan/dangerous.ts): строка причины в карточке плана */
export enum AssistantPlanDangerReasonType {
  BanType = 'BAN',
  CountryAccessType = 'COUNTRY_ACCESS',
  DeleteType = 'DELETE',
  DisableMemberType = 'DISABLE_MEMBER',
  FinishStreamType = 'FINISH_STREAM',
  MassChangeType = 'MASS_CHANGE',
  ModelType = 'MODEL',
  PublishedPriceType = 'PUBLISHED_PRICE',
  RemovesItemsType = 'REMOVES_ITEMS',
  RoleAdminType = 'ROLE_ADMIN',
  RoleRemoveType = 'ROLE_REMOVE',
  TerminatePurchaseType = 'TERMINATE_PURCHASE',
  UnpublishType = 'UNPUBLISH'
}

export enum AssistantPlanStatusType {
  CancelledType = 'CANCELLED',
  DoneType = 'DONE',
  DraftType = 'DRAFT',
  FailedType = 'FAILED',
  PartialType = 'PARTIAL',
  RunningType = 'RUNNING'
}

export type AssistantPlanStepType = {
  __typename?: 'AssistantPlanStep';
  /** Причина опасности, null у безопасного шага и у планов до появления поля */
  dangerReason?: Maybe<AssistantPlanDangerReasonType>;
  dangerous: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  /** Перезаписываемые списки, из которых шаг убирает элементы */
  removedFrom: Array<Scalars['String']['output']>;
  status: AssistantPlanStepStatusType;
};

export enum AssistantPlanStepStatusType {
  DoneType = 'DONE',
  FailedType = 'FAILED',
  PendingType = 'PENDING',
  SkippedType = 'SKIPPED'
}

export type AttributionEmailType = {
  __typename?: 'AttributionEmail';
  automationId?: Maybe<Scalars['ID']['output']>;
  /** null: сценарий удалён (кабинет показывает «Удалённая рассылка») или письмо служебное */
  automationName?: Maybe<Scalars['String']['output']>;
  kind: AttributionEmailKindType;
  nodeId?: Maybe<Scalars['String']['output']>;
  /** Имя шаблона служебного письма */
  template?: Maybe<Scalars['String']['output']>;
};

export enum AttributionEmailKindType {
  BroadcastType = 'BROADCAST',
  EventType = 'EVENT',
  JourneyType = 'JOURNEY',
  TransactionalType = 'TRANSACTIONAL'
}

export type AttributionLinkType = {
  __typename?: 'AttributionLink';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AttributionTouchType = {
  __typename?: 'AttributionTouch';
  /** Касание восстановлено бэкфиллом: только аналитика, без награды ссылки */
  backfilled: Scalars['Boolean']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  /** null у старых меток и восстановленных бэкфиллом */
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  email?: Maybe<AttributionEmailType>;
  /** null: ссылки нет или она другой платформы */
  link?: Maybe<AttributionLinkType>;
  linkClickId?: Maybe<Scalars['ID']['output']>;
  linkId?: Maybe<Scalars['ID']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type AudienceConditionType = {
  __typename?: 'AudienceCondition';
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  field: AudienceFieldType;
  /** Узел письма (EMAIL_OPENED, EMAIL_CLICKED) */
  nodeId?: Maybe<Scalars['String']['output']>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  op: AudienceOpType;
  stringValues?: Maybe<Array<Scalars['String']['output']>>;
};

export type AudienceConditionInputType = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  field: AudienceFieldType;
  /** Узел письма (EMAIL_OPENED, EMAIL_CLICKED) */
  nodeId?: InputMaybe<Scalars['String']['input']>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  op: AudienceOpType;
  stringValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceEstimateType = {
  __typename?: 'AudienceEstimate';
  contacts: Scalars['Int']['output'];
  viewers: Scalars['Int']['output'];
};

export enum AudienceFieldType {
  CountryType = 'COUNTRY',
  EmailClickedType = 'EMAIL_CLICKED',
  EmailOpenedType = 'EMAIL_OPENED',
  HasActiveSubscriptionType = 'HAS_ACTIVE_SUBSCRIPTION',
  HasPurchasesType = 'HAS_PURCHASES',
  LanguageType = 'LANGUAGE',
  LastViewDaysAgoType = 'LAST_VIEW_DAYS_AGO',
  PurchasedProductType = 'PURCHASED_PRODUCT',
  RegisteredDaysAgoType = 'REGISTERED_DAYS_AGO',
  RegistrationEmailCampaignType = 'REGISTRATION_EMAIL_CAMPAIGN',
  RegistrationLinkType = 'REGISTRATION_LINK',
  RegistrationUtmCampaignType = 'REGISTRATION_UTM_CAMPAIGN',
  RegistrationUtmMediumType = 'REGISTRATION_UTM_MEDIUM',
  RegistrationUtmSourceType = 'REGISTRATION_UTM_SOURCE',
  SpentUsdType = 'SPENT_USD',
  UpcomingStreamType = 'UPCOMING_STREAM'
}

export type AudienceFilterType = {
  __typename?: 'AudienceFilter';
  conditions: Array<AudienceConditionType>;
  match: AudienceMatchType;
};

export type AudienceFilterInputType = {
  conditions: Array<AudienceConditionInputType>;
  match: AudienceMatchType;
};

export enum AudienceMatchType {
  AllType = 'ALL',
  AnyType = 'ANY'
}

export enum AudienceOpType {
  GteType = 'GTE',
  InType = 'IN',
  IsType = 'IS',
  LteType = 'LTE',
  NeverType = 'NEVER',
  NotInType = 'NOT_IN'
}

export type AutocompleteType = {
  __typename?: 'Autocomplete';
  options: Array<Maybe<AutocompleteOptionType>>;
  value: Array<Maybe<AutocompleteOptionType>>;
};

export type AutocompleteLinksFilterInputType = {
  linkType?: InputMaybe<LinkTypeType>;
};

export type AutocompleteOptionType = {
  __typename?: 'AutocompleteOption';
  label: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AutocompleteOptionWithIdType = {
  __typename?: 'AutocompleteOptionWithID';
  label: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type AutocompletePlatformPagesFilterInputType = {
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutocompleteTagTypesFilterInputType = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutocompleteTagsFilterInputType = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutocompleteWithIdType = {
  __typename?: 'AutocompleteWithID';
  options: Array<Maybe<AutocompleteOptionWithIdType>>;
  value: Array<Maybe<AutocompleteOptionWithIdType>>;
};

export type AutomationType = {
  __typename?: 'Automation';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Что партнёр может сделать со сценарием в его статусе (automations/lifecycle.ts) */
  allowedActions: Array<AutomationActionType>;
  /** null: зрители платформы не входят в аудиторию */
  audience?: Maybe<AudienceFilterType>;
  contactListIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailTemplate?: Maybe<EmailTemplateType>;
  emailTemplateId?: Maybe<Scalars['ID']['output']>;
  /** Входы в цепочку за сегодня (UTC), отказы сверх лимита за сегодня и дневной лимит платформы */
  entryToday: AutomationEntryLimitType;
  /** Последние события платформы, новые сверху (не больше 50) */
  eventRuns: Array<AutomationEventRunType>;
  /** Правила выхода цепочки по порядку (у рассылок и автоматизаций пусто) */
  exitRules: Array<AutomationExitRuleType>;
  graph: AutomationGraphType;
  /** Ошибки графа (пусто у рассылок) */
  graphIssues: Array<AutomationGraphIssueType>;
  /** Правила графа вида сценария (как automationGraphRules); null у вида без правил */
  graphRules?: Maybe<AutomationGraphRulesType>;
  id: Scalars['ID']['output'];
  kind: AutomationKindType;
  name: Scalars['String']['output'];
  nodeStats: Array<AutomationNodeStatsType>;
  reentry: AutomationReentryType;
  /** Версия настройки: растёт с каждым сохранением графа, аудитории или названия */
  revision: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: BroadcastStateType;
  stats: AutomationStatsType;
  status: AutomationStatusType;
  templateKey?: Maybe<Scalars['String']['output']>;
  /** Событие узла-триггера (строка списка читает его вместо всего графа); null без триггера */
  triggerEvent?: Maybe<AutomationTriggerType>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AutomationEventRunsArgsType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Действие партнёра над сценарием: правка, запуск, пауза, архив, удаление */
export enum AutomationActionType {
  ActivateType = 'ACTIVATE',
  ArchiveType = 'ARCHIVE',
  DeleteType = 'DELETE',
  EditType = 'EDIT',
  PauseType = 'PAUSE'
}

/** Конфиг узла CONDITION: выход yes, если зритель проходит фильтр */
export type AutomationConditionConfigType = {
  __typename?: 'AutomationConditionConfig';
  filter: AudienceFilterType;
};

export type AutomationConditionConfigInputType = {
  filter: AudienceFilterInputType;
};

export type AutomationConnectionType = {
  __typename?: 'AutomationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AutomationType>;
};

export type AutomationEdgeType = {
  __typename?: 'AutomationEdge';
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceHandle?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
};

export type AutomationEdgeInputType = {
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceHandle?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};

export type AutomationEnrollmentType = {
  __typename?: 'AutomationEnrollment';
  createdAt: Scalars['DateTime']['output'];
  currentNodeId?: Maybe<Scalars['String']['output']>;
  exitReason?: Maybe<AutomationEnrollmentExitReasonType>;
  exitRuleId?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: AutomationEnrollmentStatusType;
  viewer?: Maybe<AutomationEnrollmentViewerType>;
  waitUntil?: Maybe<Scalars['DateTime']['output']>;
};

export enum AutomationEnrollmentExitReasonType {
  AutomationArchivedType = 'AUTOMATION_ARCHIVED',
  CancelledType = 'CANCELLED',
  GraphChangedType = 'GRAPH_CHANGED',
  UserDeletedType = 'USER_DELETED'
}

export type AutomationEnrollmentPageType = {
  __typename?: 'AutomationEnrollmentPage';
  /** Курсор следующей страницы; null значит страниц больше нет */
  nextCursor?: Maybe<Scalars['ID']['output']>;
  nodes: Array<AutomationEnrollmentType>;
};

export enum AutomationEnrollmentStatusType {
  ActiveType = 'ACTIVE',
  CompletedType = 'COMPLETED',
  ExitedType = 'EXITED',
  FailedType = 'FAILED',
  GoalReachedType = 'GOAL_REACHED',
  StoppedType = 'STOPPED'
}

export type AutomationEnrollmentViewerType = {
  __typename?: 'AutomationEnrollmentViewer';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type AutomationEntryLimitType = {
  __typename?: 'AutomationEntryLimit';
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  /** Сколько входов сегодня не состоялось из-за лимита */
  limited: Scalars['Int']['output'];
};

/** Событие платформы, обработанное автоматизацией */
export type AutomationEventRunType = {
  __typename?: 'AutomationEventRun';
  enrolled: Scalars['Int']['output'];
  eventAt: Scalars['DateTime']['output'];
  eventType: AutomationTriggerType;
  id: Scalars['ID']['output'];
  objectId: Scalars['ID']['output'];
  objectTitle: Scalars['String']['output'];
  skipReason?: Maybe<AutomationEventRunSkipReasonType>;
  skipped: Scalars['Int']['output'];
  status: AutomationEventRunStatusType;
};

export enum AutomationEventRunSkipReasonType {
  AutomationInactiveType = 'AUTOMATION_INACTIVE',
  MarketingDisabledType = 'MARKETING_DISABLED',
  ObjectUnavailableType = 'OBJECT_UNAVAILABLE',
  RateLimitType = 'RATE_LIMIT'
}

export enum AutomationEventRunStatusType {
  DoneType = 'DONE',
  FailedType = 'FAILED',
  RunningType = 'RUNNING',
  SkippedType = 'SKIPPED'
}

export type AutomationExitRuleType = {
  __typename?: 'AutomationExitRule';
  /** null: правило только с фильтром, его проверяет тик перед каждым шагом */
  event?: Maybe<AutomationExitRuleEventType>;
  filter?: Maybe<AudienceFilterType>;
  id: Scalars['String']['output'];
  kind: AutomationExitRuleKindType;
  name: Scalars['String']['output'];
  scope: AutomationExitRuleScopeType;
};

/** События правил выхода цепочки */
export enum AutomationExitRuleEventType {
  MarketingUnsubscribedType = 'MARKETING_UNSUBSCRIBED',
  PaymentSucceededType = 'PAYMENT_SUCCEEDED',
  ProductPurchasedType = 'PRODUCT_PURCHASED',
  PurchaseRefundedType = 'PURCHASE_REFUNDED',
  SubscriptionExpiredType = 'SUBSCRIPTION_EXPIRED',
  SubscriptionRenewalEnabledType = 'SUBSCRIPTION_RENEWAL_ENABLED',
  SubscriptionRenewedType = 'SUBSCRIPTION_RENEWED',
  ViewCompletedType = 'VIEW_COMPLETED',
  ViewStartedType = 'VIEW_STARTED'
}

export type AutomationExitRuleInputType = {
  event?: InputMaybe<AutomationExitRuleEventType>;
  filter?: InputMaybe<AudienceFilterInputType>;
  id: Scalars['String']['input'];
  kind: AutomationExitRuleKindType;
  name: Scalars['String']['input'];
  scope: AutomationExitRuleScopeType;
};

export enum AutomationExitRuleKindType {
  GoalType = 'GOAL',
  StopType = 'STOP'
}

export enum AutomationExitRuleScopeType {
  AnyType = 'ANY',
  ContextType = 'CONTEXT'
}

export type AutomationGraphType = {
  __typename?: 'AutomationGraph';
  edges: Array<AutomationEdgeType>;
  nodes: Array<AutomationNodeType>;
};

export type AutomationGraphInputType = {
  edges: Array<AutomationEdgeInputType>;
  nodes: Array<AutomationNodeInputType>;
};

/** Ошибка графа: nodeId пуст у ошибок графа целиком */
export type AutomationGraphIssueType = {
  __typename?: 'AutomationGraphIssue';
  code: AutomationGraphIssueCodeType;
  /** Правило выхода (EXIT_RULE_INVALID) */
  exitRuleId?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
};

/** Коды ошибок графа (GRAPH_ISSUE_CODES): новый код без текста ломает типы кабинета */
export enum AutomationGraphIssueCodeType {
  AudienceInvalidType = 'AUDIENCE_INVALID',
  AudienceRequiredType = 'AUDIENCE_REQUIRED',
  ConditionEmailNodeInvalidType = 'CONDITION_EMAIL_NODE_INVALID',
  ConditionEmailNoWaitType = 'CONDITION_EMAIL_NO_WAIT',
  ConditionFilterInvalidType = 'CONDITION_FILTER_INVALID',
  ConditionFilterRequiredType = 'CONDITION_FILTER_REQUIRED',
  ContactListsNotAllowedType = 'CONTACT_LISTS_NOT_ALLOWED',
  EdgeInvalidType = 'EDGE_INVALID',
  EmailNotFoundType = 'EMAIL_NOT_FOUND',
  EmailRequiredType = 'EMAIL_REQUIRED',
  ExitRuleInvalidType = 'EXIT_RULE_INVALID',
  GraphCycleType = 'GRAPH_CYCLE',
  KindNotSupportedType = 'KIND_NOT_SUPPORTED',
  NodeNoOutputType = 'NODE_NO_OUTPUT',
  NodeTypeNotSupportedType = 'NODE_TYPE_NOT_SUPPORTED',
  NodeUnreachableType = 'NODE_UNREACHABLE',
  NoEmailNodeType = 'NO_EMAIL_NODE',
  OutputDuplicateType = 'OUTPUT_DUPLICATE',
  TooManyEmailsType = 'TOO_MANY_EMAILS',
  TriggerDuplicateType = 'TRIGGER_DUPLICATE',
  TriggerFilterRequiredType = 'TRIGGER_FILTER_REQUIRED',
  TriggerHasInputType = 'TRIGGER_HAS_INPUT',
  TriggerMissingType = 'TRIGGER_MISSING',
  TriggerParamsInvalidType = 'TRIGGER_PARAMS_INVALID',
  TriggerTypeInvalidType = 'TRIGGER_TYPE_INVALID',
  WaitDurationInvalidType = 'WAIT_DURATION_INVALID'
}

export type AutomationGraphLimitsType = {
  __typename?: 'AutomationGraphLimits';
  cooldownDaysMax: Scalars['Int']['output'];
  daysBeforeMax: Scalars['Int']['output'];
  edges: Scalars['Int']['output'];
  exitRuleNameLength: Scalars['Int']['output'];
  exitRules: Scalars['Int']['output'];
  maxEmailNodes: Scalars['Int']['output'];
  /** Длина названия после trim */
  nameLength: Scalars['Int']['output'];
  nodes: Scalars['Int']['output'];
  /** Предел координаты позиции узла по модулю */
  positionAbs: Scalars['Int']['output'];
  /** Видео в триггерах VIEW_* */
  triggerContents: Scalars['Int']['output'];
  /** Продуктов в триггере PRODUCT_PURCHASED, больше сохранение отклоняет */
  triggerProducts: Scalars['Int']['output'];
  /** Тегов в фильтре триггера поста */
  triggerTags: Scalars['Int']['output'];
};

/** Правила графа вида сценария: палитра редактора и ручки узлов */
export type AutomationGraphRulesType = {
  __typename?: 'AutomationGraphRules';
  audienceRequired: Scalars['Boolean']['output'];
  /** Поля аудитории только для узла CONDITION (нет в аудитории и правилах выхода) */
  conditionFields: Array<AudienceFieldType>;
  contactLists: Scalars['Boolean']['output'];
  /** События правил выхода, у которых допустим scope CONTEXT (есть продукт или контент) */
  contextScopeEvents: Array<AutomationExitRuleEventType>;
  exitRuleEvents: Array<AutomationExitRuleEventType>;
  exitRules: Scalars['Boolean']['output'];
  kind: AutomationKindType;
  limits: AutomationGraphLimitsType;
  nodeTypes: Array<AutomationNodeRuleType>;
  renewalReasons: Array<AutomationRenewalFailureReasonType>;
  /** Шаблоны этого вида, с которых можно начать */
  templates: Array<AutomationTemplateOptionType>;
  /** Те же события в том же порядке, с фильтром тегов */
  triggerRules: Array<AutomationTriggerRuleType>;
  triggers: Array<AutomationTriggerType>;
  waitUnits: Array<AutomationWaitUnitLimitType>;
};

export type AutomationInputType = {
  audience?: InputMaybe<AudienceFilterInputType>;
  contactListIds: Array<Scalars['ID']['input']>;
  /** Цепочки; не передано значит не менять */
  exitRules?: InputMaybe<Array<AutomationExitRuleInputType>>;
  /**
   * Версия, от которой начата правка (Automation.revision). Если передана и
   * отличается от сохранённой, updateAutomation ничего не пишет и отвечает
   * AUTOMATION_REVISION_CONFLICT. automationGraphIssues её не читает
   */
  expectedRevision?: InputMaybe<Scalars['Int']['input']>;
  graph: AutomationGraphInputType;
  name: Scalars['String']['input'];
  /** Цепочки: что делать со зрителями удалённых шагов (по умолчанию вывести) */
  nodeMoves?: InputMaybe<Array<AutomationNodeMoveInputType>>;
  reentry?: InputMaybe<AutomationReentryInputType>;
};

export enum AutomationKindType {
  BroadcastType = 'BROADCAST',
  JourneyType = 'JOURNEY',
  PlatformEventType = 'PLATFORM_EVENT'
}

/** Результат сохранения и запуска: пустой issues значит граф годен к запуску */
export type AutomationMutationResultType = {
  __typename?: 'AutomationMutationResult';
  automation: AutomationType;
  issues: Array<AutomationGraphIssueType>;
};

/** Узел графа: заполнен конфиг своего типа */
export type AutomationNodeType = {
  __typename?: 'AutomationNode';
  condition?: Maybe<AutomationConditionConfigType>;
  id: Scalars['String']['output'];
  position?: Maybe<AutomationNodePositionType>;
  sendEmail?: Maybe<AutomationSendEmailConfigType>;
  trigger?: Maybe<AutomationTriggerConfigType>;
  type: AutomationNodeTypeType;
  wait?: Maybe<AutomationWaitConfigType>;
};

export type AutomationNodeInputType = {
  condition?: InputMaybe<AutomationConditionConfigInputType>;
  id: Scalars['String']['input'];
  position?: InputMaybe<AutomationNodePositionInputType>;
  sendEmail?: InputMaybe<AutomationSendEmailConfigInputType>;
  trigger?: InputMaybe<AutomationTriggerConfigInputType>;
  type: AutomationNodeTypeType;
  wait?: InputMaybe<AutomationWaitConfigInputType>;
};

export enum AutomationNodeMoveActionType {
  ExitType = 'EXIT',
  MoveType = 'MOVE'
}

export type AutomationNodeMoveInputType = {
  action: AutomationNodeMoveActionType;
  nodeId: Scalars['String']['input'];
};

export type AutomationNodePositionType = {
  __typename?: 'AutomationNodePosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type AutomationNodePositionInputType = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Правило типа узла: выходы (null это выход без sourceHandle), может ли быть последним */
export type AutomationNodeRuleType = {
  __typename?: 'AutomationNodeRule';
  /** В узел может прийти связь (у события входа нет) */
  acceptsInput: Scalars['Boolean']['output'];
  canEnd: Scalars['Boolean']['output'];
  /** Сколько узлов этого типа допускает граф; null без своего предела (действует limits.nodes) */
  maxCount?: Maybe<Scalars['Int']['output']>;
  outputs: Array<Maybe<Scalars['String']['output']>>;
  /** Узел есть в каждом графе: его нельзя удалить и добавить второй раз */
  required: Scalars['Boolean']['output'];
  type: AutomationNodeTypeType;
};

/** Готовые счётчики узла (nodeStats) узлов текущего графа */
export type AutomationNodeStatsType = {
  __typename?: 'AutomationNodeStats';
  bounced: Scalars['Int']['output'];
  clicked: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  /** Сколько прохождений дошли до узла (воронка цепочки) */
  entered: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  nodeId: Scalars['String']['output'];
  opened: Scalars['Int']['output'];
  /** Первые покупки по касанию письма */
  purchases: Scalars['Int']['output'];
  renewalRevenueUSD: Scalars['Float']['output'];
  /** Продления подписок, пришедших по письму (засчитываются исходной покупке) */
  renewals: Scalars['Int']['output'];
  /** Первые покупки по касанию письма */
  revenueUSD: Scalars['Float']['output'];
  /** Выручка первых покупок плюс продления */
  revenueWithRenewalsUSD: Scalars['Float']['output'];
  sent: Scalars['Int']['output'];
  skipped: Array<AutomationSkipCountType>;
  unsubscribed: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

/** Типы узлов графа: TRIGGER, SEND_EMAIL, EXIT (фаза 3), WAIT и CONDITION (цепочки, фаза 4) */
export enum AutomationNodeTypeType {
  ConditionType = 'CONDITION',
  ExitType = 'EXIT',
  SendEmailType = 'SEND_EMAIL',
  TriggerType = 'TRIGGER',
  WaitType = 'WAIT'
}

export type AutomationReentryType = {
  __typename?: 'AutomationReentry';
  cooldownDays: Scalars['Int']['output'];
  mode: AutomationReentryModeType;
};

export type AutomationReentryInputType = {
  cooldownDays?: InputMaybe<Scalars['Int']['input']>;
  mode: AutomationReentryModeType;
};

export enum AutomationReentryModeType {
  EveryTimeType = 'EVERY_TIME',
  OnceType = 'ONCE'
}

export enum AutomationRenewalFailureReasonType {
  CardDeclinedType = 'CARD_DECLINED',
  CardExpiredType = 'CARD_EXPIRED',
  InsufficientFundsType = 'INSUFFICIENT_FUNDS',
  NoPaymentMethodType = 'NO_PAYMENT_METHOD',
  OtherType = 'OTHER'
}

/** Конфиг узла SEND_EMAIL */
export type AutomationSendEmailConfigType = {
  __typename?: 'AutomationSendEmailConfig';
  emailTemplate?: Maybe<EmailTemplateType>;
  emailTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type AutomationSendEmailConfigInputType = {
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutomationSkipCountType = {
  __typename?: 'AutomationSkipCount';
  count: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/** Готовые счётчики сценария; доли считает кабинет */
export type AutomationStatsType = {
  __typename?: 'AutomationStats';
  active: Scalars['Int']['output'];
  bounced: Scalars['Int']['output'];
  clicked: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  enrolled: Scalars['Int']['output'];
  /** События, не зачисленные из-за дневного лимита входа */
  entryLimited: Scalars['Int']['output'];
  exited: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  goalReached: Scalars['Int']['output'];
  opened: Scalars['Int']['output'];
  /** Первые покупки по касанию письма */
  purchases: Scalars['Int']['output'];
  renewalRevenueUSD: Scalars['Float']['output'];
  /** Продления подписок, пришедших по письму (засчитываются исходной покупке) */
  renewals: Scalars['Int']['output'];
  /** Первые покупки по касанию письма */
  revenueUSD: Scalars['Float']['output'];
  /** Выручка первых покупок плюс продления */
  revenueWithRenewalsUSD: Scalars['Float']['output'];
  sent: Scalars['Int']['output'];
  skipped: Array<AutomationSkipCountType>;
  stopped: Scalars['Int']['output'];
  unsubscribed: Scalars['Int']['output'];
  /** Уникальные зрители сценария (HyperLogLog по ссылкам с utm_campaign=mkt_<id>), фаза 2, Task 10. */
  viewers: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export enum AutomationStatusType {
  ActiveType = 'ACTIVE',
  ArchivedType = 'ARCHIVED',
  DraftType = 'DRAFT',
  PausedType = 'PAUSED'
}

/** Шаблон, с которого можно начать сценарий (createAutomation templateKey) */
export type AutomationTemplateOptionType = {
  __typename?: 'AutomationTemplateOption';
  key: Scalars['String']['output'];
  /** Событие автоматизации из шаблона; null у рассылки */
  trigger?: Maybe<AutomationTriggerType>;
};

/** Триггеры: SCHEDULED у рассылок, события платформы у автоматизаций, события зрителя у цепочек */
export enum AutomationTriggerType {
  CheckoutStartedType = 'CHECKOUT_STARTED',
  ContentPublishedType = 'CONTENT_PUBLISHED',
  PaymentSucceededType = 'PAYMENT_SUCCEEDED',
  PostPublishedType = 'POST_PUBLISHED',
  ProductPublishedType = 'PRODUCT_PUBLISHED',
  ProductPurchasedType = 'PRODUCT_PURCHASED',
  RenewalFailedType = 'RENEWAL_FAILED',
  ScheduledType = 'SCHEDULED',
  StreamAnnouncedType = 'STREAM_ANNOUNCED',
  SubscriptionCancelledType = 'SUBSCRIPTION_CANCELLED',
  SubscriptionEndingType = 'SUBSCRIPTION_ENDING',
  SubscriptionExpiredType = 'SUBSCRIPTION_EXPIRED',
  UserRegisteredType = 'USER_REGISTERED',
  ViewCompletedType = 'VIEW_COMPLETED',
  ViewStartedType = 'VIEW_STARTED'
}

/** Конфиг узла TRIGGER: событие и фильтр тегов поста */
export type AutomationTriggerConfigType = {
  __typename?: 'AutomationTriggerConfig';
  contentIds: Array<Scalars['ID']['output']>;
  daysBefore?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<AutomationTriggerType>;
  productIds: Array<Scalars['ID']['output']>;
  reasons: Array<AutomationRenewalFailureReasonType>;
  tagIds: Array<Scalars['ID']['output']>;
};

export type AutomationTriggerConfigInputType = {
  contentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  daysBefore?: InputMaybe<Scalars['Int']['input']>;
  event?: InputMaybe<AutomationTriggerType>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reasons?: InputMaybe<Array<AutomationRenewalFailureReasonType>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Параметры узла TRIGGER, которые хранит событие (triggerParamKeys) */
export enum AutomationTriggerParamType {
  ContentIdsType = 'CONTENT_IDS',
  DaysBeforeType = 'DAYS_BEFORE',
  ProductIdsType = 'PRODUCT_IDS',
  ReasonsType = 'REASONS',
  TagIdsType = 'TAG_IDS'
}

/** Правило события: нужен ли узлу TRIGGER фильтр тегов */
export type AutomationTriggerRuleType = {
  __typename?: 'AutomationTriggerRule';
  /** Задержка события перед входом в цепочку, минуты; null без задержки */
  delayMinutes?: Maybe<Scalars['Int']['output']>;
  event: AutomationTriggerType;
  /** Параметры триггера этого события (Task 15) */
  params: Array<AutomationTriggerParamType>;
  supportsTagFilter: Scalars['Boolean']['output'];
};

/** Конфиг узла WAIT */
export type AutomationWaitConfigType = {
  __typename?: 'AutomationWaitConfig';
  unit: AutomationWaitUnitType;
  value: Scalars['Int']['output'];
};

export type AutomationWaitConfigInputType = {
  unit: AutomationWaitUnitType;
  value: Scalars['Int']['input'];
};

export enum AutomationWaitUnitType {
  DaysType = 'DAYS',
  HoursType = 'HOURS'
}

export type AutomationWaitUnitLimitType = {
  __typename?: 'AutomationWaitUnitLimit';
  max: Scalars['Int']['output'];
  unit: AutomationWaitUnitType;
};

/**  для аватарок и квадратных картинок */
export type AvatarType = {
  __typename?: 'Avatar';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для аватарок и квадратных картинок */
export type AvatarUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для аватарок и квадратных картинок */
export type AvatarWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type AvatarConnectionType = {
  __typename?: 'AvatarConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AvatarType>;
};

export type AvatarsFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BankDetailsType = {
  __typename?: 'BankDetails';
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankBik?: Maybe<Scalars['String']['output']>;
  bankCorrAccount?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
};

/**  для баннеров и широких картинок */
export type BannerType = {
  __typename?: 'Banner';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для баннеров и широких картинок */
export type BannerUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для баннеров и широких картинок */
export type BannerWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type BannerConnectionType = {
  __typename?: 'BannerConnection';
  count: Scalars['Int']['output'];
  nodes: Array<BannerType>;
};

export type BannersFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BroadcastInputType = {
  audience?: InputMaybe<AudienceFilterInputType>;
  contactListIds: Array<Scalars['ID']['input']>;
  emailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Состояние рассылки для кабинета, выводится из статуса и хода отправки */
export enum BroadcastStateType {
  ArchivedType = 'ARCHIVED',
  DraftType = 'DRAFT',
  ScheduledType = 'SCHEDULED',
  SendingType = 'SENDING',
  SentType = 'SENT'
}

/**
 * Библиотека Stream, видимая по аккаунтному ключу bunny.net. Нужна форме
 * выбора в кабинете до подключения: партнёр решает, создать новую библиотеку
 * или взять существующую. Ключей библиотеки здесь нет намеренно, хотя живой
 * ответ Bunny их несёт.
 */
export type BunnyAccountLibraryType = {
  __typename?: 'BunnyAccountLibrary';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Коды регионов репликации Bunny (UK, SE, NY, LA, SG, SYD, BR, JH). */
  replicationRegions: Array<Scalars['String']['output']>;
  videoCount: Scalars['Int']['output'];
};

export enum CalendarIntervalType {
  DayType = 'DAY',
  HourType = 'HOUR',
  MonthType = 'MONTH',
  WeekType = 'WEEK',
  YearType = 'YEAR'
}

export type CancelEventInputType = {
  confirmTitle: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

export type ChatBanType = {
  __typename?: 'ChatBan';
  createdAt: Scalars['DateTime']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: ChatBanTypeType;
  user?: Maybe<UserType>;
  userId: Scalars['ID']['output'];
};

export type ChatBanConnectionType = {
  __typename?: 'ChatBanConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ChatBanType>;
};

export enum ChatBanTypeType {
  PermanentType = 'PERMANENT',
  TemporaryType = 'TEMPORARY'
}

export type ChatMessageType = {
  __typename?: 'ChatMessage';
  content?: Maybe<ContentType>;
  contentId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messageType: ChatMessageTypeType;
  user?: Maybe<UserType>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ChatMessageConnectionType = {
  __typename?: 'ChatMessageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ChatMessageType>;
};

export enum ChatMessageTypeType {
  SystemType = 'SYSTEM',
  UserType = 'USER'
}

export type ChatMessagesFilterInputType = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientType = {
  __typename?: 'Client';
  addresses?: Maybe<Array<OrganizationAddressType>>;
  bankDetails: BankDetailsType;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organizationDetails: OrganizationDetailsType;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CollectionContentSortType {
  LatestType = 'LATEST',
  ManualType = 'MANUAL',
  OldestType = 'OLDEST',
  UpdatedType = 'UPDATED'
}

export enum CollectionDisplayModeType {
  HorizontalType = 'HORIZONTAL',
  VerticalType = 'VERTICAL'
}

export type CollectionTypeType = {
  __typename?: 'CollectionType';
  collectionDisplayMode?: Maybe<CollectionDisplayModeType>;
  id: Scalars['ID']['output'];
  showInSearch: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type ComplianceRecordType = {
  __typename?: 'ComplianceRecord';
  /** Заполнено ровно одно из двух: contentId или productId */
  contentId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Имя загруженного файла (kind: FILE) */
  fileName?: Maybe<Scalars['String']['output']>;
  /**
   * Подписанная ссылка на файл записи, действует 15 минут. Генерируется
   * только после проверки прав кабинета; ключ объекта в приватном бакете
   * наружу не отдаётся. null для kind: LINK.
   */
  fileUrl?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  kind: ComplianceRecordKindType;
  note?: Maybe<Scalars['String']['output']>;
  /** Имя исполнителя. Персональные данные: в логи не пишется */
  performerName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Внешний адрес записи (kind: LINK) */
  url?: Maybe<Scalars['URL']['output']>;
};

export enum ComplianceRecordKindType {
  FileType = 'FILE',
  LinkType = 'LINK'
}

export type ConnectBunnyByAccountInputType = {
  /** Аккаунтный ключ bunny.net (Account > API), не ключ библиотеки. */
  accountApiKey: Scalars['String']['input'];
  /**
   * Существующая библиотека аккаунта. Пусто значит «создать новую под эту
   * платформу», с именем платформы.
   */
  libraryId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Регионы репликации для создаваемой библиотеки. У существующей библиотеки
   * реплики не меняются. Каждая реплика умножает стоимость хранения.
   */
  replicationRegions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConnectCcBillInputType = {
  accnum: Scalars['String']['input'];
  flexFormId: Scalars['String']['input'];
  salt: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  subaccount: Scalars['String']['input'];
  supportUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectDomainInputType = {
  host: Scalars['String']['input'];
};

export type ConnectPayPalInputType = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectPaynetInputType = {
  merchantCode: Scalars['String']['input'];
  password: Scalars['String']['input'];
  saleArea?: InputMaybe<Scalars['String']['input']>;
  secretKey: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type ConnectStripeInputType = {
  publishableKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export type ContactImportResultType = {
  __typename?: 'ContactImportResult';
  added: Scalars['Int']['output'];
  duplicates: Scalars['Int']['output'];
  invalid: Scalars['Int']['output'];
  matchedViewers: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type ContactListType = {
  __typename?: 'ContactList';
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactListConnectionType = {
  __typename?: 'ContactListConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContactListType>;
};

export type ContactRowInputType = {
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ContentType = {
  __typename?: 'Content';
  accessStartAt?: Maybe<Scalars['DateTime']['output']>;
  ageRestrictions: Scalars['Int']['output'];
  childrenContentsCount: Scalars['Int']['output'];
  collectionContentSort: CollectionContentSortType;
  collectionIds: Array<Scalars['ID']['output']>;
  collectionType?: Maybe<CollectionTypeType>;
  collectionTypeId?: Maybe<Scalars['ID']['output']>;
  countryAccess?: Maybe<CountryAccessType>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  embedUrl?: Maybe<Scalars['URL']['output']>;
  hideChildrenContentFromLists: Scalars['Boolean']['output'];
  hideInGeneralLists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  liveState?: Maybe<ContentLiveStateType>;
  nestedSortValue?: Maybe<Scalars['Int']['output']>;
  onlyUsers: Scalars['Boolean']['output'];
  path?: Maybe<Scalars['String']['output']>;
  pendingVideo?: Maybe<VideoType>;
  playback?: Maybe<ContentPlaybackType>;
  premium: Scalars['Boolean']['output'];
  preview?: Maybe<ImageType>;
  processingStatus: ContentProcessingStatusType;
  productIds: Array<Scalars['ID']['output']>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  stream?: Maybe<StreamType>;
  tags: Array<TagType>;
  title: Scalars['String']['output'];
  totalViews: Scalars['Int']['output'];
  transcodingError?: Maybe<Scalars['String']['output']>;
  type: ContentTypeType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['URL']['output']>;
  verticalPreview?: Maybe<ImageType>;
  video?: Maybe<VideoType>;
  videoDownload?: Maybe<VideoDownloadType>;
  viewersOnline: Scalars['Int']['output'];
  widget?: Maybe<WidgetType>;
};


export type ContentChildrenContentsCountArgsType = {
  type?: InputMaybe<ContentTypeType>;
};


export type ContentNestedSortValueArgsType = {
  collectionId: Scalars['ID']['input'];
};

export type ContentConnectionType = {
  __typename?: 'ContentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContentType>;
};

export enum ContentLiveStateType {
  LiveType = 'LIVE',
  SignalType = 'SIGNAL'
}

export type ContentPlaybackType = {
  __typename?: 'ContentPlayback';
  dashUrl?: Maybe<Scalars['URL']['output']>;
  hlsUrl: Scalars['URL']['output'];
  iframeUrl?: Maybe<Scalars['URL']['output']>;
  thumbnailUrl: Scalars['URL']['output'];
  token: Scalars['String']['output'];
};

export type ContentPollType = {
  __typename?: 'ContentPoll';
  autoCloseSeconds?: Maybe<Scalars['Int']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  contentId: Scalars['ID']['output'];
  /** Сколько ответивших выбрали ровно правильные варианты */
  correctVotersCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Id прикрепления */
  id: Scalars['ID']['output'];
  isMultiple: Scalars['Boolean']['output'];
  /** Секунда от фактического старта эфира или от начала видео (AT_OFFSET) */
  offsetSeconds?: Maybe<Scalars['Int']['output']>;
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  options: Array<ContentPollOptionType>;
  /** Опрос библиотеки */
  pollId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  resultsMode: PollResultsModeType;
  /** Время запуска по часам (AT_TIME) */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Статус есть только у прикреплений эфира, у видео null */
  status?: Maybe<PollStatusType>;
  trigger: PollTriggerType;
  votersCount: Scalars['Int']['output'];
};

export type ContentPollOptionType = {
  __typename?: 'ContentPollOption';
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  votes: Scalars['Int']['output'];
};

export type ContentPollScheduleInputType = {
  autoCloseSeconds?: InputMaybe<Scalars['Int']['input']>;
  offsetSeconds?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  trigger: PollTriggerType;
};

export enum ContentProcessingStatusType {
  CompleteType = 'COMPLETE',
  ErrorType = 'ERROR',
  NofileType = 'NOFILE',
  ProcessingType = 'PROCESSING'
}

export enum ContentPublicationStatusType {
  NotPublishedType = 'NOT_PUBLISHED',
  PublishedType = 'PUBLISHED'
}

export type ContentTimecodesType = {
  __typename?: 'ContentTimecodes';
  id: Scalars['ID']['output'];
  timecodes: Array<TimecodeType>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ContentTypeType {
  CollectionType = 'COLLECTION',
  StreamType = 'STREAM',
  VideoType = 'VIDEO'
}

export type ContentsFilterInputType = {
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentPublicationStatusType>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<ContentTypeType>;
};

export enum ContentsSortTypeType {
  CreatedAtAscType = 'CREATED_AT_ASC',
  CreatedAtDescType = 'CREATED_AT_DESC',
  ManualType = 'MANUAL',
  PublishAtAscType = 'PUBLISH_AT_ASC',
  PublishAtDescType = 'PUBLISH_AT_DESC'
}

export type ContractPaymentType = {
  __typename?: 'ContractPayment';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  createdAt: Scalars['DateTime']['output'];
  expired: Scalars['Boolean']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<ContractPaymentInvoiceType>;
  invoiceAmount?: Maybe<AmountType>;
  invoiceDate: Scalars['DateTime']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  lines: Array<ContractPaymentLineType>;
  organizationId: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  periodFrom: Scalars['DateTime']['output'];
  periodTo: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type ContractPaymentConnectionType = {
  __typename?: 'ContractPaymentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContractPaymentType>;
};

export type ContractPaymentInvoiceType = {
  __typename?: 'ContractPaymentInvoice';
  issuedAt: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
};

export type ContractPaymentLineType = {
  __typename?: 'ContractPaymentLine';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  itemType: Scalars['String']['output'];
  report?: Maybe<RevenueShareReportType>;
  title: Scalars['String']['output'];
};

export type ContractPaymentsFilterInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationTopicType {
  AccessType = 'ACCESS',
  AccountType = 'ACCOUNT',
  OtherType = 'OTHER',
  PaymentType = 'PAYMENT',
  PlaybackType = 'PLAYBACK',
  PurchaseType = 'PURCHASE',
  RefundType = 'REFUND'
}

export type CountryAccessType = {
  __typename?: 'CountryAccess';
  contentsCount: Scalars['Int']['output'];
  countries: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: CountryAccessTypeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CountryAccessConnectionType = {
  __typename?: 'CountryAccessConnection';
  count: Scalars['Int']['output'];
  nodes: Array<CountryAccessType>;
};

export enum CountryAccessTypeType {
  AllType = 'ALL',
  ExcludeType = 'EXCLUDE',
  IncludeType = 'INCLUDE'
}

export type CreateAutomationInputType = {
  kind: AutomationKindType;
  name: Scalars['String']['input'];
  templateKey?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<AutomationTriggerType>;
};

export type CreateBroadcastInputType = {
  name: Scalars['String']['input'];
  templateKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChatBanInputType = {
  type: ChatBanTypeType;
  userId: Scalars['ID']['input'];
};

export type CreateComplianceRecordInputType = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Обязателен при kind: FILE */
  file?: InputMaybe<Scalars['Upload']['input']>;
  kind: ComplianceRecordKindType;
  note?: InputMaybe<Scalars['String']['input']>;
  performerName?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Обязателен при kind: LINK */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContentFromUrlInputType = {
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['URL']['input'];
};

export type CreateContentInputType = {
  accessStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestrictions?: InputMaybe<Scalars['Int']['input']>;
  collectionContentSort?: InputMaybe<CollectionContentSortType>;
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectionTypeId?: InputMaybe<Scalars['ID']['input']>;
  countryAccessId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideChildrenContentFromLists?: InputMaybe<Scalars['Boolean']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  type?: InputMaybe<ContentTypeType>;
  verticalPreviewId?: InputMaybe<Scalars['ID']['input']>;
  videoFileName?: InputMaybe<Scalars['String']['input']>;
  videoUid?: InputMaybe<Scalars['String']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCountryAccessInputType = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  type: CountryAccessTypeType;
};

export type CreateLinkInputType = {
  href?: InputMaybe<Scalars['String']['input']>;
  linkType: LinkTypeType;
  reward?: InputMaybe<LinkRewardInputType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-ссылки, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  title: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMultiplePromocodesInputType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  count: Scalars['Int']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  finishAt?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  promocodeCampaignId?: InputMaybe<Scalars['ID']['input']>;
  promocodeCampaignTitle?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  trialPeriod?: InputMaybe<Scalars['Int']['input']>;
  type: PromocodeTypeType;
};

export type CreatePlatformCustomCoverInputType = {
  align?: InputMaybe<Scalars['String']['input']>;
  alignMobile?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<PlatformCustomCoverBackgroundInputType>;
  brightness?: InputMaybe<Scalars['Float']['input']>;
  buttons?: InputMaybe<Array<PlatformCustomCoverButtonInputType>>;
  buttonsColor?: InputMaybe<Scalars['String']['input']>;
  buttonsSize?: InputMaybe<Scalars['String']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  subTitle?: InputMaybe<PlatformCustomCoverSubTitleInputType>;
  title?: InputMaybe<PlatformCustomCoverTitleInputType>;
  verticalAlign?: InputMaybe<Scalars['String']['input']>;
  verticalAlignMobile?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlatformMenuItemInputType = {
  href?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<PlatformMenuItemDialogItemInputType>>;
  label: Scalars['String']['input'];
  linkType?: InputMaybe<PlatformMenuItemLinkTypeType>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-пункта, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  type?: InputMaybe<PlatformMenuItemTypeType>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type CreatePlatformPageInputType = {
  blocks?: InputMaybe<Array<PlatformPageBlockInputType>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  path: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type CreatePollInputType = {
  isMultiple: Scalars['Boolean']['input'];
  options: Array<PollOptionInputType>;
  question: Scalars['String']['input'];
  resultsMode: PollResultsModeType;
};

export type CreatePostInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateProductInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventFinishAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishAt: Scalars['DateTime']['input'];
  finishSalesAt?: InputMaybe<Scalars['DateTime']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  perContentPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  prices?: InputMaybe<Array<ProductPriceInputType>>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  showContent?: InputMaybe<Scalars['Boolean']['input']>;
  startAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: ProductTypeType;
};

export type CreatePromocodeInputType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  code: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  finishAt?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  promocodeCampaignId?: InputMaybe<Scalars['ID']['input']>;
  promocodeCampaignTitle?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  trialPeriod?: InputMaybe<Scalars['Int']['input']>;
  type: PromocodeTypeType;
};

export type CreateRefundInputType = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type CreateReportInputType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  type: ReportTypeType;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  widget?: InputMaybe<AnalyticsWidgetType>;
};

export type CreateRestreamDestinationInputType = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  streamKey: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateStreamClipInputType = {
  contentId: Scalars['ID']['input'];
  durationSeconds: Scalars['Int']['input'];
  startSeconds: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStreamEntrypointInputType = {
  title: Scalars['String']['input'];
};

export type CreateStreamInputType = {
  accessStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestrictions?: InputMaybe<Scalars['Int']['input']>;
  autoPublishRecord?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dvrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enableRecord?: InputMaybe<Scalars['Boolean']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  verticalPreviewId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTagInputType = {
  customFieldValues?: InputMaybe<Array<CustomFieldValueInputType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  platformPageId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['ID']['input']>;
  verticalImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVideoFileUploadInputType = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type CreateWidgetInputType = {
  buttonColor: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  buttonTextColor: Scalars['String']['input'];
  buttonUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum CurrencyType {
  RubType = 'RUB',
  UsdType = 'USD'
}

export type CustomFieldType = {
  __typename?: 'CustomField';
  helperText?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<SelectOptionType>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: CustomFieldTypeType;
};

export type CustomFieldInputType = {
  helperText?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<SelectOptionInputType>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: CustomFieldTypeType;
};

export enum CustomFieldTypeType {
  BooleanType = 'BOOLEAN',
  CountryType = 'COUNTRY',
  DateType = 'DATE',
  NumberType = 'NUMBER',
  SelectType = 'SELECT',
  TextType = 'TEXT'
}

export type CustomFieldValueType = {
  __typename?: 'CustomFieldValue';
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<CustomFieldTypeType>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldValueInputType = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Детальная информация об адресе от DaData */
export type DaDataAddressType = {
  __typename?: 'DaDataAddress';
  /** Район в регионе */
  area?: Maybe<Scalars['String']['output']>;
  /** Тип района (сокращенный) */
  area_type?: Maybe<Scalars['String']['output']>;
  /** Тип района (полный) */
  area_type_full?: Maybe<Scalars['String']['output']>;
  /** Район с типом */
  area_with_type?: Maybe<Scalars['String']['output']>;
  /** Корпус/строение */
  block?: Maybe<Scalars['String']['output']>;
  /** Тип корпуса (сокращенный) */
  block_type?: Maybe<Scalars['String']['output']>;
  /** Тип корпуса (полный) */
  block_type_full?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  /** Тип города (сокращенный) */
  city_type?: Maybe<Scalars['String']['output']>;
  /** Тип города (полный) */
  city_type_full?: Maybe<Scalars['String']['output']>;
  /** Город с типом */
  city_with_type?: Maybe<Scalars['String']['output']>;
  /** Страна */
  country: Scalars['String']['output'];
  /** ISO код страны (двухсимвольный) */
  country_iso_code: Scalars['String']['output'];
  /** Федеральный округ */
  federal_district?: Maybe<Scalars['String']['output']>;
  /** ФИАС ID адреса */
  fias_id: Scalars['String']['output'];
  /** Уровень детализации в ФИАС (от 0 до 9) */
  fias_level: Scalars['String']['output'];
  /** Квартира */
  flat?: Maybe<Scalars['String']['output']>;
  /** Тип квартиры (сокращенный) */
  flat_type?: Maybe<Scalars['String']['output']>;
  /** Тип квартиры (полный) */
  flat_type_full?: Maybe<Scalars['String']['output']>;
  /** Широта (географические координаты) */
  geo_lat?: Maybe<Scalars['String']['output']>;
  /** Долгота (географические координаты) */
  geo_lon?: Maybe<Scalars['String']['output']>;
  /** Номер дома */
  house?: Maybe<Scalars['String']['output']>;
  /** Тип дома (сокращенный) */
  house_type?: Maybe<Scalars['String']['output']>;
  /** Тип дома (полный) */
  house_type_full?: Maybe<Scalars['String']['output']>;
  /** КЛАДР ID адреса */
  kladr_id: Scalars['String']['output'];
  /** Почтовый индекс */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Код точности координат (0-5) */
  qc_geo?: Maybe<Scalars['Int']['output']>;
  /** Регион */
  region: Scalars['String']['output'];
  /** Тип региона (сокращенный) */
  region_type: Scalars['String']['output'];
  /** Тип региона (полный) */
  region_type_full: Scalars['String']['output'];
  /** Регион с типом */
  region_with_type: Scalars['String']['output'];
  /** Населенный пункт */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Тип населенного пункта (сокращенный) */
  settlement_type?: Maybe<Scalars['String']['output']>;
  /** Тип населенного пункта (полный) */
  settlement_type_full?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт с типом */
  settlement_with_type?: Maybe<Scalars['String']['output']>;
  /** Улица */
  street?: Maybe<Scalars['String']['output']>;
  /** Тип улицы (сокращенный) */
  street_type?: Maybe<Scalars['String']['output']>;
  /** Тип улицы (полный) */
  street_type_full?: Maybe<Scalars['String']['output']>;
  /** Улица с типом */
  street_with_type?: Maybe<Scalars['String']['output']>;
};

/** Ответ с подсказками по адресам */
export type DaDataAddressResponseType = {
  __typename?: 'DaDataAddressResponse';
  /** Список найденных адресов */
  suggestions: Array<DaDataAddressSuggestionType>;
};

/** Подсказка по адресу */
export type DaDataAddressSuggestionType = {
  __typename?: 'DaDataAddressSuggestion';
  /** Детальная информация об адресе */
  data: DaDataAddressType;
  /** Полный адрес с индексом */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес в кратком формате (для отображения в списке) */
  value: Scalars['String']['output'];
};

/** Детальная информация о банке от DaData */
export type DaDataBankType = {
  __typename?: 'DaDataBank';
  /** Адрес банка */
  address: DaDataBankAddressType;
  /** БИК банка */
  bic: Scalars['String']['output'];
  /** Корреспондентский счет */
  correspondent_account: Scalars['String']['output'];
  /** ИНН банка */
  inn: Scalars['String']['output'];
  /** КПП банка */
  kpp: Scalars['String']['output'];
  /** Наименования банка */
  name: DaDataBankNameType;
  /** SWIFT код банка */
  swift?: Maybe<Scalars['String']['output']>;
};

/** Адрес банка */
export type DaDataBankAddressType = {
  __typename?: 'DaDataBankAddress';
  /** Адрес (полный) */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес (краткий) */
  value: Scalars['String']['output'];
};

/** Наименования банка */
export type DaDataBankNameType = {
  __typename?: 'DaDataBankName';
  /** Полное наименование */
  full: Scalars['String']['output'];
  /** Платежное наименование */
  payment: Scalars['String']['output'];
  /** Краткое наименование */
  short: Scalars['String']['output'];
};

/** Ответ с подсказками по банкам */
export type DaDataBankResponseType = {
  __typename?: 'DaDataBankResponse';
  /** Список найденных банков */
  suggestions: Array<DaDataBankSuggestionType>;
};

/** Подсказка по банку */
export type DaDataBankSuggestionType = {
  __typename?: 'DaDataBankSuggestion';
  /** Детальная информация о банке */
  data: DaDataBankType;
  /** Полное название банка */
  unrestricted_value: Scalars['String']['output'];
  /** Название банка (краткое) */
  value: Scalars['String']['output'];
};

/** Ограничения по местоположению для поиска */
export type DaDataLocationInputType = {
  /** Название района */
  area?: InputMaybe<Scalars['String']['input']>;
  /** Название города */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Код страны */
  country?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС ID региона/города */
  fias_id?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР ID региона/города */
  kladr_id?: InputMaybe<Scalars['String']['input']>;
  /** Название региона */
  region?: InputMaybe<Scalars['String']['input']>;
};

/** Детальная информация об организации от DaData */
export type DaDataOrganizationType = {
  __typename?: 'DaDataOrganization';
  /** Адрес организации */
  address: DaDataOrganizationAddressType;
  /** ИНН организации */
  inn: Scalars['String']['output'];
  /** КПП организации */
  kpp: Scalars['String']['output'];
  /** Руководство организации */
  management?: Maybe<DaDataOrganizationManagementType>;
  /** Наименования организации */
  name: DaDataOrganizationNameType;
  /** ОГРН организации */
  ogrn: Scalars['String']['output'];
  /** Состояние организации */
  state: DaDataOrganizationStateType;
};

/** Адрес организации */
export type DaDataOrganizationAddressType = {
  __typename?: 'DaDataOrganizationAddress';
  /** Адрес (полный) */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес (краткий) */
  value: Scalars['String']['output'];
};

/** Руководство организации */
export type DaDataOrganizationManagementType = {
  __typename?: 'DaDataOrganizationManagement';
  /** ФИО руководителя */
  name: Scalars['String']['output'];
  /** Должность руководителя */
  post: Scalars['String']['output'];
};

/** Наименования организации */
export type DaDataOrganizationNameType = {
  __typename?: 'DaDataOrganizationName';
  /** Полное наименование без ОПФ */
  full: Scalars['String']['output'];
  /** Полное наименование с ОПФ */
  full_with_opf: Scalars['String']['output'];
  /** Наименование на латинице */
  latin?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование без ОПФ */
  short: Scalars['String']['output'];
  /** Краткое наименование с ОПФ */
  short_with_opf: Scalars['String']['output'];
};

/** Ответ с подсказками по организациям */
export type DaDataOrganizationResponseType = {
  __typename?: 'DaDataOrganizationResponse';
  /** Список найденных организаций */
  suggestions: Array<DaDataOrganizationSuggestionType>;
};

/** Состояние организации */
export type DaDataOrganizationStateType = {
  __typename?: 'DaDataOrganizationState';
  /** Дата ликвидации (timestamp) */
  liquidation_date?: Maybe<Scalars['Float']['output']>;
  /** Дата регистрации (timestamp) */
  registration_date?: Maybe<Scalars['Float']['output']>;
  /** Статус организации (ACTIVE, LIQUIDATING, LIQUIDATED) */
  status: Scalars['String']['output'];
};

/** Подсказка по организации */
export type DaDataOrganizationSuggestionType = {
  __typename?: 'DaDataOrganizationSuggestion';
  /** Детальная информация об организации */
  data: DaDataOrganizationType;
  /** Полное название организации */
  unrestricted_value: Scalars['String']['output'];
  /** Название организации (краткое) */
  value: Scalars['String']['output'];
};

export type DashboardType = {
  __typename?: 'Dashboard';
  finishedStreamDuration: Scalars['Float']['output'];
  finishedStreamsCount: Scalars['Int']['output'];
  metrics: DashboardMetricsType;
  storageTotalSize: Scalars['Float']['output'];
  videosCount: Scalars['Int']['output'];
  videosDuration: Scalars['Float']['output'];
};


export type DashboardMetricsArgsType = {
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};

export type DashboardMetricsType = {
  __typename?: 'DashboardMetrics';
  purchases: Scalars['Int']['output'];
  purchasesTrend: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  revenueCurrency: PaymentCurrencyType;
  revenueTrend: Scalars['Float']['output'];
  users: Scalars['Int']['output'];
  usersTrend: Scalars['Float']['output'];
  views: Scalars['Int']['output'];
  viewsTrend: Scalars['Float']['output'];
  visitors: Scalars['Int']['output'];
  visitorsTrend: Scalars['Float']['output'];
};

export type DisputeType = {
  __typename?: 'Dispute';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feeAmount?: Maybe<AmountType>;
  id: Scalars['ID']['output'];
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  payment?: Maybe<PaymentType>;
  providerFeeAmount?: Maybe<AmountType>;
  status: DisputeStatusType;
};

export type DisputeConnectionType = {
  __typename?: 'DisputeConnection';
  count: Scalars['Int']['output'];
  nodes: Array<DisputeType>;
};

export enum DisputeStatusType {
  ClosedType = 'CLOSED',
  LostType = 'LOST',
  NeedsResponseType = 'NEEDS_RESPONSE',
  WonType = 'WON'
}

export type DisputesFilterInputType = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providers?: InputMaybe<Array<PaymentProviderType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatusType>;
};

export enum DocumentTypeType {
  OttType = 'OTT'
}

export enum DocumentVersionType {
  ArchiveType = 'ARCHIVE',
  LatestType = 'LATEST'
}

/**
 * DNS-запись для ручной установки: партнёр прописывает её у своего
 * регистратора, когда его зоны у нас нет.
 */
export type DomainDnsRecordType = {
  __typename?: 'DomainDnsRecord';
  name: Scalars['String']['output'];
  /** CNAME или ALIAS (на apex CNAME запрещён стандартом). */
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Кем инстанс подключает домен витрины: Cloudflare клиента плюс Firebase App
 * Hosting или pull zone Bunny. Карточка домена по этому значению показывает
 * свои шаги и свои подсказки.
 */
export enum DomainProviderType {
  BunnyType = 'BUNNY',
  CloudflareType = 'CLOUDFLARE'
}

export type EmailBlockType = {
  __typename?: 'EmailBlock';
  alt?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  source?: Maybe<EmailDynamicSourceType>;
  text?: Maybe<Scalars['String']['output']>;
  type: EmailBlockTypeType;
  url?: Maybe<Scalars['String']['output']>;
};

export type EmailBlockInputType = {
  alt?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<EmailDynamicSourceType>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: EmailBlockTypeType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailBlockTypeType {
  ButtonType = 'BUTTON',
  ContentCardType = 'CONTENT_CARD',
  DividerType = 'DIVIDER',
  DynamicCardType = 'DYNAMIC_CARD',
  HeadingType = 'HEADING',
  ImageType = 'IMAGE',
  ProductCardType = 'PRODUCT_CARD',
  TextType = 'TEXT'
}

export enum EmailDynamicSourceType {
  AbandonedCheckoutType = 'ABANDONED_CHECKOUT',
  ContinueWatchingType = 'CONTINUE_WATCHING',
  EventObjectType = 'EVENT_OBJECT',
  NextStreamType = 'NEXT_STREAM',
  PurchasedType = 'PURCHASED',
  TopProductType = 'TOP_PRODUCT'
}

/** Отрендеренное письмо: тема и HTML с примерными данными */
export type EmailPreviewType = {
  __typename?: 'EmailPreview';
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailTemplateType = {
  __typename?: 'EmailTemplate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<EmailTemplateVariantType>;
};

export type EmailTemplateConnectionType = {
  __typename?: 'EmailTemplateConnection';
  count: Scalars['Int']['output'];
  nodes: Array<EmailTemplateType>;
};

export type EmailTemplateInputType = {
  name: Scalars['String']['input'];
  variants: Array<EmailTemplateVariantInputType>;
};

export type EmailTemplateVariantType = {
  __typename?: 'EmailTemplateVariant';
  blocks: Array<EmailBlockType>;
  language: MarketingLanguageType;
  preheader: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailTemplateVariantInputType = {
  blocks: Array<EmailBlockInputType>;
  language: MarketingLanguageType;
  preheader?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type EventCancelItemType = {
  __typename?: 'EventCancelItem';
  amount?: Maybe<AmountType>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  pendingRefundId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<PaymentProviderType>;
  providerPaymentId?: Maybe<Scalars['String']['output']>;
  purchaseId: Scalars['ID']['output'];
};

export type EventCancelPreviewType = {
  __typename?: 'EventCancelPreview';
  amount?: Maybe<AmountType>;
  byProvider: Array<EventCancelProviderTotalType>;
  free: Scalars['Int']['output'];
  liveStreams: Scalars['Int']['output'];
  manualItems: Array<EventCancelItemType>;
  pendingStreams: Scalars['Int']['output'];
  productTitle: Scalars['String']['output'];
  purchases: Scalars['Int']['output'];
  sharedStreams: Scalars['Int']['output'];
  unknownPayments: Scalars['Int']['output'];
};

export type EventCancelProgressType = {
  __typename?: 'EventCancelProgress';
  disputed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  failures: Array<EventCancelItemType>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  free: Scalars['Int']['output'];
  manual: Scalars['Int']['output'];
  manualItems: Array<EventCancelItemType>;
  message?: Maybe<Scalars['String']['output']>;
  pending: Scalars['Int']['output'];
  refunded: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
};

export type EventCancelProviderTotalType = {
  __typename?: 'EventCancelProviderTotal';
  amount?: Maybe<AmountType>;
  count: Scalars['Int']['output'];
  provider: PaymentProviderType;
};

export enum FieldTypeType {
  BooleanType = 'BOOLEAN',
  MultiSelectType = 'MULTI_SELECT',
  SelectType = 'SELECT',
  TextType = 'TEXT'
}

/**  для публичных файлов */
export type FileType = {
  __typename?: 'File';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

/**  для картинок и баннеров 16:9 или 16:x */
export type ImageType = {
  __typename?: 'Image';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для картинок и баннеров 16:9 или 16:x */
export type ImageUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для картинок и баннеров 16:9 или 16:x */
export type ImageWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type ImageConnectionType = {
  __typename?: 'ImageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ImageType>;
};

export type ImageThumbnailType = {
  __typename?: 'ImageThumbnail';
  format: ThumbnailFormatType;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
  width: Scalars['Int']['output'];
};

export type ImagesFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ImportMarketingContactsInputType = {
  consentConfirmed: Scalars['Boolean']['input'];
  listId: Scalars['ID']['input'];
  rows: Array<ContactRowInputType>;
  source: MarketingContactSourceType;
};

/**
 * Возможности инстанса: одного развёртывания образа со своей базой и своим
 * набором провайдеров (backend/src/config/instance.ts). Значения одинаковы
 * для всех платформ развёртывания, поэтому кабинет запрашивает их один раз и
 * решает по ним, что показывать вовсе.
 */
export type InstanceType = {
  __typename?: 'Instance';
  /** Кем подключается домен витрины. */
  domainProvider: DomainProviderType;
  /** Включены ли эфиры. Выключено — кабинет прячет разделы эфиров. */
  liveEnabled: Scalars['Boolean']['output'];
  /** Платёжные провайдеры, разрешённые инстансу. */
  paymentProviders: Array<PaymentProviderType>;
  /** Провайдер видео по умолчанию (платформа может переопределить своим). */
  videoProvider: VideoProviderType;
};

export type InviteOrganizationUserInputType = {
  email: Scalars['EmailAddress']['input'];
  roles: Array<OrganizationRoleType>;
};

export type LanguageType = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type LinkType = {
  __typename?: 'Link';
  createdAt: Scalars['DateTime']['output'];
  creator: UserType;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkType: LinkTypeType;
  organization: OrganizationType;
  platform: PlatformType;
  /** @deprecated Use targetType PAGE and targetId; removed after the cabinet moves */
  platformPage?: Maybe<PlatformPageType>;
  /** @deprecated Use targetType POST and targetId; removed after the cabinet moves */
  post?: Maybe<PostType>;
  reward?: Maybe<LinkRewardType>;
  slug: Scalars['String']['output'];
  stats?: Maybe<LinkStatsType>;
  /** @deprecated Use targetType TAG and targetId; removed after the cabinet moves */
  tag?: Maybe<TagType>;
  /** id цели INTERNAL-ссылки; null у EXTERNAL */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Название цели (страницы, статьи, тега, контента, продукта); null, если цели нет на платформе */
  targetTitle?: Maybe<Scalars['String']['output']>;
  /** Тип цели INTERNAL-ссылки; null у EXTERNAL */
  targetType?: Maybe<LinkTargetTypeType>;
  /** Абсолютный адрес перехода: href внешней ссылки или адрес цели на витрине */
  targetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
};

export type LinkConnectionType = {
  __typename?: 'LinkConnection';
  count: Scalars['Int']['output'];
  nodes: Array<LinkType>;
};

export type LinkRewardType = {
  __typename?: 'LinkReward';
  fixedAmount?: Maybe<Scalars['Float']['output']>;
  fixedCurrency?: Maybe<PaymentCurrencyType>;
  percent?: Maybe<Scalars['Float']['output']>;
  type: LinkRewardTypeType;
};

export type LinkRewardInputType = {
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  type: LinkRewardTypeType;
};

export enum LinkRewardTypeType {
  FixedType = 'FIXED',
  PercentType = 'PERCENT'
}

export type LinkStatsType = {
  __typename?: 'LinkStats';
  /** Переходы по короткой ссылке за всё время */
  clicks: Scalars['Int']['output'];
  currency: PaymentCurrencyType;
  /** Регистрации по ссылке за всё время */
  registrations: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  reward: Scalars['Float']['output'];
  sales: Scalars['Int']['output'];
  /** Просмотры, пришедшие по ссылке (views.utm.linkId), за всё время */
  views: Scalars['Int']['output'];
};

/** Цель внутренней ссылки и пункта меню (linkType INTERNAL) */
export enum LinkTargetTypeType {
  /** Контент: видео, эфир или коллекция */
  ContentType = 'CONTENT',
  /** Страница платформы */
  PageType = 'PAGE',
  /** Статья */
  PostType = 'POST',
  /** Продукт */
  ProductType = 'PRODUCT',
  /** Тег */
  TagType = 'TAG'
}

export enum LinkTypeType {
  ExternalType = 'EXTERNAL',
  InternalType = 'INTERNAL'
}

export type LinksFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  linkType?: InputMaybe<LinkTypeType>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LiveInputEventType = {
  __typename?: 'LiveInputEvent';
  at: Scalars['DateTime']['output'];
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isWarning: Scalars['Boolean']['output'];
};

export type LiveInputMetricsPointType = {
  __typename?: 'LiveInputMetricsPoint';
  at: Scalars['DateTime']['output'];
  bitRateKbps?: Maybe<Scalars['Float']['output']>;
  keyframeIntervalSeconds?: Maybe<Scalars['Float']['output']>;
  uploadSpeedPercent?: Maybe<Scalars['Float']['output']>;
};

export type LiveInputMonitoringType = {
  __typename?: 'LiveInputMonitoring';
  available: Scalars['Boolean']['output'];
  events: Array<LiveInputEventType>;
  granularity: MonitoringGranularityType;
  outages: LiveInputOutagesType;
  player?: Maybe<PlayerMetricsType>;
  points: Array<LiveInputMetricsPointType>;
  sessions: Array<LiveInputSessionType>;
  status?: Maybe<LiveInputStatusType>;
  unavailableReason?: Maybe<MonitoringUnavailableReasonType>;
};

export type LiveInputOutagePeriodType = {
  __typename?: 'LiveInputOutagePeriod';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type LiveInputOutagesType = {
  __typename?: 'LiveInputOutages';
  count: Scalars['Int']['output'];
  lastAt?: Maybe<Scalars['DateTime']['output']>;
  periods: Array<LiveInputOutagePeriodType>;
  totalSeconds: Scalars['Int']['output'];
};

export type LiveInputSessionType = {
  __typename?: 'LiveInputSession';
  end?: Maybe<Scalars['DateTime']['output']>;
  eventCount: Scalars['Int']['output'];
  hadStartupWarnings: Scalars['Boolean']['output'];
  outcome: LiveInputSessionOutcomeType;
  start: Scalars['DateTime']['output'];
  warningCount: Scalars['Int']['output'];
};

export enum LiveInputSessionOutcomeType {
  DisconnectedType = 'DISCONNECTED',
  EndedType = 'ENDED',
  OngoingType = 'ONGOING',
  TimeoutType = 'TIMEOUT'
}

export type LiveInputStatusType = {
  __typename?: 'LiveInputStatus';
  connected: Scalars['Boolean']['output'];
  protocol?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  since?: Maybe<Scalars['DateTime']['output']>;
};

export enum LiveReactionEmojiType {
  AngryType = 'ANGRY',
  BoxingType = 'BOXING',
  ClapType = 'CLAP',
  FireType = 'FIRE',
  HeartType = 'HEART',
  HeartEyesType = 'HEART_EYES',
  LaughType = 'LAUGH',
  MindBlownType = 'MIND_BLOWN',
  MuscleType = 'MUSCLE',
  PartyType = 'PARTY',
  SadType = 'SAD',
  SoccerType = 'SOCCER',
  ThumbsDownType = 'THUMBS_DOWN',
  ThumbsUpType = 'THUMBS_UP',
  TrophyType = 'TROPHY',
  WowType = 'WOW'
}

export type MarketingConsentType = {
  __typename?: 'MarketingConsent';
  at: Scalars['DateTime']['output'];
  utm?: Maybe<AttributionTouchType>;
};

export enum MarketingConsentModeType {
  OptInType = 'OPT_IN',
  OptOutType = 'OPT_OUT'
}

export type MarketingContactType = {
  __typename?: 'MarketingContact';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isViewer: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source: MarketingContactSourceType;
  status: MarketingContactStatusType;
};

export type MarketingContactConnectionType = {
  __typename?: 'MarketingContactConnection';
  count: Scalars['Int']['output'];
  nodes: Array<MarketingContactType>;
};

export enum MarketingContactSourceType {
  CsvType = 'CSV',
  ManualType = 'MANUAL'
}

export enum MarketingContactStatusType {
  SubscribedType = 'SUBSCRIBED',
  SuppressedType = 'SUPPRESSED',
  UnsubscribedType = 'UNSUBSCRIBED'
}

export enum MarketingLanguageType {
  EnType = 'en',
  PlType = 'pl',
  PtType = 'pt',
  RuType = 'ru'
}

/** Пределы ввода рассылок и аудитории, по которым бэкенд проверяет сохранение */
export type MarketingLimitsType = {
  __typename?: 'MarketingLimits';
  /** Сколько условий можно задать в фильтре аудитории */
  audienceConditions: Scalars['Int']['output'];
  /** Наибольшее число дней в условиях по давности */
  audienceMaxDays: Scalars['Int']['output'];
  /** Наибольшая сумма в условии по тратам, USD */
  audienceMaxNumber: Scalars['Int']['output'];
  /** Сколько значений можно выбрать в одном условии */
  audienceValues: Scalars['Int']['output'];
  /** Длина названия рассылки после trim */
  broadcastNameLength: Scalars['Int']['output'];
  /** Сколько списков контактов можно выбрать в аудитории */
  contactListsPerAudience: Scalars['Int']['output'];
  /** Переменные, которые могут стоять адресом кнопки письма ({{productUrl}}); заполняются в письмах цепочек */
  emailUrlVariables: Array<Scalars['String']['output']>;
};

/** Счётчик маркетинговых писем за текущий месяц (UTC) */
export type MarketingQuotaUsageType = {
  __typename?: 'MarketingQuotaUsage';
  month: Scalars['String']['output'];
  quota: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type MarketingSettingsType = {
  __typename?: 'MarketingSettings';
  consentMode: MarketingConsentModeType;
  /** Когда последний раз сменили режим согласия (null: режим не меняли). */
  consentModeChangedAt?: Maybe<Scalars['DateTime']['output']>;
  frequencyCapCount: Scalars['Int']['output'];
  frequencyCapDays: Scalars['Int']['output'];
};

export type MarketingSettingsInputType = {
  consentMode: MarketingConsentModeType;
  frequencyCapCount: Scalars['Int']['input'];
  frequencyCapDays: Scalars['Int']['input'];
};

export enum MonitoringGranularityType {
  FiveMinutesType = 'FIVE_MINUTES',
  MinuteType = 'MINUTE'
}

export enum MonitoringUnavailableReasonType {
  CloudflareErrorType = 'CLOUDFLARE_ERROR',
  NotAuthorizedType = 'NOT_AUTHORIZED',
  NotSupportedType = 'NOT_SUPPORTED'
}

export type MutationType = {
  __typename?: 'Mutation';
  activateAutomation: AutomationMutationResultType;
  archiveAutomations: Array<AutomationType>;
  /** null снимает ответственного */
  assignSupportRequest: SupportRequestType;
  attachStreamEntrypoint: StreamEntrypointType;
  cancelAssistantPlan: AssistantPlanType;
  cancelBroadcast: AutomationType;
  cancelEvent: ProductType;
  checkStreamConnection: ContentType;
  closeContentPoll: ContentPollType;
  /**
   * Подключение Bunny Stream по одному аккаунтному ключу: ottkit создаёт (или
   * берёт выбранную существующую) библиотеку, приводит её и её pull zone к
   * нашему профилю, прописывает вебхук и сохраняет все ключи сам.
   */
  connectBunnyByAccount: PlatformType;
  connectCCBill: PlatformType;
  connectDomain: PlatformType;
  connectPayPal: PlatformType;
  connectPaynet: PlatformType;
  connectStripe: PlatformType;
  createAutomation: AutomationType;
  createBroadcast: AutomationType;
  createChatBan: ChatBanType;
  createComplianceRecord: ComplianceRecordType;
  createContactList: ContactListType;
  createContent: ContentType;
  createContentFromUrl: ContentType;
  createContentPoll: ContentPollType;
  createCountryAccess: CountryAccessType;
  createEmailTemplate: EmailTemplateType;
  createLink: LinkType;
  createMultipleContents: Array<ContentType>;
  createMultiplePromocodes: Array<PromocodeType>;
  createPlatformCustomCover: PlatformCustomCoverType;
  createPlatformMenuItem: PlatformMenuItemType;
  createPlatformPage: PlatformPageType;
  createPoll: PollType;
  createPost: PostType;
  createProduct: ProductType;
  createPromocode: PromocodeType;
  /**
   * Возврат по платежу своей организации (референс createRefund админской
   * схемы). Списывает деньги через провайдера и снимает доступ у зрителя,
   * как и у админа: см. RefundService.createRefund.
   */
  createRefund: RefundType;
  createReport: ReportType;
  createRestreamDestination: ContentType;
  createStream: ContentType;
  createStreamClip: StreamClipType;
  createStreamEntrypoint: StreamEntrypointType;
  createTag: TagType;
  createVideoFileUpload: VideoFileUploadType;
  createWidget: WidgetType;
  deleteAutomations: Array<AutomationType>;
  deleteChatBan: ChatBanType;
  deleteChatMessage: ChatMessageType;
  deleteComplianceRecord: Scalars['Boolean']['output'];
  /** Удаляет списки и контакты, которых больше нет ни в одном списке */
  deleteContactLists: Array<ContactListType>;
  /** Открепление разрешено всегда, ответы этого прикрепления удаляются */
  deleteContentPoll: ContentPollType;
  deleteContents: Array<Maybe<ContentType>>;
  deleteCountryAccesses: Array<Maybe<CountryAccessType>>;
  deleteEmailTemplates: Array<EmailTemplateType>;
  deleteLinks: Array<Maybe<LinkType>>;
  /** Удаляет контакты насовсем (право на забвение) */
  deleteMarketingContacts: Array<MarketingContactType>;
  deletePlatformCustomCovers: Array<Maybe<PlatformCustomCoverType>>;
  deletePlatformMenuItems: Array<Maybe<PlatformMenuItemType>>;
  deletePlatformPages: Array<Maybe<PlatformPageType>>;
  /** Прикреплённый опрос удалить нельзя (POLL_IN_USE) */
  deletePolls: Array<PollType>;
  deletePosts: Array<Maybe<PostType>>;
  deleteProducts: Array<Scalars['ID']['output']>;
  deletePromocodes: Array<Scalars['ID']['output']>;
  deleteRestreamDestination: ContentType;
  deleteStreamClip: Scalars['Boolean']['output'];
  deleteStreamEntrypoints: Scalars['Boolean']['output'];
  deleteTags: Array<Maybe<TagType>>;
  deleteVideoFiles: Array<Maybe<VideoFileType>>;
  deleteWidgets: Array<Maybe<WidgetType>>;
  /** Отключение сотрудника (soft delete связки), доступ пропадает сразу. */
  disableOrganizationUser: OrganizationUserType;
  disconnectCCBill: PlatformType;
  disconnectDomain: PlatformType;
  disconnectPayPal: PlatformType;
  disconnectPaynet: PlatformType;
  disconnectStripe: PlatformType;
  downloadReport: ReportDownloadType;
  enableOrganizationUser: OrganizationUserType;
  finishStream: ContentType;
  finishVideoFileUpload: VideoFileType;
  /** Пачка до 2000 строк; кабинет режет большой импорт на пачки */
  importMarketingContacts: ContactImportResultType;
  /** Приглашение сотрудника по email: письмо со ссылкой быстрого входа. */
  inviteOrganizationUser: OrganizationUserType;
  /** Только для прикреплений идущего эфира */
  openContentPoll: ContentPollType;
  pauseAutomation: AutomationType;
  /**
   * Сверка неподтверждённого возврата Paynet (ответ вендора потерян) после
   * проверки в бэк-офисе Paynet: refunded true, если деньги ушли. Только admin
   * организации (как отмена события, где такие возвраты возникают).
   */
  reconcileRefund: RefundType;
  /**
   * Возвращает завершённый эфир в ожидание: зрители снова видят счётчик, а
   * не "эфир закончился". Для тестового прогона, стартованного и
   * завершённого до анонса. Работает только из статуса FINISHED.
   */
  reopenStream: ContentType;
  replySupportRequest: SupportRequestType;
  /**
   * Загрузка для провайдеров с tus и подписанными заголовками (Bunny).
   * Отдельная мутация, а не расширение requestVideoUpload: тот обещает
   * непустой uploadUrl, что верно только для Cloudflare.
   * fileName нужен провайдеру при создании объекта видео (у Bunny title
   * обязателен). contentType резолвер сам не читает и в метаданные tus не
   * кладёт: metadata.filetype для tus.Upload формирует сам клиент из
   * file.type (см. buildTusOptions.ts в кабинете), аргумент здесь только
   * фиксирует контракт на будущее.
   */
  requestTusVideoUpload: TusVideoUploadPayloadType;
  /**
   * Запускает подготовку MP4 у провайдера (у Cloudflare идемпотентно: повторный
   * вызов возвращает текущий статус) и сразу отдаёт статус. Дальше кабинет
   * опрашивает Content.videoDownload, пока PREPARING.
   */
  requestVideoDownload: VideoDownloadType;
  requestVideoUpload: VideoUploadPayloadType;
  /** Повторная отправка приглашения, не чаще раза в 5 минут. */
  resendOrganizationUserInvitation: OrganizationUserType;
  resetStreamKey: ContentType;
  restoreLinks: Array<Maybe<LinkType>>;
  restorePlatformCustomCovers: Array<Maybe<PlatformCustomCoverType>>;
  retryDomainSetup: PlatformType;
  retryEventCancel?: Maybe<EventCancelProgressType>;
  /**
   * Перевыпуск секрета вебхука. Секрет лежит в пути URL и оседает в
   * access-логах, поэтому после любой утечки логов его надо ротировать, а
   * новый адрес прописать в админке CCBill. Старый URL перестаёт работать
   * сразу.
   */
  rotateCCBillWebhookSecret: PlatformType;
  /** Отправить сейчас (scheduledAt пуст) или запланировать */
  sendBroadcast: AutomationType;
  /** Отправить письмо себе (сотруднику), мимо потолка и квоты, с примерными данными */
  sendTestEmailTemplate: Scalars['Boolean']['output'];
  setDefaultCountryAccess: CountryAccessType;
  setDefaultWidget: Scalars['Boolean']['output'];
  /**
   * Выбор платёжного провайдера платформы. null возвращает выбор по валюте.
   * Значение обязано входить в instance.paymentProviders.
   */
  setPaymentProvider: PlatformType;
  setSupportRequestStatus: SupportRequestType;
  signIn: SignInOutputType;
  signOut: Scalars['Boolean']['output'];
  startEntrypointPull: StreamEntrypointType;
  startStream: ContentType;
  startStreamPull: ContentType;
  stopEntrypointPull: StreamEntrypointType;
  stopStreamPull: ContentType;
  /**
   * Остановить покупку своей организации: доступ истекает сейчас, автопродление
   * подписки выключается (референс terminateProductPurchase админской схемы).
   * Уже истёкшую покупку возвращает без изменений.
   */
  terminateProductPurchase: ProductPurchaseType;
  updateAutomation: AutomationMutationResultType;
  updateBroadcast: AutomationType;
  updateBunnySettings: PlatformType;
  updateComplianceRecord: ComplianceRecordType;
  updateContactList: ContactListType;
  updateContent: ContentType;
  updateContentMany: Array<Maybe<ContentType>>;
  updateContentNestedSort: ContentType;
  /** Только до запуска (эфир) или пока нет ответов (видео) */
  updateContentPoll: ContentPollType;
  updateContents: Array<Maybe<ContentType>>;
  updateCountryAccess: CountryAccessType;
  updateCurrentPlatform: PlatformType;
  updateCurrentUser: UserType;
  updateEmailTemplate: EmailTemplateType;
  updateLink: LinkType;
  updateOrganizationUserRoles: OrganizationUserType;
  updatePlatformCustomCover: PlatformCustomCoverType;
  updatePlatformCustomCovers: Array<Maybe<PlatformCustomCoverType>>;
  updatePlatformMenuItem: PlatformMenuItemType;
  updatePlatformMenuItems: Array<Maybe<PlatformMenuItemType>>;
  updatePlatformPage: PlatformPageType;
  updatePlatformPages: Array<Maybe<PlatformPageType>>;
  /** Вопрос всегда; варианты, множественный выбор и режим только пока нет ответов (POLL_LOCKED) */
  updatePoll: PollType;
  updatePost: PostType;
  updatePosts: Array<Maybe<PostType>>;
  updateProduct: ProductType;
  /**
   * Правка покупки своей организации: даты доступа и автопродление подписки
   * (референс updateProductPurchase админской схемы). Пустой ввод возвращает
   * покупку как есть.
   */
  updateProductPurchase: ProductPurchaseType;
  updateProducts: Array<ProductType>;
  updatePromocode: PromocodeType;
  updateRestreamDestination: ContentType;
  updateStream: ContentType;
  updateStreamEntrypoint: StreamEntrypointType;
  updateStreamingSettings: PlatformType;
  updateTag: TagType;
  updateTags: Array<Maybe<TagType>>;
  updateTimecodes: ContentTimecodesType;
  updateWidget: WidgetType;
  uploadAssistantAttachment: AssistantAttachmentType;
  uploadAvatar: AvatarType;
  uploadBanner: BannerType;
  uploadFile: FileType;
  uploadImage: ImageType;
  uploadPrivateFile: PrivateFileType;
  verifySignIn: VerifyEmailOutputType;
};


export type MutationActivateAutomationArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveAutomationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAssignSupportRequestArgsType = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAttachStreamEntrypointArgsType = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCancelAssistantPlanArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationCancelBroadcastArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationCancelEventArgsType = {
  input: CancelEventInputType;
};


export type MutationCheckStreamConnectionArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationCloseContentPollArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationConnectBunnyByAccountArgsType = {
  input: ConnectBunnyByAccountInputType;
};


export type MutationConnectCcBillArgsType = {
  input: ConnectCcBillInputType;
};


export type MutationConnectDomainArgsType = {
  input: ConnectDomainInputType;
};


export type MutationConnectPayPalArgsType = {
  input: ConnectPayPalInputType;
};


export type MutationConnectPaynetArgsType = {
  input: ConnectPaynetInputType;
};


export type MutationConnectStripeArgsType = {
  input: ConnectStripeInputType;
};


export type MutationCreateAutomationArgsType = {
  input: CreateAutomationInputType;
};


export type MutationCreateBroadcastArgsType = {
  input: CreateBroadcastInputType;
};


export type MutationCreateChatBanArgsType = {
  input: CreateChatBanInputType;
};


export type MutationCreateComplianceRecordArgsType = {
  input: CreateComplianceRecordInputType;
};


export type MutationCreateContactListArgsType = {
  name: Scalars['String']['input'];
};


export type MutationCreateContentArgsType = {
  input: CreateContentInputType;
};


export type MutationCreateContentFromUrlArgsType = {
  input: CreateContentFromUrlInputType;
};


export type MutationCreateContentPollArgsType = {
  contentId: Scalars['ID']['input'];
  input: ContentPollScheduleInputType;
  pollId: Scalars['ID']['input'];
};


export type MutationCreateCountryAccessArgsType = {
  input: CreateCountryAccessInputType;
};


export type MutationCreateEmailTemplateArgsType = {
  input: EmailTemplateInputType;
};


export type MutationCreateLinkArgsType = {
  input: CreateLinkInputType;
};


export type MutationCreateMultipleContentsArgsType = {
  input: Array<CreateContentInputType>;
};


export type MutationCreateMultiplePromocodesArgsType = {
  input: CreateMultiplePromocodesInputType;
};


export type MutationCreatePlatformCustomCoverArgsType = {
  input: CreatePlatformCustomCoverInputType;
};


export type MutationCreatePlatformMenuItemArgsType = {
  input: CreatePlatformMenuItemInputType;
};


export type MutationCreatePlatformPageArgsType = {
  input: CreatePlatformPageInputType;
};


export type MutationCreatePollArgsType = {
  input: CreatePollInputType;
};


export type MutationCreatePostArgsType = {
  input: CreatePostInputType;
};


export type MutationCreateProductArgsType = {
  input: CreateProductInputType;
};


export type MutationCreatePromocodeArgsType = {
  input: CreatePromocodeInputType;
};


export type MutationCreateRefundArgsType = {
  input: CreateRefundInputType;
};


export type MutationCreateReportArgsType = {
  input: CreateReportInputType;
};


export type MutationCreateRestreamDestinationArgsType = {
  contentId: Scalars['ID']['input'];
  input: CreateRestreamDestinationInputType;
};


export type MutationCreateStreamArgsType = {
  input: CreateStreamInputType;
};


export type MutationCreateStreamClipArgsType = {
  input: CreateStreamClipInputType;
};


export type MutationCreateStreamEntrypointArgsType = {
  input: CreateStreamEntrypointInputType;
};


export type MutationCreateTagArgsType = {
  input: CreateTagInputType;
};


export type MutationCreateVideoFileUploadArgsType = {
  input: CreateVideoFileUploadInputType;
};


export type MutationCreateWidgetArgsType = {
  input: CreateWidgetInputType;
};


export type MutationDeleteAutomationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteChatBanArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatMessageArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteComplianceRecordArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContactListsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteContentPollArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCountryAccessesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEmailTemplatesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteLinksArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMarketingContactsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformCustomCoversArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformMenuItemsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformPagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePollsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePostsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePromocodesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteRestreamDestinationArgsType = {
  contentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteStreamClipArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationDeleteStreamEntrypointsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTagsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteVideoFilesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteWidgetsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDisableOrganizationUserArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadReportArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationEnableOrganizationUserArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationFinishStreamArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationFinishVideoFileUploadArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationImportMarketingContactsArgsType = {
  input: ImportMarketingContactsInputType;
};


export type MutationInviteOrganizationUserArgsType = {
  input: InviteOrganizationUserInputType;
};


export type MutationOpenContentPollArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationPauseAutomationArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationReconcileRefundArgsType = {
  refundId: Scalars['ID']['input'];
  refunded: Scalars['Boolean']['input'];
};


export type MutationReopenStreamArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationReplySupportRequestArgsType = {
  id: Scalars['ID']['input'];
  input: ReplySupportRequestInputType;
};


export type MutationRequestTusVideoUploadArgsType = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
};


export type MutationRequestVideoDownloadArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationRequestVideoUploadArgsType = {
  durationSeconds?: InputMaybe<Scalars['Float']['input']>;
  fileSize: Scalars['Float']['input'];
};


export type MutationResendOrganizationUserInvitationArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationResetStreamKeyArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationRestoreLinksArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestorePlatformCustomCoversArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRetryEventCancelArgsType = {
  productId: Scalars['ID']['input'];
};


export type MutationSendBroadcastArgsType = {
  id: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationSendTestEmailTemplateArgsType = {
  id: Scalars['ID']['input'];
  language: MarketingLanguageType;
};


export type MutationSetDefaultCountryAccessArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultWidgetArgsType = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetPaymentProviderArgsType = {
  provider?: InputMaybe<PaymentProviderType>;
};


export type MutationSetSupportRequestStatusArgsType = {
  id: Scalars['ID']['input'];
  input: SetSupportRequestStatusInputType;
};


export type MutationSignInArgsType = {
  input: SignInInputType;
};


export type MutationStartEntrypointPullArgsType = {
  id: Scalars['ID']['input'];
  sourceUrl: Scalars['String']['input'];
};


export type MutationStartStreamArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationStartStreamPullArgsType = {
  contentId: Scalars['ID']['input'];
  sourceUrl: Scalars['String']['input'];
};


export type MutationStopEntrypointPullArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationStopStreamPullArgsType = {
  contentId: Scalars['ID']['input'];
};


export type MutationTerminateProductPurchaseArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAutomationArgsType = {
  id: Scalars['ID']['input'];
  input: AutomationInputType;
};


export type MutationUpdateBroadcastArgsType = {
  id: Scalars['ID']['input'];
  input: BroadcastInputType;
};


export type MutationUpdateBunnySettingsArgsType = {
  input: UpdateBunnySettingsInputType;
};


export type MutationUpdateComplianceRecordArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateComplianceRecordInputType;
};


export type MutationUpdateContactListArgsType = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateContentArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateContentInputType;
};


export type MutationUpdateContentManyArgsType = {
  input: Array<UpdateContentManyInputType>;
};


export type MutationUpdateContentNestedSortArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateContentNestedSortInputType;
};


export type MutationUpdateContentPollArgsType = {
  id: Scalars['ID']['input'];
  input: ContentPollScheduleInputType;
};


export type MutationUpdateContentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdateContentsInputType;
};


export type MutationUpdateCountryAccessArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateCountryAccessInputType;
};


export type MutationUpdateCurrentPlatformArgsType = {
  input: UpdateCurrentPlatformInputType;
};


export type MutationUpdateCurrentUserArgsType = {
  input: UpdateCurrentUserInputType;
};


export type MutationUpdateEmailTemplateArgsType = {
  id: Scalars['ID']['input'];
  input: EmailTemplateInputType;
};


export type MutationUpdateLinkArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateLinkInputType;
};


export type MutationUpdateOrganizationUserRolesArgsType = {
  id: Scalars['ID']['input'];
  roles: Array<OrganizationRoleType>;
};


export type MutationUpdatePlatformCustomCoverArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformCustomCoverInputType;
};


export type MutationUpdatePlatformCustomCoversArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdatePlatformCustomCoversInputType;
};


export type MutationUpdatePlatformMenuItemArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformMenuItemInputType;
};


export type MutationUpdatePlatformMenuItemsArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdatePlatformMenuItemsInputType;
};


export type MutationUpdatePlatformPageArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformPageInputType;
};


export type MutationUpdatePlatformPagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdatePlatformPagesInputType;
};


export type MutationUpdatePollArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePollInputType;
};


export type MutationUpdatePostArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePostInputType;
};


export type MutationUpdatePostsArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdatePostsInputType;
};


export type MutationUpdateProductArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateProductInputType;
};


export type MutationUpdateProductPurchaseArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateProductPurchaseInputType;
};


export type MutationUpdateProductsArgsType = {
  input: Array<UpdateProductsInputType>;
};


export type MutationUpdatePromocodeArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePromocodeInputType;
};


export type MutationUpdateRestreamDestinationArgsType = {
  contentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: UpdateRestreamDestinationInputType;
};


export type MutationUpdateStreamArgsType = {
  contentId: Scalars['ID']['input'];
  input: UpdateStreamInputType;
};


export type MutationUpdateStreamEntrypointArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateStreamEntrypointInputType;
};


export type MutationUpdateStreamingSettingsArgsType = {
  input: UpdateStreamingSettingsInputType;
};


export type MutationUpdateTagArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateTagInputType;
};


export type MutationUpdateTagsArgsType = {
  ids: Array<Scalars['ID']['input']>;
  input: UpdateTagsInputType;
};


export type MutationUpdateTimecodesArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateTimecodesInputType;
};


export type MutationUpdateWidgetArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateWidgetInputType;
};


export type MutationUploadAssistantAttachmentArgsType = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  file: Scalars['Upload']['input'];
};


export type MutationUploadAvatarArgsType = {
  input: UploadAvatarInputType;
};


export type MutationUploadBannerArgsType = {
  input: UploadBannerInputType;
};


export type MutationUploadFileArgsType = {
  input: UploadFileInputType;
};


export type MutationUploadImageArgsType = {
  input: UploadImageInputType;
};


export type MutationUploadPrivateFileArgsType = {
  input: UploadPrivateFileInputType;
};


export type MutationVerifySignInArgsType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum OrderStatusType {
  CanceledType = 'CANCELED',
  CompletedType = 'COMPLETED',
  CreatedType = 'CREATED',
  DraftType = 'DRAFT',
  NeedsApprovalType = 'NEEDS_APPROVAL',
  NeedsRefundType = 'NEEDS_REFUND',
  PaidType = 'PAID',
  PaymentRequiredType = 'PAYMENT_REQUIRED'
}

export type OrganizationType = {
  __typename?: 'Organization';
  altNames?: Maybe<Array<Scalars['String']['output']>>;
  assistantEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  currency: PaymentCurrencyType;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<AvatarType>;
  platform?: Maybe<PlatformType>;
  platformId?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: OrganizationStatusType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAddressType = {
  __typename?: 'OrganizationAddress';
  address: AddressType;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: OrganizationAddressTypeType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrganizationAddressTypeType {
  /** Дополнительный адрес */
  AdditionalType = 'ADDITIONAL',
  /** Юридический адрес */
  LegalType = 'LEGAL',
  /** Почтовый адрес */
  PostalType = 'POSTAL'
}

export type OrganizationDetailsType = {
  __typename?: 'OrganizationDetails';
  createdAt: Scalars['DateTime']['output'];
  inn?: Maybe<Scalars['String']['output']>;
  kpp?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  ogrn?: Maybe<Scalars['String']['output']>;
  representationBasis?: Maybe<Scalars['String']['output']>;
  representative?: Maybe<Scalars['String']['output']>;
  representativePosition?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Роль сотрудника внутри организации (OrganizationUser.roles) */
export enum OrganizationRoleType {
  AdminType = 'admin',
  AnalyticsType = 'analytics',
  MarketingType = 'marketing',
  ProductsType = 'products',
  SettingsType = 'settings',
  StreamsType = 'streams',
  UsersType = 'users',
  VideosType = 'videos'
}

export enum OrganizationStatusType {
  ActiveType = 'active',
  InactiveType = 'inactive'
}

export type OrganizationUserType = {
  __typename?: 'OrganizationUser';
  createdAt: Scalars['DateTime']['output'];
  /** Связка отключена (soft delete), сотрудник в кабинет не попадёт. */
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Кто пригласил сотрудника, если приглашение делали из кабинета. */
  invitedBy?: Maybe<UserType>;
  roles: Array<OrganizationRoleType>;
  user: UserType;
  /** Когда сотруднику ушло письмо о доступе (поле берётся с User). */
  welcomeEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationUserConnectionType = {
  __typename?: 'OrganizationUserConnection';
  count: Scalars['Int']['output'];
  nodes: Array<OrganizationUserType>;
};

export type OrganizationUsersFilterInputType = {
  /** true: только отключённые, false: только активные, null: все. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Поиск по email и имени пользователя. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerAssistantConversationType = {
  __typename?: 'PartnerAssistantConversation';
  id: Scalars['ID']['output'];
  messages: Array<PartnerAssistantMessageType>;
};

export type PartnerAssistantMessageType = {
  __typename?: 'PartnerAssistantMessage';
  ask?: Maybe<Scalars['JSON']['output']>;
  attachments: Array<AssistantAttachmentType>;
  cards: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: AssistantMessageKindType;
  plan?: Maybe<AssistantPlanType>;
  role: AssistantMessageRoleType;
  text: Scalars['String']['output'];
};

export type PaymentType = {
  __typename?: 'Payment';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feeAmount?: Maybe<AmountType>;
  id: Scalars['ID']['output'];
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  organizationId: Scalars['ID']['output'];
  ottkitFeeAmount?: Maybe<AmountType>;
  period: Scalars['Int']['output'];
  platformId: Scalars['ID']['output'];
  product?: Maybe<ProductType>;
  productId: Scalars['ID']['output'];
  provider: PaymentProviderType;
  providerFeeAmount?: Maybe<AmountType>;
  recurrent: Scalars['Boolean']['output'];
  refunds: Array<RefundType>;
  status: PaymentStatusType;
  userId: Scalars['ID']['output'];
  /** Касание продажи (спека attribution): последнее касание в окне на момент оплаты. */
  utm?: Maybe<AttributionTouchType>;
};

export type PaymentConnectionType = {
  __typename?: 'PaymentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PaymentType>;
};

export enum PaymentCurrencyType {
  CadType = 'CAD',
  EurType = 'EUR',
  GbpType = 'GBP',
  MdlType = 'MDL',
  PlnType = 'PLN',
  UsdType = 'USD'
}

export enum PaymentProviderType {
  CcbillType = 'CCBILL',
  PaynetType = 'PAYNET',
  PaypalType = 'PAYPAL',
  StripeType = 'STRIPE'
}

export enum PaymentStatusType {
  CanceledType = 'CANCELED',
  PendingType = 'PENDING',
  RefundedType = 'REFUNDED',
  SucceededType = 'SUCCEEDED'
}

export type PaymentsFilterInputType = {
  currency?: InputMaybe<PaymentCurrencyType>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providers?: InputMaybe<Array<PaymentProviderType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatusType>;
};

export type PlatformType = {
  __typename?: 'Platform';
  acceptTermsOfServiceOnSignIn?: Maybe<Scalars['Boolean']['output']>;
  bunnySettings?: Maybe<PlatformBunnySettingsType>;
  complianceCustodianAddress?: Maybe<Scalars['String']['output']>;
  complianceCustodianName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customHTML?: Maybe<Scalars['String']['output']>;
  customHead?: Maybe<Scalars['String']['output']>;
  customTerms: Array<PlatformCustomTermType>;
  defaultRowSize?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domainSetup?: Maybe<PlatformDomainSetupType>;
  /**
   * Провайдер, которым платформа играет на самом деле: её собственный, если
   * задан, иначе дефолт инстанса. В отличие от videoProvider никогда не
   * пустой. Кабинет решает по нему, какой мутацией просить загрузку.
   */
  effectiveVideoProvider: VideoProviderType;
  faviconId?: Maybe<Scalars['ID']['output']>;
  features: Array<PlatformFeatureType>;
  footer?: Maybe<PlatformFooterType>;
  gaId?: Maybe<Scalars['String']['output']>;
  googleSiteVerification?: Maybe<Scalars['String']['output']>;
  hideableHeader?: Maybe<Scalars['Boolean']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  iconId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isAgeGateEnabled?: Maybe<Scalars['Boolean']['output']>;
  isComplianceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFavoritesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeaturedVideosEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLikesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLiveReactionsEnabled: Scalars['Boolean']['output'];
  isSearchIndexingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStreamChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  isVideoChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
  languageId?: Maybe<Scalars['ID']['output']>;
  legalEntity?: Maybe<PlatformLegalEntityType>;
  liveReactionEmojis: Array<LiveReactionEmojiType>;
  liveReactionPhrases: Array<Scalars['String']['output']>;
  logo?: Maybe<AvatarType>;
  logoId?: Maybe<Scalars['ID']['output']>;
  marketingSettings: MarketingSettingsType;
  parallelPremiumViewLimit?: Maybe<Scalars['Int']['output']>;
  paymentSettings?: Maybe<PlatformPaymentSettingsType>;
  privacyPolicyUrl?: Maybe<Scalars['URL']['output']>;
  published: Scalars['Boolean']['output'];
  refundPolicyUrl?: Maybe<Scalars['URL']['output']>;
  slug: Scalars['String']['output'];
  slugHost: Scalars['String']['output'];
  slugUrl: Scalars['URL']['output'];
  status: PlatformStatusType;
  streamSignalAlertsEnabled: Scalars['Boolean']['output'];
  /**
   * True when video upload/playback actually works for this platform: either
   * its own streamingSettings (accountId + apiToken) are configured, or the
   * shared DEFAULT Cloudflare credentials (config cloudflareStream.default)
   * are available as a fallback. Does not expose any secrets.
   */
  streamingAvailable: Scalars['Boolean']['output'];
  streamingSettings?: Maybe<PlatformStreamingSettingsType>;
  termsOfServiceUrl?: Maybe<Scalars['URL']['output']>;
  theme?: Maybe<PlatformThemeType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['URL']['output']>;
  videoProvider?: Maybe<VideoProviderType>;
};

/**
 * Учётные данные Bunny платформы, только для чтения. Секреты наружу не
 * уходят, отдаётся маска и не-секретные поля.
 */
export type PlatformBunnySettingsType = {
  __typename?: 'PlatformBunnySettings';
  apiKeyMask: Scalars['String']['output'];
  cdnHostname: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  libraryId: Scalars['String']['output'];
};

export type PlatformCcBillSettingsType = {
  __typename?: 'PlatformCCBillSettings';
  accnum: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  flexFormId: Scalars['String']['output'];
  saltMask: Scalars['String']['output'];
  sandbox: Scalars['Boolean']['output'];
  subaccount: Scalars['String']['output'];
  supportUrl?: Maybe<Scalars['String']['output']>;
  webhookUrl: Scalars['String']['output'];
};

export type PlatformCustomCoverType = {
  __typename?: 'PlatformCustomCover';
  align: Scalars['String']['output'];
  alignMobile: Scalars['String']['output'];
  background: PlatformCustomCoverBackgroundType;
  brightness: Scalars['Float']['output'];
  buttons: Array<PlatformCustomCoverButtonType>;
  buttonsColor: Scalars['String']['output'];
  buttonsSize: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  desktopImage?: Maybe<BannerType>;
  desktopVideo?: Maybe<VideoFileType>;
  id: Scalars['ID']['output'];
  mobileImage?: Maybe<BannerType>;
  mobileVideo?: Maybe<VideoFileType>;
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  platform: PlatformType;
  platformId: Scalars['ID']['output'];
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  subTitle: PlatformCustomCoverSubTitleType;
  title: PlatformCustomCoverTitleType;
  updatedAt: Scalars['DateTime']['output'];
  verticalAlign: Scalars['String']['output'];
  verticalAlignMobile: Scalars['String']['output'];
};

export type PlatformCustomCoverBackgroundType = {
  __typename?: 'PlatformCustomCoverBackground';
  desktopImageId?: Maybe<Scalars['ID']['output']>;
  desktopVideoId?: Maybe<Scalars['ID']['output']>;
  mobileImageId?: Maybe<Scalars['ID']['output']>;
  mobileVideoId?: Maybe<Scalars['ID']['output']>;
};

export type PlatformCustomCoverBackgroundInputType = {
  desktopImageId?: InputMaybe<Scalars['ID']['input']>;
  desktopVideoId?: InputMaybe<Scalars['ID']['input']>;
  mobileImageId?: InputMaybe<Scalars['ID']['input']>;
  mobileVideoId?: InputMaybe<Scalars['ID']['input']>;
};

export type PlatformCustomCoverButtonType = {
  __typename?: 'PlatformCustomCoverButton';
  disabled: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

export type PlatformCustomCoverButtonInputType = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  text: Scalars['String']['input'];
  variant: Scalars['String']['input'];
};

export type PlatformCustomCoverConnectionType = {
  __typename?: 'PlatformCustomCoverConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformCustomCoverType>;
};

export type PlatformCustomCoverSubTitleType = {
  __typename?: 'PlatformCustomCoverSubTitle';
  color: Scalars['String']['output'];
  size: Scalars['String']['output'];
  text: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type PlatformCustomCoverSubTitleInputType = {
  color: Scalars['String']['input'];
  size: Scalars['String']['input'];
  text: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type PlatformCustomCoverTitleType = {
  __typename?: 'PlatformCustomCoverTitle';
  color: Scalars['String']['output'];
  size: Scalars['String']['output'];
  text: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type PlatformCustomCoverTitleInputType = {
  color: Scalars['String']['input'];
  size: Scalars['String']['input'];
  text: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type PlatformCustomCoversFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformCustomTermType = {
  __typename?: 'PlatformCustomTerm';
  label: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type PlatformCustomTermInputType = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/**
 * Подключение домена витрины. Внутренние id (записи, правила, pull zone)
 * наружу не отдаём — партнёру нужны статус, причина и записи, которые он
 * ставит сам.
 */
export type PlatformDomainSetupType = {
  __typename?: 'PlatformDomainSetup';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Запись в DNS поставили мы, а не партнёр руками. */
  dnsManaged: Scalars['Boolean']['output'];
  host: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  /**
   * Записи, которые партнёр ставит руками. Пусто, когда запись поставили мы
   * (dnsManaged) или когда провайдер таких записей не требует.
   */
  manualRecords: Array<DomainDnsRecordType>;
  previousStatus?: Maybe<PlatformDomainStatusType>;
  /**
   * Провайдер, которым это подключение начиналось. Подключения, сделанные до
   * появления Bunny-пути, отдаются как CLOUDFLARE.
   */
  provider: DomainProviderType;
  status: PlatformDomainStatusType;
  statusChangedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

export enum PlatformDomainStatusType {
  ActiveType = 'ACTIVE',
  FailedType = 'FAILED',
  PendingCertType = 'PENDING_CERT',
  PendingDnsType = 'PENDING_DNS',
  ProtectingType = 'PROTECTING',
  ZoneMissingType = 'ZONE_MISSING'
}

/** Фичефлаг платформы: включается только в админке */
export enum PlatformFeatureType {
  LiveReactionsType = 'LIVE_REACTIONS',
  MarketingEmailsType = 'MARKETING_EMAILS',
  PlayerPollsType = 'PLAYER_POLLS'
}

export type PlatformFooterType = {
  __typename?: 'PlatformFooter';
  social: Array<PlatformSocialType>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlatformFooterInputType = {
  social?: InputMaybe<Array<PlatformSocialInputType>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Реквизиты юрлица платформы для футера — требование мерчант-комплаенса Paynet */
export type PlatformLegalEntityType = {
  __typename?: 'PlatformLegalEntity';
  address: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** Регистрационный номер компании, в Молдове IDNO */
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type PlatformLegalEntityInputType = {
  address: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMenuItemType = {
  __typename?: 'PlatformMenuItem';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<AvatarType>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  linkType: PlatformMenuItemLinkTypeType;
  mobileIcon?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use targetType PAGE and targetId; removed after the cabinet moves */
  platformPage?: Maybe<PlatformPageType>;
  /** @deprecated Use targetType PAGE and targetId; removed after the cabinet moves */
  platformPageId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use targetType POST and targetId; removed after the cabinet moves */
  post?: Maybe<PostType>;
  /** @deprecated Use targetType POST and targetId; removed after the cabinet moves */
  postId?: Maybe<Scalars['String']['output']>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use targetType TAG and targetId; removed after the cabinet moves */
  tag?: Maybe<TagType>;
  /** @deprecated Use targetType TAG and targetId; removed after the cabinet moves */
  tagId?: Maybe<Scalars['String']['output']>;
  /** id цели INTERNAL-пункта */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Название цели; null, если цели нет на платформе */
  targetTitle?: Maybe<Scalars['String']['output']>;
  /** Тип цели INTERNAL-пункта; null у EXTERNAL и DIALOG */
  targetType?: Maybe<LinkTargetTypeType>;
  /** Абсолютный адрес перехода: href внешнего пункта или адрес цели на витрине */
  targetUrl?: Maybe<Scalars['URL']['output']>;
  type: PlatformMenuItemTypeType;
  visibilityConditions?: Maybe<VisibilityConditionsType>;
};

export type PlatformMenuItemConnectionType = {
  __typename?: 'PlatformMenuItemConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformMenuItemType>;
};

export type PlatformMenuItemDialogItemInputType = {
  subItems: Array<PlatformMenuItemDialogSubItemInputType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMenuItemDialogSubItemInputType = {
  href?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PlatformMenuItemLinkTypeType {
  ExternalType = 'EXTERNAL',
  InternalType = 'INTERNAL'
}

export enum PlatformMenuItemTypeType {
  DialogType = 'DIALOG',
  LinkType = 'LINK'
}

export type PlatformMenuItemsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformPageType = {
  __typename?: 'PlatformPage';
  blocks: Array<PlatformPageBlockType>;
  countryCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<BannerType>;
  isHomepage: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  platform: PlatformType;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['URL']['output']>;
  visibilityConditions?: Maybe<VisibilityConditionsType>;
};

export type PlatformPageBlockType = {
  __typename?: 'PlatformPageBlock';
  component: PlatformPageBlockTypeType;
  id: Scalars['ID']['output'];
  props: Scalars['JSON']['output'];
  visibilityConditions: VisibilityConditionsType;
};

export type PlatformPageBlockInputType = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  component: PlatformPageBlockTypeType;
  props?: InputMaybe<Scalars['JSON']['input']>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export enum PlatformPageBlockTypeType {
  AppsListType = 'APPS_LIST',
  ArchiveType = 'ARCHIVE',
  BannerType = 'BANNER',
  ButtonType = 'BUTTON',
  ContentsType = 'CONTENTS',
  ContinueReadContentsType = 'CONTINUE_READ_CONTENTS',
  ContinueWatchingContentsType = 'CONTINUE_WATCHING_CONTENTS',
  CoverCarouselType = 'COVER_CAROUSEL',
  CustomCoverType = 'CUSTOM_COVER',
  DigitalAssetsType = 'DIGITAL_ASSETS',
  DonationProgressType = 'DONATION_PROGRESS',
  FaqType = 'FAQ',
  FastLinksListType = 'FAST_LINKS_LIST',
  FavoriteContentsType = 'FAVORITE_CONTENTS',
  HtmlType = 'HTML',
  ItemsListType = 'ITEMS_LIST',
  MarkdownType = 'MARKDOWN',
  PackagesType = 'PACKAGES',
  PartnersType = 'PARTNERS',
  PlaylistsType = 'PLAYLISTS',
  PostsType = 'POSTS',
  ProductsType = 'PRODUCTS',
  RedirectType = 'REDIRECT',
  ReviewsType = 'REVIEWS',
  ServicesType = 'SERVICES',
  TagsType = 'TAGS',
  TagCardType = 'TAG_CARD',
  TextType = 'TEXT',
  TvPlayerType = 'TV_PLAYER'
}

export type PlatformPageConnectionType = {
  __typename?: 'PlatformPageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformPageType>;
};

export type PlatformPagesFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Секрет наружу не отдаётся даже маской целиком: им подписываются запросы к
 * PayPal. clientId, наоборот, публичный, он и так уходит в адрес JS SDK.
 */
export type PlatformPayPalSettingsType = {
  __typename?: 'PlatformPayPalSettings';
  clientId: Scalars['String']['output'];
  clientSecretMask: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  sandbox: Scalars['Boolean']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type PlatformPaymentSettingsType = {
  __typename?: 'PlatformPaymentSettings';
  ccbill?: Maybe<PlatformCcBillSettingsType>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  paynet?: Maybe<PlatformPaynetSettingsType>;
  paypal?: Maybe<PlatformPayPalSettingsType>;
  /**
   * Выбранный провайдер платформы. null означает прежнее поведение: провайдер
   * выводится из валюты цены.
   */
  provider?: Maybe<PaymentProviderType>;
  publishableKey?: Maybe<Scalars['String']['output']>;
  secretKeyMask?: Maybe<Scalars['String']['output']>;
};

export type PlatformPaynetSettingsType = {
  __typename?: 'PlatformPaynetSettings';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  merchantCode: Scalars['String']['output'];
  saleArea?: Maybe<Scalars['String']['output']>;
  secretKeyMask: Scalars['String']['output'];
};

export type PlatformSocialType = {
  __typename?: 'PlatformSocial';
  link: Scalars['URL']['output'];
  type: PlatformSocialTypeType;
};

export type PlatformSocialInputType = {
  link: Scalars['URL']['input'];
  type: PlatformSocialTypeType;
};

export enum PlatformSocialTypeType {
  FacebookType = 'facebook',
  InstagramType = 'instagram',
  OdnoklassnikiType = 'odnoklassniki',
  TelegramType = 'telegram',
  TiktokType = 'tiktok',
  TwitterType = 'twitter',
  VkontakteType = 'vkontakte',
  YoutubeType = 'youtube'
}

export enum PlatformStatusType {
  DisabledType = 'disabled',
  DraftType = 'draft',
  EnabledType = 'enabled'
}

export type PlatformStreamingSettingsType = {
  __typename?: 'PlatformStreamingSettings';
  accountId: Scalars['String']['output'];
  apiTokenMask: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlatformThemeType = {
  __typename?: 'PlatformTheme';
  palette?: Maybe<PlatformThemePaletteType>;
  typography?: Maybe<PlatformThemeTypographyType>;
};

export type PlatformThemeInputType = {
  palette?: InputMaybe<PlatformThemePaletteInputType>;
  typography?: InputMaybe<PlatformThemeTypographyInputType>;
};

export type PlatformThemePaletteType = {
  __typename?: 'PlatformThemePalette';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
  type: PlatformThemePaletteTypeType;
};

export type PlatformThemePaletteInputType = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PlatformThemePaletteTypeType>;
};

export enum PlatformThemePaletteTypeType {
  DarkType = 'dark',
  LightType = 'light'
}

export type PlatformThemeTypographyType = {
  __typename?: 'PlatformThemeTypography';
  fontFamily?: Maybe<Scalars['String']['output']>;
  headingFontFamily?: Maybe<Scalars['String']['output']>;
};

export type PlatformThemeTypographyInputType = {
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  headingFontFamily?: InputMaybe<Scalars['String']['input']>;
};

export type PlayerMetricsType = {
  __typename?: 'PlayerMetrics';
  byCountry: Array<PlayerMetricsBucketType>;
  byResolution: Array<PlayerMetricsBucketType>;
  points: Array<PlayerMetricsPointType>;
};

export type PlayerMetricsBucketType = {
  __typename?: 'PlayerMetricsBucket';
  key: Scalars['String']['output'];
  viewers: Scalars['Int']['output'];
};

export type PlayerMetricsPointType = {
  __typename?: 'PlayerMetricsPoint';
  at: Scalars['DateTime']['output'];
  bufferLengthSeconds?: Maybe<Scalars['Float']['output']>;
  bufferStarvationSeconds?: Maybe<Scalars['Float']['output']>;
  viewers: Scalars['Int']['output'];
};

export type PollType = {
  __typename?: 'Poll';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMultiple: Scalars['Boolean']['output'];
  options: Array<PollOptionType>;
  question: Scalars['String']['output'];
  resultsMode: PollResultsModeType;
  updatedAt: Scalars['DateTime']['output'];
  usage: PollUsageType;
};

export type PollConnectionType = {
  __typename?: 'PollConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PollType>;
};

export type PollOptionType = {
  __typename?: 'PollOption';
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type PollOptionInputType = {
  /** Id варианта, который уже есть в опросе: сохраняет его при правке */
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export enum PollResultsModeType {
  AfterCloseType = 'AFTER_CLOSE',
  AfterVoteType = 'AFTER_VOTE'
}

export enum PollStatusType {
  ActiveType = 'ACTIVE',
  ClosedType = 'CLOSED',
  DraftType = 'DRAFT',
  ScheduledType = 'SCHEDULED'
}

export enum PollTriggerType {
  AtOffsetType = 'AT_OFFSET',
  AtTimeType = 'AT_TIME',
  ManualType = 'MANUAL'
}

export type PollUsageType = {
  __typename?: 'PollUsage';
  /** Сколько видео и эфиров используют опрос (удалённый контент не считается) */
  attachmentsCount: Scalars['Int']['output'];
  /** Есть ответы зрителей: варианты, множественный выбор и режим результатов менять нельзя */
  isLocked: Scalars['Boolean']['output'];
};

export type PostType = {
  __typename?: 'Post';
  accessOnlyViaLink: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: ImageType;
  organization: OrganizationType;
  path?: Maybe<Scalars['String']['output']>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tags: Array<TagType>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['URL']['output']>;
};

export type PostConnectionType = {
  __typename?: 'PostConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PostType>;
};

export type PostsFilterInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  publishedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  для приватных файлов */
export type PrivateFileType = {
  __typename?: 'PrivateFile';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductType = {
  __typename?: 'Product';
  collectionsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventCancel?: Maybe<ProductEventCancelType>;
  eventFinishAt?: Maybe<Scalars['DateTime']['output']>;
  eventStartAt?: Maybe<Scalars['DateTime']['output']>;
  finishAt: Scalars['DateTime']['output'];
  finishSalesAt?: Maybe<Scalars['DateTime']['output']>;
  hideInGeneralLists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  perContentPurchase: Scalars['Boolean']['output'];
  preview?: Maybe<ImageType>;
  prices: Array<ProductPriceType>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  showContent: Scalars['Boolean']['output'];
  siteUrl: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  status: ProductStatusType;
  streamsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: ProductTypeType;
  updatedAt: Scalars['DateTime']['output'];
  videosCount: Scalars['Int']['output'];
};

export type ProductConnectionType = {
  __typename?: 'ProductConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ProductType>;
};

export enum ProductCurrencyType {
  CadType = 'CAD',
  EurType = 'EUR',
  GbpType = 'GBP',
  MdlType = 'MDL',
  PlnType = 'PLN',
  UsdType = 'USD'
}

export type ProductEventCancelType = {
  __typename?: 'ProductEventCancel';
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type ProductPriceType = {
  __typename?: 'ProductPrice';
  countryAccessId?: Maybe<Scalars['ID']['output']>;
  currency: ProductCurrencyType;
  id: Scalars['ID']['output'];
  period: Scalars['Int']['output'];
  periods: Array<ProductPricePeriodType>;
  trialPeriod: Scalars['Int']['output'];
  trialValue: Scalars['Float']['output'];
};

export type ProductPriceInputType = {
  countryAccessId?: InputMaybe<Scalars['ID']['input']>;
  currency: ProductCurrencyType;
  id?: InputMaybe<Scalars['ID']['input']>;
  period: Scalars['Int']['input'];
  periods: Array<ProductPricePeriodInputType>;
  trialPeriod?: InputMaybe<Scalars['Int']['input']>;
  trialValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductPricePeriodType = {
  __typename?: 'ProductPricePeriod';
  dateFrom: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  oldValue?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export type ProductPricePeriodInputType = {
  dateFrom: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  oldValue?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['Float']['input'];
};

export type ProductPurchaseType = {
  __typename?: 'ProductPurchase';
  buyerEmail?: Maybe<Scalars['String']['output']>;
  disputed: Scalars['Boolean']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  linkReward?: Maybe<AmountType>;
  organizationId: Scalars['ID']['output'];
  payment?: Maybe<PaymentType>;
  platformId: Scalars['ID']['output'];
  product: ProductType;
  productId: Scalars['ID']['output'];
  refunded: Scalars['Boolean']['output'];
  startAt: Scalars['DateTime']['output'];
  subscription?: Maybe<ProductSubscriptionType>;
  type: ProductPurchaseTypeType;
  userId: Scalars['ID']['output'];
  /** Касание покупки (спека attribution): копия касания платежа. */
  utm?: Maybe<AttributionTouchType>;
};

export type ProductPurchaseConnectionType = {
  __typename?: 'ProductPurchaseConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ProductPurchaseType>;
};

export enum ProductPurchaseStatusType {
  ActiveType = 'ACTIVE',
  DisputedType = 'DISPUTED',
  ExpiredType = 'EXPIRED',
  RefundedType = 'REFUNDED'
}

export enum ProductPurchaseTypeType {
  PpvType = 'PPV',
  SubscriptionType = 'SUBSCRIPTION'
}

export type ProductPurchasesFilterInputType = {
  currency?: InputMaybe<PaymentCurrencyType>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providers?: InputMaybe<Array<PaymentProviderType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductPurchaseStatusType>;
  type?: InputMaybe<ProductPurchaseTypeType>;
};

export enum ProductStatusType {
  AllType = 'ALL',
  DraftType = 'DRAFT',
  FinishedType = 'FINISHED',
  PublishedType = 'PUBLISHED'
}

export type ProductSubscriptionType = {
  __typename?: 'ProductSubscription';
  billingCyclesComplete: Scalars['Int']['output'];
  buyerEmail?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodEnd: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nextRenewAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  pastDueSince?: Maybe<Scalars['DateTime']['output']>;
  platformId: Scalars['ID']['output'];
  product: ProductType;
  productId: Scalars['ID']['output'];
  promocode?: Maybe<SubscriptionPromocodeType>;
  renewAttempts: Scalars['Int']['output'];
  renewDeadlineAt?: Maybe<Scalars['DateTime']['output']>;
  renewErrorReason?: Maybe<RenewErrorReasonType>;
  renewSubscription: Scalars['Boolean']['output'];
  revenue: AmountType;
  startAt: Scalars['DateTime']['output'];
  status: SubscriptionStatusType;
  userId: Scalars['ID']['output'];
};

export enum ProductTypeType {
  PpvType = 'PPV',
  SubscriptionType = 'SUBSCRIPTION'
}

export type PromocodeType = {
  __typename?: 'Promocode';
  activations: Scalars['Int']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  finishAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  productIds: Array<Scalars['ID']['output']>;
  promocodeCampaign?: Maybe<PromocodeCampaignType>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  totalRevenue: PromocodeRevenueType;
  trialPeriod?: Maybe<Scalars['Int']['output']>;
  type: PromocodeTypeType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromocodeCampaignType = {
  __typename?: 'PromocodeCampaign';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type PromocodeConnectionType = {
  __typename?: 'PromocodeConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PromocodeType>;
};

export type PromocodeRevenueType = {
  __typename?: 'PromocodeRevenue';
  currency: ProductCurrencyType;
  value: Scalars['Float']['output'];
};

export enum PromocodeTypeType {
  DiscountType = 'DISCOUNT',
  TrialType = 'TRIAL'
}

export type PromocodesFilterInputType = {
  promocodeCampaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PullStateType = {
  __typename?: 'PullState';
  attempt: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<StreamErrorType>;
  maxAttempts: Scalars['Int']['output'];
  sourceUrl: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: PullStatusType;
};

export enum PullStatusType {
  FailedType = 'FAILED',
  RetryingType = 'RETRYING',
  RunningType = 'RUNNING',
  StoppedType = 'STOPPED'
}

export type QueryType = {
  __typename?: 'Query';
  analyticsSales: AnalyticsSalesResultType;
  analyticsUsers: AnalyticsUsersResultType;
  analyticsViews: AnalyticsViewsResultType;
  assistantConversation?: Maybe<AssistantConversationType>;
  assistantConversations: AssistantConversationConnectionType;
  /** Оценка сверху: отписанные отсеются при отправке */
  audienceEstimate: AudienceEstimateType;
  autocompleteAvailableOrganizations: AutocompleteWithIdType;
  autocompleteLinks: AutocompleteWithIdType;
  autocompletePlatformPages: AutocompleteWithIdType;
  autocompleteProducts: AutocompleteWithIdType;
  autocompletePromocodeCampaigns: AutocompleteWithIdType;
  autocompleteTagTypes: AutocompleteWithIdType;
  autocompleteTags: AutocompleteWithIdType;
  automation: AutomationType;
  /** Участники цепочки: новые сверху, курсор after, не больше 50 за раз. Право read Automation */
  automationEnrollments: AutomationEnrollmentPageType;
  /** Ошибки несохранённого графа автоматизации, без записи */
  automationGraphIssues: Array<AutomationGraphIssueType>;
  /** Разрешённые узлы, выходы, триггеры и пределы графа вида сценария */
  automationGraphRules: AutomationGraphRulesType;
  /** Сколько прохождений стоит на шаге (диалог удаления шага). Право read Automation */
  automationNodeActiveCount: Scalars['Int']['output'];
  /** Сценарии и рассылки текущей платформы. Нужен фичефлаг MARKETING_EMAILS */
  automations: AutomationConnectionType;
  avatar: AvatarType;
  avatars: AvatarConnectionType;
  banner: BannerType;
  banners: BannerConnectionType;
  /**
   * Библиотеки Stream, видимые по переданному аккаунтному ключу. Ключ идёт
   * аргументом, а не читается из платформы: на момент выбора библиотеки он
   * ещё нигде не сохранён.
   */
  bunnyAccountLibraries: Array<BunnyAccountLibraryType>;
  chatBans: ChatBanConnectionType;
  chatMessages: ChatMessageConnectionType;
  collectionTypes: Array<CollectionTypeType>;
  /**
   * Записи 2257 конкретного тайтла или продукта. Ровно один из аргументов
   * обязателен. Пустой список означает «записей нет»: карточка показывает
   * предупреждение, публикацию это не блокирует.
   */
  complianceRecords: Array<ComplianceRecordType>;
  contactList: ContactListType;
  contactLists: ContactListConnectionType;
  content: ContentType;
  /** Прикрепления контента с результатами */
  contentPolls: Array<ContentPollType>;
  contentTimecodes?: Maybe<ContentTimecodesType>;
  contents: ContentConnectionType;
  contractPayments: ContractPaymentConnectionType;
  countryAccess: CountryAccessType;
  countryAccesses: CountryAccessConnectionType;
  currentPlatform?: Maybe<PlatformType>;
  currentUser?: Maybe<UserType>;
  /**
   * Поиск банка по БИК в DaData.
   * Возвращает точную информацию о банке.
   */
  dadataFindBankByBic: DaDataBankResponseType;
  /**
   * Поиск организации по ИНН в DaData.
   * Возвращает точную информацию об организации.
   */
  dadataFindOrganizationByInn: DaDataOrganizationResponseType;
  /**
   * Получение подсказок по адресам из DaData.
   * Поддерживает поиск по частичному адресу, почтовому индексу, ФИАС ID.
   */
  dadataSuggestAddress: DaDataAddressResponseType;
  /**
   * Получение подсказок по банкам из DaData.
   * Поиск по названию банка, БИК.
   */
  dadataSuggestBank: DaDataBankResponseType;
  /**
   * Получение подсказок по организациям из DaData.
   * Поиск по названию, ИНН, ОГРН организации.
   */
  dadataSuggestOrganization: DaDataOrganizationResponseType;
  dashboard: DashboardType;
  disputes: DisputeConnectionType;
  /** Письмо библиотеки. Нужен фичефлаг MARKETING_EMAILS */
  emailTemplate: EmailTemplateType;
  /** Живое превью несохранённого варианта письма */
  emailTemplatePreview: EmailPreviewType;
  /** Библиотека писем текущей платформы */
  emailTemplates: EmailTemplateConnectionType;
  eventCancelPreview: EventCancelPreviewType;
  eventCancelProgress?: Maybe<EventCancelProgressType>;
  file: FileType;
  image: ImageType;
  images: ImageConnectionType;
  /**
   * Возможности инстанса. Не зависит от организации и платформы: кабинет
   * спрашивает их до и независимо от currentPlatform.
   */
  instance: InstanceType;
  languages: Array<LanguageType>;
  link: LinkType;
  links: LinkConnectionType;
  marketingContacts: MarketingContactConnectionType;
  /** Нужен фичефлаг MARKETING_EMAILS */
  marketingLimits: MarketingLimitsType;
  /** Нужен фичефлаг MARKETING_EMAILS */
  marketingQuotaUsage: MarketingQuotaUsageType;
  /** Текущий диалог сотрудника с помощником (последний за сутки), для восстановления ленты */
  myPartnerAssistantConversation?: Maybe<PartnerAssistantConversationType>;
  organizationUser: OrganizationUserType;
  /** Сотрудники текущей организации, включая отключённых. */
  organizationUsers: OrganizationUserConnectionType;
  payments: PaymentConnectionType;
  platformCustomCover: PlatformCustomCoverType;
  platformCustomCovers: PlatformCustomCoverConnectionType;
  platformMenuItem: PlatformMenuItemType;
  platformMenuItems: PlatformMenuItemConnectionType;
  platformPage: PlatformPageType;
  platformPages: PlatformPageConnectionType;
  /** Опрос библиотеки. Нужен фичефлаг PLAYER_POLLS */
  poll: PollType;
  /** Библиотека опросов текущей платформы */
  polls: PollConnectionType;
  post: PostType;
  posts: PostConnectionType;
  privateFile: PrivateFileType;
  product: ProductType;
  productPurchases: ProductPurchaseConnectionType;
  products: ProductConnectionType;
  promocode?: Maybe<PromocodeType>;
  promocodes: PromocodeConnectionType;
  refunds: RefundConnectionType;
  report: ReportType;
  reports: ReportConnectionType;
  revenueShareReports: RevenueShareReportConnectionType;
  storageBreakdown: StorageBreakdownType;
  streamClips: Array<StreamClipType>;
  streamEntrypoint: StreamEntrypointType;
  streamEntrypoints: StreamEntrypointConnectionType;
  streamingUsage: StreamingUsageType;
  subscriptions: SubscriptionConnectionType;
  supportRequest?: Maybe<SupportRequestType>;
  /** Сотрудники организации, которым можно назначить обращение (роли admin и users) */
  supportRequestAssignees: Array<UserType>;
  /** Исходный HTML входящего письма для просмотра в песочнице */
  supportRequestMessageOriginal?: Maybe<Scalars['String']['output']>;
  supportRequests: SupportRequestConnectionType;
  supportRequestsOpenCount: Scalars['Int']['output'];
  tag: TagType;
  /** Тип тега целиком: форма тега строит по customFields динамические поля */
  tagType: TagTypeType;
  tags: TagConnectionType;
  usageHistory: AnalyticsChartType;
  user: UserType;
  users: UserConnectionType;
  videoFile?: Maybe<VideoFileType>;
  /** Видео текущей платформы, новые первыми. */
  videoFiles: Array<VideoFileType>;
  widget: WidgetType;
  widgets: WidgetConnectionType;
};


export type QueryAnalyticsSalesArgsType = {
  filter: AnalyticsSalesFilterInputType;
};


export type QueryAnalyticsUsersArgsType = {
  filter: AnalyticsUsersFilterInputType;
};


export type QueryAnalyticsViewsArgsType = {
  filter: AnalyticsViewsFilterInputType;
};


export type QueryAssistantConversationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAssistantConversationsArgsType = {
  filter?: InputMaybe<AssistantConversationsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudienceEstimateArgsType = {
  audience?: InputMaybe<AudienceFilterInputType>;
  contactListIds: Array<Scalars['ID']['input']>;
};


export type QueryAutocompleteAvailableOrganizationsArgsType = {
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteLinksArgsType = {
  filter?: InputMaybe<AutocompleteLinksFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompletePlatformPagesArgsType = {
  filter?: InputMaybe<AutocompletePlatformPagesFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteProductsArgsType = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  input?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductTypeType>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompletePromocodeCampaignsArgsType = {
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteTagTypesArgsType = {
  filter?: InputMaybe<AutocompleteTagTypesFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteTagsArgsType = {
  filter?: InputMaybe<AutocompleteTagsFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutomationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationEnrollmentsArgsType = {
  after?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AutomationEnrollmentStatusType>;
};


export type QueryAutomationGraphIssuesArgsType = {
  id: Scalars['ID']['input'];
  input: AutomationInputType;
};


export type QueryAutomationGraphRulesArgsType = {
  kind: AutomationKindType;
};


export type QueryAutomationNodeActiveCountArgsType = {
  id: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
};


export type QueryAutomationsArgsType = {
  kind?: InputMaybe<AutomationKindType>;
  kinds?: InputMaybe<Array<AutomationKindType>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AutomationStatusType>;
};


export type QueryAvatarArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAvatarsArgsType = {
  filter?: InputMaybe<AvatarsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBannerArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryBannersArgsType = {
  filter?: InputMaybe<BannersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBunnyAccountLibrariesArgsType = {
  accountApiKey: Scalars['String']['input'];
};


export type QueryChatBansArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatMessagesArgsType = {
  filter?: InputMaybe<ChatMessagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComplianceRecordsArgsType = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactListArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContactListsArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContentPollsArgsType = {
  contentId: Scalars['ID']['input'];
};


export type QueryContentTimecodesArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContentsArgsType = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContentsSortTypeType>;
};


export type QueryContractPaymentsArgsType = {
  filter?: InputMaybe<ContractPaymentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryAccessArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryCountryAccessesArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDadataFindBankByBicArgsType = {
  bic: Scalars['String']['input'];
};


export type QueryDadataFindOrganizationByInnArgsType = {
  inn: Scalars['String']['input'];
  kpp?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDadataSuggestAddressArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>>>;
  query: Scalars['String']['input'];
};


export type QueryDadataSuggestBankArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryDadataSuggestOrganizationArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>>>;
  query: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDisputesArgsType = {
  filter?: InputMaybe<DisputesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailTemplateArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryEmailTemplatePreviewArgsType = {
  input: EmailTemplateVariantInputType;
};


export type QueryEmailTemplatesArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventCancelPreviewArgsType = {
  productId: Scalars['ID']['input'];
};


export type QueryEventCancelProgressArgsType = {
  productId: Scalars['ID']['input'];
};


export type QueryFileArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryImageArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgsType = {
  filter?: InputMaybe<ImagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLanguagesArgsType = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLinkArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryLinksArgsType = {
  filter?: InputMaybe<LinksFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketingContactsArgsType = {
  listId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationUserArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationUsersArgsType = {
  filter?: InputMaybe<OrganizationUsersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentsArgsType = {
  filter?: InputMaybe<PaymentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformCustomCoverArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformCustomCoversArgsType = {
  filter?: InputMaybe<PlatformCustomCoversFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformMenuItemArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformMenuItemsArgsType = {
  filter?: InputMaybe<PlatformMenuItemsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformPageArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformPagesArgsType = {
  filter?: InputMaybe<PlatformPagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPollArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPollsArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPostArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPostsArgsType = {
  filter?: InputMaybe<PostsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPrivateFileArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryProductPurchasesArgsType = {
  filter?: InputMaybe<ProductPurchasesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductsArgsType = {
  countryAccessId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductStatusType>;
  types?: InputMaybe<Array<ProductTypeType>>;
};


export type QueryPromocodeArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPromocodesArgsType = {
  filter?: InputMaybe<PromocodesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRefundsArgsType = {
  filter?: InputMaybe<RefundsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryReportsArgsType = {
  filter?: InputMaybe<ReportsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRevenueShareReportsArgsType = {
  filter?: InputMaybe<RevenueShareReportsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStorageBreakdownArgsType = {
  onlyUnwatched?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StorageBreakdownSortType>;
};


export type QueryStreamClipsArgsType = {
  contentId: Scalars['ID']['input'];
};


export type QueryStreamEntrypointArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryStreamEntrypointsArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionsArgsType = {
  filter?: InputMaybe<SubscriptionsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportRequestArgsType = {
  id: Scalars['ID']['input'];
};


export type QuerySupportRequestMessageOriginalArgsType = {
  id: Scalars['ID']['input'];
};


export type QuerySupportRequestsArgsType = {
  filter?: InputMaybe<SupportRequestsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryTagTypeArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryTagsArgsType = {
  filter?: InputMaybe<TagsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsageHistoryArgsType = {
  calendarInterval?: InputMaybe<CalendarIntervalType>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};


export type QueryUserArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgsType = {
  filter?: InputMaybe<UsersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideoFileArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetsArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordingTrimType = {
  __typename?: 'RecordingTrim';
  endSeconds: Scalars['Float']['output'];
  error?: Maybe<RecordingTrimErrorType>;
  progress?: Maybe<Scalars['Float']['output']>;
  startSeconds: Scalars['Float']['output'];
  status: RecordingTrimStatusType;
};

export type RecordingTrimErrorType = {
  __typename?: 'RecordingTrimError';
  code: RecordingTrimErrorCodeType;
  message: Scalars['String']['output'];
};

export enum RecordingTrimErrorCodeType {
  ClipErrorType = 'CLIP_ERROR',
  CloudflareApiType = 'CLOUDFLARE_API',
  CopyErrorType = 'COPY_ERROR',
  CutErrorType = 'CUT_ERROR',
  DownloadErrorType = 'DOWNLOAD_ERROR',
  TimeoutType = 'TIMEOUT',
  TooLargeType = 'TOO_LARGE',
  TooLongType = 'TOO_LONG',
  WorkerLostType = 'WORKER_LOST'
}

export enum RecordingTrimStatusType {
  ClippingType = 'CLIPPING',
  CopyingType = 'COPYING',
  CuttingType = 'CUTTING',
  DoneType = 'DONE',
  DownloadingType = 'DOWNLOADING',
  FailedType = 'FAILED',
  PendingType = 'PENDING'
}

export type RefundType = {
  __typename?: 'Refund';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<AmountType>;
  id: Scalars['ID']['output'];
  initiatedBy: Scalars['String']['output'];
  /** Возврат учтён только у нас: деньги покупателю партнёр возвращает руками в кабинете провайдера (старые платежи Paynet). */
  manual: Scalars['Boolean']['output'];
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  payment?: Maybe<PaymentType>;
  providerFeeAmount?: Maybe<AmountType>;
  reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  status: RefundStatusType;
};

export type RefundConnectionType = {
  __typename?: 'RefundConnection';
  count: Scalars['Int']['output'];
  nodes: Array<RefundType>;
};

export enum RefundStatusType {
  FailedType = 'FAILED',
  PendingType = 'PENDING',
  SucceededType = 'SUCCEEDED'
}

export type RefundsFilterInputType = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  providers?: InputMaybe<Array<PaymentProviderType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RefundStatusType>;
};

export enum RenewErrorReasonType {
  CardDeclinedType = 'cardDeclined',
  CardExpiredType = 'cardExpired',
  ChargeFailedType = 'chargeFailed',
  InsufficientFundsType = 'insufficientFunds',
  NoPaymentMethodType = 'noPaymentMethod'
}

export type ReplySupportRequestInputType = {
  /** Внутренняя заметка: видна только команде, зрителю не уходит */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ответ сразу решает обращение */
  resolve?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  /** Ответ отправлен помощником партнёра (ставит сервер помощника) */
  viaAssistant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportType = {
  __typename?: 'Report';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<UserType>;
  downloadedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<ReportErrorType>;
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  filter?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  progress: Scalars['Float']['output'];
  rowCount?: Maybe<Scalars['Int']['output']>;
  status: ReportStatusType;
  type: ReportTypeType;
  widget?: Maybe<AnalyticsWidgetType>;
};

export type ReportConnectionType = {
  __typename?: 'ReportConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ReportType>;
};

export type ReportDownloadType = {
  __typename?: 'ReportDownload';
  url: Scalars['URL']['output'];
};

export type ReportErrorType = {
  __typename?: 'ReportError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ReportStatusType {
  CompletedType = 'COMPLETED',
  ErrorType = 'ERROR',
  PendingType = 'PENDING',
  ProcessingType = 'PROCESSING'
}

export enum ReportTypeType {
  AnalyticsWidgetType = 'ANALYTICS_WIDGET',
  ContractPaymentsType = 'CONTRACT_PAYMENTS',
  DisputesType = 'DISPUTES',
  LinksType = 'LINKS',
  MarketingContactsType = 'MARKETING_CONTACTS',
  PaymentsType = 'PAYMENTS',
  ProductsType = 'PRODUCTS',
  PromocodesType = 'PROMOCODES',
  PurchasesType = 'PURCHASES',
  RefundsType = 'REFUNDS',
  RevenueShareReportsType = 'REVENUE_SHARE_REPORTS',
  StreamsType = 'STREAMS',
  SubscriptionsType = 'SUBSCRIPTIONS',
  UsersType = 'USERS',
  VideosType = 'VIDEOS'
}

export type ReportsFilterInputType = {
  status?: InputMaybe<ReportStatusType>;
  type?: InputMaybe<ReportTypeType>;
};

export type RestreamDestinationType = {
  __typename?: 'RestreamDestination';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  streamKey: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RevenueShareReportType = {
  __typename?: 'RevenueShareReport';
  corrections: Array<RevenueShareReportCorrectionType>;
  createdAt: Scalars['DateTime']['output'];
  disputesAmount: AmountType;
  disputesCount: Scalars['Int']['output'];
  feeAmount: AmountType;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  period: Scalars['String']['output'];
  purchasesCount: Scalars['Int']['output'];
  refundsAmount: AmountType;
  refundsCount: Scalars['Int']['output'];
  reportAmount: AmountType;
  reportAmountInContractCurrency?: Maybe<AmountType>;
  salesAmount: AmountType;
  status: Scalars['String']['output'];
};

export type RevenueShareReportConnectionType = {
  __typename?: 'RevenueShareReportConnection';
  count: Scalars['Int']['output'];
  nodes: Array<RevenueShareReportType>;
};

export type RevenueShareReportCorrectionType = {
  __typename?: 'RevenueShareReportCorrection';
  amount: AmountType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
};

export type RevenueShareReportsFilterInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SelectOptionType = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectOptionInputType = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ServiceBillingTypeType {
  OneTimeType = 'ONE_TIME',
  RecurringType = 'RECURRING'
}

export type SetSupportRequestStatusInputType = {
  /** OPEN: открыть снова; CLOSED: решить */
  status: SupportRequestStatusType;
};

export type SignInInputType = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
};

export type SignInOutputType = {
  __typename?: 'SignInOutput';
  token: Scalars['String']['output'];
};

export type StorageBreakdownType = {
  __typename?: 'StorageBreakdown';
  items: Array<StorageBreakdownItemType>;
  totalCount: Scalars['Int']['output'];
  totals: StorageBreakdownTotalsType;
};

export type StorageBreakdownItemType = {
  __typename?: 'StorageBreakdownItem';
  contentId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Длительность видео в секундах, для показа чч:мм:сс. */
  durationSeconds: Scalars['Int']['output'];
  /**
   * true, когда storageBytes и цена получены оценкой, а не точным размером от
   * провайдера: так помечены видео Bunny, залитые до появления поля
   * Video.storageBytes (их объём прикинут пропорционально длительности от
   * общего объёма библиотеки). У Cloudflare всегда false.
   */
  estimated: Scalars['Boolean']['output'];
  hasPurchases: Scalars['Boolean']['output'];
  onSale: Scalars['Boolean']['output'];
  /**
   * Объём видео у провайдера, байты. Заполнен только у провайдеров с
   * тарификацией по объёму (Bunny) и пуст у Cloudflare, который размера файла
   * не отдаёт.
   */
  storageBytes?: Maybe<Scalars['Float']['output']>;
  storageCostUsdMonth: Scalars['Float']['output'];
  /**
   * Длительность в минутах. У Cloudflare по ней считается цена, у Bunny это
   * справочная величина: там платят за объём.
   */
  storageMinutes: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  viewsLast90Days: Scalars['Int']['output'];
  watchedMinutesLast90Days: Scalars['Float']['output'];
};

export enum StorageBreakdownSortType {
  CreatedAscType = 'CREATED_ASC',
  StorageCostDescType = 'STORAGE_COST_DESC',
  ViewsAscType = 'VIEWS_ASC'
}

export type StorageBreakdownTotalsType = {
  __typename?: 'StorageBreakdownTotals';
  contentsCount: Scalars['Int']['output'];
  /** Суммарная длительность всех видео платформы в секундах. */
  durationSeconds: Scalars['Int']['output'];
  /**
   * Занятый платформой объём, байты: у Bunny это реальный объём библиотеки,
   * у Cloudflare пусто.
   */
  storageBytes?: Maybe<Scalars['Float']['output']>;
  storageCostUsdMonth: Scalars['Float']['output'];
  storageMinutes: Scalars['Float']['output'];
  unwatchedCostUsdMonth: Scalars['Float']['output'];
  unwatchedCount: Scalars['Int']['output'];
};

export type StreamType = {
  __typename?: 'Stream';
  autoPublishRecord: Scalars['Boolean']['output'];
  dvrEnabled: Scalars['Boolean']['output'];
  enableRecord: Scalars['Boolean']['output'];
  entrypoint?: Maybe<StreamEntrypointType>;
  finishAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isChatEnabled: Scalars['Boolean']['output'];
  lastError?: Maybe<StreamErrorType>;
  lastPublishAt?: Maybe<Scalars['DateTime']['output']>;
  liveConnected: Scalars['Boolean']['output'];
  monitoring: LiveInputMonitoringType;
  playback?: Maybe<ContentPlaybackType>;
  pull?: Maybe<PullStateType>;
  recordContentId?: Maybe<Scalars['ID']['output']>;
  recordPlayback?: Maybe<ContentPlaybackType>;
  recordingTrim?: Maybe<RecordingTrimType>;
  restreamDestinations: Array<RestreamDestinationType>;
  restreamDestinationsLimit: Scalars['Int']['output'];
  rtmpsStreamKey: Scalars['String']['output'];
  rtmpsUrl: Scalars['URL']['output'];
  signal?: Maybe<StreamSignalType>;
  srtPassphrase: Scalars['String']['output'];
  srtStreamId: Scalars['String']['output'];
  srtUrl: Scalars['URL']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: StreamStatusType;
};


export type StreamMonitoringArgsType = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type StreamClipType = {
  __typename?: 'StreamClip';
  content: ContentType;
  downloadUrl?: Maybe<Scalars['URL']['output']>;
  durationSeconds: Scalars['Int']['output'];
  previewUrl?: Maybe<Scalars['URL']['output']>;
  startSeconds: Scalars['Int']['output'];
};

export type StreamEntrypointType = {
  __typename?: 'StreamEntrypoint';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  liveConnected: Scalars['Boolean']['output'];
  monitoring: LiveInputMonitoringType;
  playback?: Maybe<ContentPlaybackType>;
  pull?: Maybe<PullStateType>;
  rtmpsPlaybackStreamKey?: Maybe<Scalars['String']['output']>;
  rtmpsPlaybackUrl?: Maybe<Scalars['String']['output']>;
  rtmpsStreamKey: Scalars['String']['output'];
  rtmpsUrl: Scalars['URL']['output'];
  signal?: Maybe<StreamSignalType>;
  srtPassphrase: Scalars['String']['output'];
  srtPlaybackPassphrase?: Maybe<Scalars['String']['output']>;
  srtPlaybackStreamId?: Maybe<Scalars['String']['output']>;
  srtPlaybackUrl?: Maybe<Scalars['String']['output']>;
  srtStreamId: Scalars['String']['output'];
  srtUrl: Scalars['URL']['output'];
  stream?: Maybe<ContentType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type StreamEntrypointMonitoringArgsType = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type StreamEntrypointConnectionType = {
  __typename?: 'StreamEntrypointConnection';
  count: Scalars['Int']['output'];
  nodes: Array<StreamEntrypointType>;
};

export type StreamErrorType = {
  __typename?: 'StreamError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type StreamSignalType = {
  __typename?: 'StreamSignal';
  checkedAt: Scalars['DateTime']['output'];
  lastSegmentAt?: Maybe<Scalars['DateTime']['output']>;
  lastSegmentSeq?: Maybe<Scalars['Int']['output']>;
  since: Scalars['DateTime']['output'];
  state: StreamSignalStateType;
};

export enum StreamSignalStateType {
  DisconnectedType = 'DISCONNECTED',
  NoVideoType = 'NO_VIDEO',
  OkType = 'OK'
}

export enum StreamStatusType {
  CancelledType = 'CANCELLED',
  FinishedType = 'FINISHED',
  PendingType = 'PENDING',
  StartedType = 'STARTED'
}

export type StreamingUsageType = {
  __typename?: 'StreamingUsage';
  alerts: Array<UsageAlertType>;
  analyticsScopeMissing: Scalars['Boolean']['output'];
  billingScopeMissing: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  cost?: Maybe<StreamingUsageCostType>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  storage?: Maybe<StreamingUsageStorageType>;
  subscription?: Maybe<StreamingUsageSubscriptionType>;
  viewedMinutes?: Maybe<Scalars['Float']['output']>;
};

export type StreamingUsageCostType = {
  __typename?: 'StreamingUsageCost';
  delivery?: Maybe<Scalars['Float']['output']>;
  /**
   * Стоимость хранения за текущий месяц, USD. Заполнена у провайдеров, которые
   * тарифицируют объём (Bunny: занятые гигабайты по тарифу
   * bunny.pricing.storageUsdPerGbMonth), и пуста у Cloudflare, где хранение
   * входит в подписку и отдельной строкой не считается.
   */
  storage?: Maybe<Scalars['Float']['output']>;
  subscription?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type StreamingUsageStorageType = {
  __typename?: 'StreamingUsageStorage';
  /** Лимит объёма. У Bunny лимита на библиотеку нет, поэтому всегда пусто. */
  limitBytes?: Maybe<Scalars['Float']['output']>;
  limitMinutes: Scalars['Float']['output'];
  /**
   * Занятое место в байтах. Заполнено у провайдеров, которые тарифицируют
   * объём (Bunny), и пусто у тех, кто тарифицирует минуты (Cloudflare).
   */
  usedBytes?: Maybe<Scalars['Float']['output']>;
  usedMinutes: Scalars['Float']['output'];
  videoCount: Scalars['Int']['output'];
};

export type StreamingUsageSubscriptionType = {
  __typename?: 'StreamingUsageSubscription';
  currency: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
};

export type SubscriptionType = {
  __typename?: 'Subscription';
  contentStatusChanged: ContentType;
  contentStreamStatusChanged: ContentType;
};


export type SubscriptionContentStatusChangedArgsType = {
  id: Scalars['ID']['input'];
};


export type SubscriptionContentStreamStatusChangedArgsType = {
  id: Scalars['ID']['input'];
};

export type SubscriptionConnectionType = {
  __typename?: 'SubscriptionConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ProductSubscriptionType>;
};

export type SubscriptionPromocodeType = {
  __typename?: 'SubscriptionPromocode';
  code: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatusType {
  ActiveType = 'ACTIVE',
  CanceledType = 'CANCELED',
  ExpiredType = 'EXPIRED',
  PastDueType = 'PAST_DUE'
}

export type SubscriptionsFilterInputType = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  renewSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatusType>;
};

export type SupportRequestType = {
  __typename?: 'SupportRequest';
  /** Ответственный сотрудник */
  assignee?: Maybe<UserType>;
  /** Реплики зрителя с помощником до обращения */
  assistantMessages: Array<AssistantMessageType>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Технические детали к обращению, только для сотрудников арены */
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  /** Лента переписки, с внутренними заметками */
  messages: Array<SupportRequestMessageType>;
  /** Номер обращения в платформе */
  number?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<PaymentType>;
  platform?: Maybe<PlatformType>;
  status: SupportRequestStatusType;
  /** Первая строка текста обращения */
  subject: Scalars['String']['output'];
  type: SupportRequestTypeType;
  user?: Maybe<UserType>;
  /** Касание зрителя на момент начала диалога (у обращения: касание его диалога) */
  utm?: Maybe<AttributionTouchType>;
  /** С какого момента ждёт ответа сторона, которая должна ответить */
  waitingSince?: Maybe<Scalars['DateTime']['output']>;
};

/** Вложение письма зрителя, url подписан на час */
export type SupportRequestAttachmentType = {
  __typename?: 'SupportRequestAttachment';
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type SupportRequestConnectionType = {
  __typename?: 'SupportRequestConnection';
  count: Scalars['Int']['output'];
  nodes: Array<SupportRequestType>;
};

export enum SupportRequestEventType {
  AssignedType = 'ASSIGNED',
  AutoClosedType = 'AUTO_CLOSED',
  ForeignSenderType = 'FOREIGN_SENDER',
  ReopenedType = 'REOPENED',
  ReopenBlockedType = 'REOPEN_BLOCKED',
  ResolvedType = 'RESOLVED',
  UnassignedType = 'UNASSIGNED'
}

/** Сообщение ленты обращения: зритель, сотрудник или системное событие */
export type SupportRequestMessageType = {
  __typename?: 'SupportRequestMessage';
  attachments: Array<SupportRequestAttachmentType>;
  author: SupportRequestMessageAuthorType;
  body: Scalars['String']['output'];
  channel: SupportRequestMessageChannelType;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<SupportRequestEventType>;
  eventUser?: Maybe<UserType>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  /** Есть исходный HTML письма (supportRequestMessageOriginal) */
  hasOriginal: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Внутренняя заметка или служебное событие, зрителю не видно */
  internal: Scalars['Boolean']['output'];
  skippedAttachments: Scalars['Int']['output'];
  staff?: Maybe<UserType>;
  /** Отправлено помощником партнёра по подтверждённому плану */
  viaAssistant: Scalars['Boolean']['output'];
};

export enum SupportRequestMessageAuthorType {
  StaffType = 'STAFF',
  SystemType = 'SYSTEM',
  ViewerType = 'VIEWER'
}

export enum SupportRequestMessageChannelType {
  CabinetType = 'CABINET',
  EmailType = 'EMAIL',
  SiteType = 'SITE',
  SystemType = 'SYSTEM'
}

export enum SupportRequestStatusType {
  CancelledType = 'CANCELLED',
  ClosedType = 'CLOSED',
  DraftType = 'DRAFT',
  OpenType = 'OPEN',
  ViewerRepliedType = 'VIEWER_REPLIED',
  WaitingViewerType = 'WAITING_VIEWER'
}

export enum SupportRequestTypeType {
  AccessProblemType = 'ACCESS_PROBLEM',
  OtherType = 'OTHER',
  PaymentProblemType = 'PAYMENT_PROBLEM',
  RefundType = 'REFUND'
}

export type SupportRequestsFilterInputType = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** true: только ждущие ответа команды (OPEN, VIEWER_REPLIED) */
  needsReply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Текст обращения или номер (12, #12) */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupportRequestStatusType>;
  type?: InputMaybe<SupportRequestTypeType>;
};

export type TagType = {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<CustomFieldValueType>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageType>;
  organization: OrganizationType;
  path?: Maybe<Scalars['String']['output']>;
  platformPage?: Maybe<PlatformPageType>;
  platformPageId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<TagTypeType>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['URL']['output']>;
  verticalImage?: Maybe<ImageType>;
};

export type TagConnectionType = {
  __typename?: 'TagConnection';
  count: Scalars['Int']['output'];
  nodes: Array<TagType>;
};

/**
 * Какая картинка у тегов этого типа основная: HORIZONTAL это 16:9 (image),
 * VERTICAL это портрет 2:3 (verticalImage). Форма тега открывает этот слот
 * первым, чтобы для актёров не заливали 16:9 по ошибке.
 */
export enum TagPreviewTypeType {
  HorizontalType = 'HORIZONTAL',
  VerticalType = 'VERTICAL'
}

export type TagTypeType = {
  __typename?: 'TagType';
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomFieldType>;
  defaultPreviewType: TagPreviewTypeType;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: OrganizationType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TagsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ThumbnailFormatType {
  DefaultType = 'DEFAULT',
  HighType = 'HIGH',
  MaxresType = 'MAXRES',
  MediumType = 'MEDIUM',
  SmallType = 'SMALL'
}

export type TimecodeType = {
  __typename?: 'Timecode';
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  icon: TimecodeIconType;
  id: Scalars['ID']['output'];
  linkedContent?: Maybe<ContentType>;
  position?: Maybe<AnnotationPositionType>;
  time: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: TimecodeTypeType;
};

export enum TimecodeIconType {
  AwesomeType = 'AWESOME',
  BaseballType = 'BASEBALL',
  BasketballType = 'BASKETBALL',
  BoltType = 'BOLT',
  CameraType = 'CAMERA',
  CelebrationType = 'CELEBRATION',
  EmotionsType = 'EMOTIONS',
  EsportsType = 'ESPORTS',
  FireType = 'FIRE',
  FitnessType = 'FITNESS',
  FlagType = 'FLAG',
  FootballType = 'FOOTBALL',
  FullscreenType = 'FULLSCREEN',
  GolfType = 'GOLF',
  HandballType = 'HANDBALL',
  HeartType = 'HEART',
  HockeyType = 'HOCKEY',
  HotFireType = 'HOT_FIRE',
  InsightsType = 'INSIGHTS',
  KabaddiType = 'KABADDI',
  LightningType = 'LIGHTNING',
  MicType = 'MIC',
  MmaType = 'MMA',
  MotorsportsType = 'MOTORSPORTS',
  MovieType = 'MOVIE',
  PlayArrowType = 'PLAY_ARROW',
  PlayCircleType = 'PLAY_CIRCLE',
  RecordVoiceType = 'RECORD_VOICE',
  RedCardType = 'RED_CARD',
  ReplayType = 'REPLAY',
  RugbyType = 'RUGBY',
  RunningType = 'RUNNING',
  SkiingType = 'SKIING',
  SlowMotionType = 'SLOW_MOTION',
  SoccerType = 'SOCCER',
  SpeedType = 'SPEED',
  SportsType = 'SPORTS',
  StarType = 'STAR',
  SwimmingType = 'SWIMMING',
  TennisType = 'TENNIS',
  ThumbDownType = 'THUMB_DOWN',
  ThumbUpType = 'THUMB_UP',
  TimerType = 'TIMER',
  TrendingType = 'TRENDING',
  TrophyType = 'TROPHY',
  VerySatisfiedType = 'VERY_SATISFIED',
  VideocamType = 'VIDEOCAM',
  VolleyballType = 'VOLLEYBALL',
  VolumeUpType = 'VOLUME_UP',
  WhistleType = 'WHISTLE',
  YellowCardType = 'YELLOW_CARD'
}

export type TimecodeInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  icon: TimecodeIconType;
  linkedContentId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<AnnotationPositionType>;
  time: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<TimecodeTypeType>;
};

export enum TimecodeTypeType {
  AnnotationType = 'ANNOTATION',
  MarkerType = 'MARKER'
}

export type TusVideoUploadHeaderType = {
  __typename?: 'TusVideoUploadHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Реквизиты resumable-загрузки по протоколу tus. Используется провайдерами,
 * у которых нет прямого upload URL: браузер шлёт файл на endpoint, добавляя
 * к каждому запросу эти заголовки. Ни один секрет провайдера в них не
 * попадает, только его подписанная производная с ограниченным сроком.
 */
export type TusVideoUploadPayloadType = {
  __typename?: 'TusVideoUploadPayload';
  endpoint: Scalars['URL']['output'];
  headers: Array<TusVideoUploadHeaderType>;
  videoUid: Scalars['String']['output'];
};

export type UpdateBunnySettingsInputType = {
  /** Аккаунтный ключ bunny.net. Нужен только плитке расхода. */
  accountApiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey: Scalars['String']['input'];
  cdnHostname: Scalars['String']['input'];
  cdnTokenKey: Scalars['String']['input'];
  libraryId: Scalars['String']['input'];
  readOnlyApiKey: Scalars['String']['input'];
};

export type UpdateComplianceRecordInputType = {
  note?: InputMaybe<Scalars['String']['input']>;
  performerName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentInputType = {
  accessStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestrictions?: InputMaybe<Scalars['Int']['input']>;
  collectionContentSort?: InputMaybe<CollectionContentSortType>;
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectionTypeId?: InputMaybe<Scalars['ID']['input']>;
  countryAccessId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideChildrenContentFromLists?: InputMaybe<Scalars['Boolean']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  isChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  verticalPreviewId?: InputMaybe<Scalars['ID']['input']>;
  videoFileName?: InputMaybe<Scalars['String']['input']>;
  videoUid?: InputMaybe<Scalars['String']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateContentManyInputType = {
  collectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateContentNestedSortInputType = {
  collectionId: Scalars['ID']['input'];
  sortValue: Scalars['Int']['input'];
};

export type UpdateContentsInputType = {
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCountryAccessInputType = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CountryAccessTypeType>;
};

export type UpdateCurrentPlatformInputType = {
  acceptTermsOfServiceOnSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  complianceCustodianAddress?: InputMaybe<Scalars['String']['input']>;
  complianceCustodianName?: InputMaybe<Scalars['String']['input']>;
  customHTML?: InputMaybe<Scalars['String']['input']>;
  customHead?: InputMaybe<Scalars['String']['input']>;
  customTerms?: InputMaybe<Array<PlatformCustomTermInputType>>;
  defaultRowSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  faviconId?: InputMaybe<Scalars['ID']['input']>;
  footer?: InputMaybe<PlatformFooterInputType>;
  gaId?: InputMaybe<Scalars['String']['input']>;
  googleSiteVerification?: InputMaybe<Scalars['String']['input']>;
  hideableHeader?: InputMaybe<Scalars['Boolean']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  isFavoritesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeaturedVideosEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLikesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLiveReactionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  legalEntity?: InputMaybe<PlatformLegalEntityInputType>;
  liveReactionEmojis?: InputMaybe<Array<LiveReactionEmojiType>>;
  liveReactionPhrases?: InputMaybe<Array<Scalars['String']['input']>>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  marketingSettings?: InputMaybe<MarketingSettingsInputType>;
  parallelPremiumViewLimit?: InputMaybe<Scalars['Int']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  refundPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  streamSignalAlertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<PlatformThemeInputType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrentUserInputType = {
  agreeToMarketingNewsletters?: InputMaybe<Scalars['Boolean']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLinkInputType = {
  href?: InputMaybe<Scalars['String']['input']>;
  linkType?: InputMaybe<LinkTypeType>;
  reward?: InputMaybe<LinkRewardInputType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-ссылки, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  title?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformCustomCoverInputType = {
  align?: InputMaybe<Scalars['String']['input']>;
  alignMobile?: InputMaybe<Scalars['String']['input']>;
  background?: InputMaybe<PlatformCustomCoverBackgroundInputType>;
  brightness?: InputMaybe<Scalars['Float']['input']>;
  buttons?: InputMaybe<Array<PlatformCustomCoverButtonInputType>>;
  buttonsColor?: InputMaybe<Scalars['String']['input']>;
  buttonsSize?: InputMaybe<Scalars['String']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  subTitle?: InputMaybe<PlatformCustomCoverSubTitleInputType>;
  title?: InputMaybe<PlatformCustomCoverTitleInputType>;
  verticalAlign?: InputMaybe<Scalars['String']['input']>;
  verticalAlignMobile?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformCustomCoversInputType = {
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePlatformMenuItemInputType = {
  href?: InputMaybe<Scalars['String']['input']>;
  iconId?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<PlatformMenuItemDialogItemInputType>>;
  label?: InputMaybe<Scalars['String']['input']>;
  linkType?: InputMaybe<PlatformMenuItemLinkTypeType>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-пункта, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  type?: InputMaybe<PlatformMenuItemTypeType>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type UpdatePlatformMenuItemsInputType = {
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePlatformPageInputType = {
  blocks?: InputMaybe<Array<PlatformPageBlockInputType>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type UpdatePlatformPagesInputType = {
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePollInputType = {
  isMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<PollOptionInputType>>;
  question?: InputMaybe<Scalars['String']['input']>;
  resultsMode?: InputMaybe<PollResultsModeType>;
};

export type UpdatePostInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostsInputType = {
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateProductInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventFinishAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishSalesAt?: InputMaybe<Scalars['DateTime']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  perContentPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  prices?: InputMaybe<Array<ProductPriceInputType>>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  showContent?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductPurchaseInputType = {
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Автопродление подписки этой покупки. У покупки без подписки отказ:
   * продлевать нечего.
   */
  renewSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateProductsInputType = {
  id: Scalars['ID']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdatePromocodeInputType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  finishAt?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  promocodeCampaignId?: InputMaybe<Scalars['ID']['input']>;
  promocodeCampaignTitle?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  trialPeriod?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRestreamDestinationInputType = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStreamEntrypointInputType = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStreamInputType = {
  accessStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestrictions?: InputMaybe<Scalars['Int']['input']>;
  autoPublishRecord?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dvrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enableRecord?: InputMaybe<Scalars['Boolean']['input']>;
  hideInGeneralLists?: InputMaybe<Scalars['Boolean']['input']>;
  isChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  previewId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  verticalPreviewId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateStreamingSettingsInputType = {
  /**
   * Необязателен: аккаунтный токен видит один аккаунт, бэкенд находит его сам.
   * Нужен только для пользовательских токенов с несколькими аккаунтами.
   */
  accountId?: InputMaybe<Scalars['String']['input']>;
  apiToken: Scalars['String']['input'];
};

export type UpdateTagInputType = {
  customFieldValues?: InputMaybe<Array<CustomFieldValueInputType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  platformPageId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  verticalImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTagsInputType = {
  platformPageId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTimecodesInputType = {
  timecodes: Array<TimecodeInputType>;
};

export type UpdateWidgetInputType = {
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UploadAvatarInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadBannerInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadFileInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadImageInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadPrivateFileInputType = {
  file: Scalars['Upload']['input'];
};

export type UsageAlertType = {
  __typename?: 'UsageAlert';
  kind: UsageAlertKindType;
  severity: UsageAlertSeverityType;
  threshold: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export enum UsageAlertKindType {
  StorageNearLimitType = 'STORAGE_NEAR_LIMIT',
  ViewsSpikeType = 'VIEWS_SPIKE'
}

export enum UsageAlertSeverityType {
  CriticalType = 'CRITICAL',
  WarningType = 'WARNING'
}

export type UserType = {
  __typename?: 'User';
  /** Упакованные правила CASL (packRules). Отдаются только самому пользователю. */
  abilityRules: Scalars['JSON']['output'];
  agreeToMarketingNewsletters?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<AvatarType>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentOrganization?: Maybe<OrganizationType>;
  currentOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Роли в текущей организации. Отдаются только самому пользователю. */
  currentOrganizationRoles: Array<OrganizationRoleType>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Последнее известное касание зрителя. */
  lastUtm?: Maybe<AttributionTouchType>;
  /** Когда зритель включил рассылку и последнее касание в тот момент. */
  marketingConsent?: Maybe<MarketingConsentType>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PlatformType>;
  platformId?: Maybe<Scalars['ID']['output']>;
  /** Счётчики зрителя на текущей платформе, считаются даталоадерами. */
  purchasesCount: Scalars['Int']['output'];
  refundsCount: Scalars['Int']['output'];
  /** Первое касание на момент регистрации (User.registrationUtm), без срока. */
  registrationUtm?: Maybe<AttributionTouchType>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewsCount: Scalars['Int']['output'];
};

export type UserConnectionType = {
  __typename?: 'UserConnection';
  count: Scalars['Int']['output'];
  nodes: Array<UserType>;
};

export type UsersFilterInputType = {
  agreeToMarketingNewsletters?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UtmDimensionType {
  CampaignType = 'CAMPAIGN',
  ContentType = 'CONTENT',
  MediumType = 'MEDIUM',
  SourceType = 'SOURCE',
  TermType = 'TERM'
}

export type VerifyEmailOutputType = {
  __typename?: 'VerifyEmailOutput';
  token: Scalars['String']['output'];
};

export type VideoType = {
  __typename?: 'Video';
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isChatEnabled: Scalars['Boolean']['output'];
  readyToStream: Scalars['Boolean']['output'];
  transcodingError?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type VideoDownloadType = {
  __typename?: 'VideoDownload';
  error?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  status: VideoDownloadStatusType;
  url?: Maybe<Scalars['URL']['output']>;
};

export enum VideoDownloadStatusType {
  ErrorType = 'ERROR',
  NotRequestedType = 'NOT_REQUESTED',
  PreparingType = 'PREPARING',
  ReadyType = 'READY',
  UnavailableType = 'UNAVAILABLE'
}

export type VideoFileType = {
  __typename?: 'VideoFile';
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  playlistUrl?: Maybe<Scalars['URL']['output']>;
  posterUrl?: Maybe<Scalars['URL']['output']>;
  size: Scalars['Int']['output'];
  status: VideoFileStatusType;
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * Видео для фона обложки: HLS + постер после транскодинга.
 * Спека: docs/superpowers/specs/2026-09-04-video-covers-design.md.
 */
export enum VideoFileStatusType {
  FailedType = 'FAILED',
  ProcessingType = 'PROCESSING',
  QueuedType = 'QUEUED',
  ReadyType = 'READY',
  UploadingType = 'UPLOADING'
}

export type VideoFileUploadType = {
  __typename?: 'VideoFileUpload';
  headers: Array<VideoFileUploadHeaderType>;
  uploadUrl: Scalars['URL']['output'];
  videoFile: VideoFileType;
};

export type VideoFileUploadHeaderType = {
  __typename?: 'VideoFileUploadHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Провайдер видео платформы. Пустое значение означает дефолт инстанса.
 * Партнёр значение только читает, меняет его админ.
 */
export enum VideoProviderType {
  BunnyType = 'BUNNY',
  CloudflareType = 'CLOUDFLARE'
}

export type VideoUploadPayloadType = {
  __typename?: 'VideoUploadPayload';
  uploadUrl: Scalars['URL']['output'];
  videoUid: Scalars['String']['output'];
};

export type VisibilityConditionsType = {
  __typename?: 'VisibilityConditions';
  applicationPlatforms: VisibilityConditionsApplicationPlatformsType;
  countries: VisibilityConditionsCountriesType;
  userType?: Maybe<VisibilityConditionsUserTypeType>;
};

export enum VisibilityConditionsApplicationPlatformTypeType {
  AllType = 'ALL',
  ExcludeType = 'EXCLUDE',
  IncludeType = 'INCLUDE'
}

export type VisibilityConditionsApplicationPlatformsType = {
  __typename?: 'VisibilityConditionsApplicationPlatforms';
  platforms: Array<ApplicationPlatformType>;
  type: VisibilityConditionsApplicationPlatformTypeType;
};

export type VisibilityConditionsApplicationPlatformsInputType = {
  platforms?: InputMaybe<Array<ApplicationPlatformType>>;
  type?: InputMaybe<VisibilityConditionsApplicationPlatformTypeType>;
};

export type VisibilityConditionsCountriesType = {
  __typename?: 'VisibilityConditionsCountries';
  countryCodes: Array<Scalars['String']['output']>;
  type: VisibilityConditionsCountriesTypeType;
};

export type VisibilityConditionsCountriesInputType = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<VisibilityConditionsCountriesTypeType>;
};

export enum VisibilityConditionsCountriesTypeType {
  AllType = 'ALL',
  ExcludeType = 'EXCLUDE',
  IncludeType = 'INCLUDE'
}

export type VisibilityConditionsInputType = {
  applicationPlatforms?: InputMaybe<VisibilityConditionsApplicationPlatformsInputType>;
  countries?: InputMaybe<VisibilityConditionsCountriesInputType>;
  userType?: InputMaybe<VisibilityConditionsUserTypeType>;
};

export enum VisibilityConditionsUserTypeType {
  AdminType = 'ADMIN',
  AllType = 'ALL',
  GuestType = 'GUEST',
  NoneType = 'NONE',
  UserType = 'USER'
}

export type WidgetType = {
  __typename?: 'Widget';
  buttonColor: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  buttonTextColor: Scalars['String']['output'];
  buttonUrl: Scalars['String']['output'];
  clicks: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  ctr: Scalars['Float']['output'];
  hits: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WidgetConnectionType = {
  __typename?: 'WidgetConnection';
  count: Scalars['Int']['output'];
  nodes: Array<WidgetType>;
};

export type AnalyticsDurationByDateQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsDurationByDateQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', durationByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type AnalyticsRevenueByDateQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsRevenueByDateQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, revenueByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type AnalyticsSalesByCityQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByCityQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByCity: Array<{ __typename?: 'AnalyticsSalesCityBreakdown', city: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByCountryQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByCountryQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByCountry: Array<{ __typename?: 'AnalyticsSalesCountryBreakdown', countryCode: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByDateQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsSalesByDateQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', salesByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type AnalyticsSalesByDeviceOsQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
}>;


export type AnalyticsSalesByDeviceOsQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByDeviceOs: Array<{ __typename?: 'AnalyticsSalesDeviceBreakdown', label: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByDeviceTypeQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
}>;


export type AnalyticsSalesByDeviceTypeQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByDeviceType: Array<{ __typename?: 'AnalyticsSalesDeviceBreakdown', label: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByEmailCampaignQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByEmailCampaignQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByEmailCampaign: Array<{ __typename?: 'AnalyticsSalesEmailCampaignBreakdown', automationId: string, title: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByLinkQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByLinkQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByLink: Array<{ __typename?: 'AnalyticsSalesLinkBreakdown', linkId: string, title: string, sales: number, revenue: number, reward: number }> } };

export type AnalyticsSalesByProductQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByProductQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByProduct: Array<{ __typename?: 'AnalyticsProductBreakdown', productId: string, title: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByPromocodeQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsSalesByPromocodeQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByPromocode: Array<{ __typename?: 'AnalyticsPromocodeBreakdown', promocodeId: string, title: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByProviderQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
}>;


export type AnalyticsSalesByProviderQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByProvider: Array<{ __typename?: 'AnalyticsProviderBreakdown', provider: string, sales: number, revenue: number }> } };

export type AnalyticsSalesByUtmQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
  dimension: UtmDimensionType;
}>;


export type AnalyticsSalesByUtmQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', currency: PaymentCurrencyType, salesByUtm: Array<{ __typename?: 'AnalyticsSalesUtmBreakdown', value: string, sales: number, revenue: number }> } };

export type AnalyticsSalesMetricsQueryVariablesType = Exact<{
  filter: AnalyticsSalesFilterInputType;
}>;


export type AnalyticsSalesMetricsQueryType = { __typename?: 'Query', analyticsSales: { __typename?: 'AnalyticsSalesResult', sales: number, purchasers: number, revenue: number, currency: PaymentCurrencyType } };

export type AnalyticsUsersByCountryQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsUsersByCountryQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByCountry: Array<{ __typename?: 'AnalyticsUsersCountryBreakdown', countryCode: string, users: number }> } };

export type AnalyticsUsersByDateQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsUsersByDateQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type AnalyticsUsersByEmailCampaignQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsUsersByEmailCampaignQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByEmailCampaign: Array<{ __typename?: 'AnalyticsUsersEmailCampaignBreakdown', automationId: string, title: string, users: number }> } };

export type AnalyticsUsersByLanguageQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
}>;


export type AnalyticsUsersByLanguageQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByLanguage: Array<{ __typename?: 'AnalyticsUsersLanguageBreakdown', language: string, users: number }> } };

export type AnalyticsUsersByLinkQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsUsersByLinkQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByLink: Array<{ __typename?: 'AnalyticsUsersLinkBreakdown', linkId: string, title: string, users: number }> } };

export type AnalyticsUsersByUtmQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
  dimension: UtmDimensionType;
}>;


export type AnalyticsUsersByUtmQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', usersByUtm: Array<{ __typename?: 'AnalyticsUsersUtmBreakdown', value: string, users: number }> } };

export type AnalyticsUsersMetricsQueryVariablesType = Exact<{
  filter: AnalyticsUsersFilterInputType;
}>;


export type AnalyticsUsersMetricsQueryType = { __typename?: 'Query', analyticsUsers: { __typename?: 'AnalyticsUsersResult', newUsers: number, totalUsers: number } };

export type AnalyticsViewsByCityQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByCityQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByCity: Array<{ __typename?: 'AnalyticsCityBreakdown', city: string, views: number, visitors: number }> } };

export type AnalyticsViewsByContentQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByContentQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByContent: Array<{ __typename?: 'AnalyticsContentBreakdown', contentId: string, title: string, views: number, visitors: number }> } };

export type AnalyticsViewsByCountryQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByCountryQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByCountry: Array<{ __typename?: 'AnalyticsCountryBreakdown', countryCode: string, views: number, visitors: number }> } };

export type AnalyticsViewsByDateQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsViewsByDateQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type AnalyticsViewsByDeviceOsQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
}>;


export type AnalyticsViewsByDeviceOsQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByDeviceOs: Array<{ __typename?: 'AnalyticsDeviceBreakdown', label: string, views: number }> } };

export type AnalyticsViewsByDeviceTypeQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
}>;


export type AnalyticsViewsByDeviceTypeQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByDeviceType: Array<{ __typename?: 'AnalyticsDeviceBreakdown', label: string, views: number }> } };

export type AnalyticsViewsByEmailCampaignQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByEmailCampaignQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByEmailCampaign: Array<{ __typename?: 'AnalyticsViewsEmailCampaignBreakdown', automationId: string, title: string, views: number, visitors: number }> } };

export type AnalyticsViewsByLinkQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByLinkQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByLink: Array<{ __typename?: 'AnalyticsLinkBreakdown', linkId: string, title: string, views: number, visitors: number }> } };

export type AnalyticsViewsByTagQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnalyticsViewsByTagQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByTag: Array<{ __typename?: 'AnalyticsTagBreakdown', tagId: string, title: string, views: number, visitors: number }> } };

export type AnalyticsViewsByUtmQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  dimension: UtmDimensionType;
}>;


export type AnalyticsViewsByUtmQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', viewsByUtm: Array<{ __typename?: 'AnalyticsUtmBreakdown', value: string, views: number }> } };

export type AnalyticsViewsMetricsQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
}>;


export type AnalyticsViewsMetricsQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', views: number, visitors: number, duration: number } };

export type AnalyticsVisitorsByDateQueryVariablesType = Exact<{
  filter: AnalyticsViewsFilterInputType;
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type AnalyticsVisitorsByDateQueryType = { __typename?: 'Query', analyticsViews: { __typename?: 'AnalyticsViewsResult', visitorsByDate: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } } };

export type DashboardQueryVariablesType = Exact<{
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
}>;


export type DashboardQueryType = { __typename?: 'Query', dashboard: { __typename?: 'Dashboard', videosCount: number, videosDuration: number, finishedStreamsCount: number, finishedStreamDuration: number, metrics: { __typename?: 'DashboardMetrics', views: number, viewsTrend: number, visitors: number, visitorsTrend: number, purchases: number, purchasesTrend: number, revenue: number, revenueTrend: number, revenueCurrency: PaymentCurrencyType, users: number, usersTrend: number } } };

export type AssignSupportRequestMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignSupportRequestMutationType = { __typename?: 'Mutation', assignSupportRequest: { __typename?: 'SupportRequest', id: string, assignee?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null } };

export type CancelAssistantPlanMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelAssistantPlanMutationType = { __typename?: 'Mutation', cancelAssistantPlan: { __typename?: 'AssistantPlan', id: string, status: AssistantPlanStatusType } };

export type ReplySupportRequestMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: ReplySupportRequestInputType;
}>;


export type ReplySupportRequestMutationType = { __typename?: 'Mutation', replySupportRequest: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatusType, lastMessageAt?: any | null, waitingSince?: any | null, closedAt?: any | null, assignee?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null } };

export type SetSupportRequestStatusMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: SetSupportRequestStatusInputType;
}>;


export type SetSupportRequestStatusMutationType = { __typename?: 'Mutation', setSupportRequestStatus: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatusType, waitingSince?: any | null, closedAt?: any | null } };

export type UploadAssistantAttachmentMutationVariablesType = Exact<{
  file: Scalars['Upload']['input'];
  conversationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UploadAssistantAttachmentMutationType = { __typename?: 'Mutation', uploadAssistantAttachment: { __typename?: 'AssistantAttachment', id: string, url: string, width: number, height: number } };

export type AssistantConversationQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssistantConversationQueryType = { __typename?: 'Query', assistantConversation?: { __typename?: 'AssistantConversation', id: string, title?: string | null, topic?: ConversationTopicType | null, hasRequest: boolean, createdAt: any, lastMessageAt: any, messageCount: number, utm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, messages: Array<{ __typename?: 'AssistantMessage', id: string, role: AssistantMessageRoleType, kind: AssistantMessageKindType, text: string, createdAt: any }> } | null };

export type AssistantConversationsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AssistantConversationsFilterInputType>;
}>;


export type AssistantConversationsListQueryType = { __typename?: 'Query', assistantConversations: { __typename?: 'AssistantConversationConnection', count: number, nodes: Array<{ __typename?: 'AssistantConversation', id: string, title?: string | null, topic?: ConversationTopicType | null, hasRequest: boolean, messageCount: number, lastMessageAt: any, user?: { __typename?: 'User', id: string, email?: string | null } | null }> } };

export type MyPartnerAssistantConversationQueryVariablesType = Exact<{ [key: string]: never; }>;


export type MyPartnerAssistantConversationQueryType = { __typename?: 'Query', myPartnerAssistantConversation?: { __typename?: 'PartnerAssistantConversation', id: string, messages: Array<{ __typename?: 'PartnerAssistantMessage', id: string, role: AssistantMessageRoleType, kind: AssistantMessageKindType, text: string, cards: any, ask?: any | null, createdAt: any, attachments: Array<{ __typename?: 'AssistantAttachment', id: string, url: string, width: number, height: number }>, plan?: { __typename?: 'AssistantPlan', id: string, status: AssistantPlanStatusType, title: string, notes: Array<string>, sources: Array<string>, previews: any, executedAt?: any | null, steps: Array<{ __typename?: 'AssistantPlanStep', index: number, description: string, operation: string, dangerous: boolean, dangerReason?: AssistantPlanDangerReasonType | null, removedFrom: Array<string>, status: AssistantPlanStepStatusType, error?: string | null }> } | null }> } | null };

export type SupportRequestAssigneesQueryVariablesType = Exact<{ [key: string]: never; }>;


export type SupportRequestAssigneesQueryType = { __typename?: 'Query', supportRequestAssignees: Array<{ __typename?: 'User', id: string, displayName?: string | null, email?: string | null }> };

export type SupportRequestMessageOriginalQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportRequestMessageOriginalQueryType = { __typename?: 'Query', supportRequestMessageOriginal?: string | null };

export type SupportRequestQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportRequestQueryType = { __typename?: 'Query', supportRequest?: { __typename?: 'SupportRequest', id: string, number?: number | null, subject: string, type: SupportRequestTypeType, status: SupportRequestStatusType, message: string, details?: string | null, conversationId: string, createdAt: any, closedAt?: any | null, lastMessageAt?: any | null, waitingSince?: any | null, utm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, user?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, assignee?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null, payment?: { __typename?: 'Payment', id: string, status: PaymentStatusType, amount: { __typename?: 'Amount', value: number, currency: string }, product?: { __typename?: 'Product', id: string, title: string } | null } | null, assistantMessages: Array<{ __typename?: 'AssistantMessage', id: string, role: AssistantMessageRoleType, kind: AssistantMessageKindType, text: string, createdAt: any }>, messages: Array<{ __typename?: 'SupportRequestMessage', id: string, author: SupportRequestMessageAuthorType, channel: SupportRequestMessageChannelType, body: string, internal: boolean, viaAssistant: boolean, event?: SupportRequestEventType | null, fromEmail?: string | null, skippedAttachments: number, hasOriginal: boolean, createdAt: any, staff?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null, eventUser?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null, attachments: Array<{ __typename?: 'SupportRequestAttachment', name: string, mimeType: string, size: number, url: string }> }> } | null };

export type SupportRequestsDashboardQueryVariablesType = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupportRequestsDashboardQueryType = { __typename?: 'Query', needsReply: { __typename?: 'SupportRequestConnection', count: number, nodes: Array<{ __typename?: 'SupportRequest', id: string, type: SupportRequestTypeType, status: SupportRequestStatusType, createdAt: any, user?: { __typename?: 'User', id: string, email?: string | null } | null }> }, waitingViewer: { __typename?: 'SupportRequestConnection', count: number, nodes: Array<{ __typename?: 'SupportRequest', id: string, type: SupportRequestTypeType, status: SupportRequestStatusType, createdAt: any, user?: { __typename?: 'User', id: string, email?: string | null } | null }> } };

export type SupportRequestsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SupportRequestsFilterInputType>;
}>;


export type SupportRequestsListQueryType = { __typename?: 'Query', supportRequests: { __typename?: 'SupportRequestConnection', count: number, nodes: Array<{ __typename?: 'SupportRequest', id: string, number?: number | null, subject: string, type: SupportRequestTypeType, status: SupportRequestStatusType, createdAt: any, lastMessageAt?: any | null, waitingSince?: any | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, assignee?: { __typename?: 'User', id: string, displayName?: string | null, email?: string | null } | null }> } };

export type SupportRequestsOpenCountQueryVariablesType = Exact<{ [key: string]: never; }>;


export type SupportRequestsOpenCountQueryType = { __typename?: 'Query', supportRequestsOpenCount: number };

export type SignInMutationVariablesType = Exact<{
  input: SignInInputType;
}>;


export type SignInMutationType = { __typename?: 'Mutation', signIn: { __typename?: 'SignInOutput', token: string } };

export type SignOutMutationVariablesType = Exact<{ [key: string]: never; }>;


export type SignOutMutationType = { __typename?: 'Mutation', signOut: boolean };

export type UpdateCurrentUserMutationVariablesType = Exact<{
  input: UpdateCurrentUserInputType;
}>;


export type UpdateCurrentUserMutationType = { __typename?: 'Mutation', updateCurrentUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, email?: string | null, phone?: string | null, country?: string | null, language?: string | null, timeZone?: string | null, agreeToMarketingNewsletters?: boolean | null, currentOrganizationId?: string | null, currentOrganizationRoles: Array<OrganizationRoleType>, abilityRules: any, isPartner?: boolean | null, currentOrganization?: { __typename?: 'Organization', id: string, title: string, currency: PaymentCurrencyType } | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } };

export type VerifySignInMutationVariablesType = Exact<{
  token: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifySignInMutationType = { __typename?: 'Mutation', verifySignIn: { __typename?: 'VerifyEmailOutput', token: string } };

export type CurrentUserQueryVariablesType = Exact<{ [key: string]: never; }>;


export type CurrentUserQueryType = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, displayName?: string | null, country?: string | null, language?: string | null, timeZone?: string | null, agreeToMarketingNewsletters?: boolean | null, currentOrganizationId?: string | null, isAdmin?: boolean | null, isSuperAdmin?: boolean | null, isPartner?: boolean | null, currentOrganizationRoles: Array<OrganizationRoleType>, abilityRules: any, currentOrganization?: { __typename?: 'Organization', id: string, title: string, currency: PaymentCurrencyType, assistantEnabled: boolean } | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } | null };

export type BillingHasContractsQueryVariablesType = Exact<{ [key: string]: never; }>;


export type BillingHasContractsQueryType = { __typename?: 'Query', contractPayments: { __typename?: 'ContractPaymentConnection', count: number }, revenueShareReports: { __typename?: 'RevenueShareReportConnection', count: number } };

export type ContractPaymentsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContractPaymentsFilterInputType>;
}>;


export type ContractPaymentsListQueryType = { __typename?: 'Query', contractPayments: { __typename?: 'ContractPaymentConnection', count: number, nodes: Array<{ __typename?: 'ContractPayment', id: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, invoiceUrl?: string | null, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, invoiceAmount?: { __typename?: 'Amount', value: number, currency: string } | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any } | null }> } };

export type RevenueShareReportsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RevenueShareReportsFilterInputType>;
}>;


export type RevenueShareReportsListQueryType = { __typename?: 'Query', revenueShareReports: { __typename?: 'RevenueShareReportConnection', count: number, nodes: Array<{ __typename?: 'RevenueShareReport', id: string, period: string, status: string, refundsCount: number, disputesCount: number, createdAt: any, salesAmount: { __typename?: 'Amount', value: number, currency: string }, feeAmount: { __typename?: 'Amount', value: number, currency: string }, refundsAmount: { __typename?: 'Amount', value: number, currency: string }, disputesAmount: { __typename?: 'Amount', value: number, currency: string }, corrections: Array<{ __typename?: 'RevenueShareReportCorrection', description: string, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string } }>, reportAmount: { __typename?: 'Amount', value: number, currency: string } }> } };

export type UnpaidContractPaymentsQueryVariablesType = Exact<{ [key: string]: never; }>;


export type UnpaidContractPaymentsQueryType = { __typename?: 'Query', waitPayment: { __typename?: 'ContractPaymentConnection', count: number, nodes: Array<{ __typename?: 'ContractPayment', id: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, invoiceUrl?: string | null, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, invoiceAmount?: { __typename?: 'Amount', value: number, currency: string } | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any } | null }> }, onWay: { __typename?: 'ContractPaymentConnection', count: number, nodes: Array<{ __typename?: 'ContractPayment', id: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, invoiceUrl?: string | null, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, invoiceAmount?: { __typename?: 'Amount', value: number, currency: string } | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any } | null }> } };

export type CreateChatBanMutationVariablesType = Exact<{
  input: CreateChatBanInputType;
}>;


export type CreateChatBanMutationType = { __typename?: 'Mutation', createChatBan: { __typename?: 'ChatBan', id: string } };

export type DeleteChatBanMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChatBanMutationType = { __typename?: 'Mutation', deleteChatBan: { __typename?: 'ChatBan', id: string } };

export type DeleteChatMessageMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChatMessageMutationType = { __typename?: 'Mutation', deleteChatMessage: { __typename?: 'ChatMessage', id: string } };

export type ChatBansQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatBansQueryType = { __typename?: 'Query', chatBans: { __typename?: 'ChatBanConnection', count: number, nodes: Array<{ __typename?: 'ChatBan', id: string, type: ChatBanTypeType, expiredAt: any, createdAt: any, userId: string, user?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> } };

export type ChatMessagesQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ChatMessagesFilterInputType>;
}>;


export type ChatMessagesQueryType = { __typename?: 'Query', chatMessages: { __typename?: 'ChatMessageConnection', count: number, nodes: Array<{ __typename?: 'ChatMessage', id: string, messageType: ChatMessageTypeType, message?: string | null, createdAt: any, userId?: string | null, userDisplayName?: string | null, contentId?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, content?: { __typename?: 'Content', id: string, title: string } | null }> } };

export type CreateComplianceRecordMutationVariablesType = Exact<{
  input: CreateComplianceRecordInputType;
}>;


export type CreateComplianceRecordMutationType = { __typename?: 'Mutation', createComplianceRecord: { __typename?: 'ComplianceRecord', id: string, contentId?: string | null, productId?: string | null, kind: ComplianceRecordKindType, performerName?: string | null, note?: string | null, url?: any | null, fileName?: string | null, fileUrl?: any | null, createdAt: any, updatedAt: any } };

export type DeleteComplianceRecordMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteComplianceRecordMutationType = { __typename?: 'Mutation', deleteComplianceRecord: boolean };

export type UpdateComplianceRecordMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateComplianceRecordInputType;
}>;


export type UpdateComplianceRecordMutationType = { __typename?: 'Mutation', updateComplianceRecord: { __typename?: 'ComplianceRecord', id: string, contentId?: string | null, productId?: string | null, kind: ComplianceRecordKindType, performerName?: string | null, note?: string | null, url?: any | null, fileName?: string | null, fileUrl?: any | null, createdAt: any, updatedAt: any } };

export type ComplianceRecordsQueryVariablesType = Exact<{
  contentId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ComplianceRecordsQueryType = { __typename?: 'Query', complianceRecords: Array<{ __typename?: 'ComplianceRecord', id: string, contentId?: string | null, productId?: string | null, kind: ComplianceRecordKindType, performerName?: string | null, note?: string | null, url?: any | null, fileName?: string | null, fileUrl?: any | null, createdAt: any, updatedAt: any }> };

export type CreateContentFromUrlMutationVariablesType = Exact<{
  input: CreateContentFromUrlInputType;
}>;


export type CreateContentFromUrlMutationType = { __typename?: 'Mutation', createContentFromUrl: { __typename?: 'Content', id: string } };

export type CreateContentMutationVariablesType = Exact<{
  input: CreateContentInputType;
}>;


export type CreateContentMutationType = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string } };

export type CreateMultipleContentsMutationVariablesType = Exact<{
  input: Array<CreateContentInputType> | CreateContentInputType;
}>;


export type CreateMultipleContentsMutationType = { __typename?: 'Mutation', createMultipleContents: Array<{ __typename?: 'Content', id: string, title: string }> };

export type DeleteContentsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContentsMutationType = { __typename?: 'Mutation', deleteContents: Array<{ __typename?: 'Content', id: string } | null> };

export type RequestTusVideoUploadMutationVariablesType = Exact<{
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  contentType: Scalars['String']['input'];
}>;


export type RequestTusVideoUploadMutationType = { __typename?: 'Mutation', requestTusVideoUpload: { __typename?: 'TusVideoUploadPayload', endpoint: any, videoUid: string, headers: Array<{ __typename?: 'TusVideoUploadHeader', name: string, value: string }> } };

export type RequestVideoDownloadMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type RequestVideoDownloadMutationType = { __typename?: 'Mutation', requestVideoDownload: { __typename?: 'VideoDownload', status: VideoDownloadStatusType, percent?: number | null, url?: any | null, error?: string | null } };

export type RequestVideoUploadMutationVariablesType = Exact<{
  fileSize: Scalars['Float']['input'];
  durationSeconds?: InputMaybe<Scalars['Float']['input']>;
}>;


export type RequestVideoUploadMutationType = { __typename?: 'Mutation', requestVideoUpload: { __typename?: 'VideoUploadPayload', uploadUrl: any, videoUid: string } };

export type UpdateContentManyMutationVariablesType = Exact<{
  input: Array<UpdateContentManyInputType> | UpdateContentManyInputType;
}>;


export type UpdateContentManyMutationType = { __typename?: 'Mutation', updateContentMany: Array<{ __typename?: 'Content', id: string, collectionIds: Array<string>, productIds: Array<string> } | null> };

export type UpdateContentMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateContentInputType;
}>;


export type UpdateContentMutationType = { __typename?: 'Mutation', updateContent: { __typename?: 'Content', id: string } };

export type UpdateContentNestedSortMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateContentNestedSortInputType;
}>;


export type UpdateContentNestedSortMutationType = { __typename?: 'Mutation', updateContentNestedSort: { __typename?: 'Content', id: string } };

export type UpdateContentsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateContentsInputType;
}>;


export type UpdateContentsMutationType = { __typename?: 'Mutation', updateContents: Array<{ __typename?: 'Content', id: string, publishAt?: any | null } | null> };

export type UpdateTimecodesMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTimecodesInputType;
}>;


export type UpdateTimecodesMutationType = { __typename?: 'Mutation', updateTimecodes: { __typename?: 'ContentTimecodes', id: string, updatedAt: any, timecodes: Array<{ __typename?: 'Timecode', id: string, type: TimecodeTypeType, time: number, title: string, description?: string | null, icon: TimecodeIconType, duration?: number | null, position?: AnnotationPositionType | null, linkedContent?: { __typename?: 'Content', id: string, title: string, preview?: { __typename?: 'Image', id: string, url: any } | null } | null }> } };

export type ChildrenContentsQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  collectionId: Scalars['ID']['input'];
  sort?: InputMaybe<ContentsSortTypeType>;
}>;


export type ChildrenContentsQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, type: ContentTypeType, title: string, publishAt?: any | null, duration?: number | null, nestedSortValue?: number | null, totalViews: number, preview?: { __typename?: 'Image', id: string, url: any } | null, playback?: { __typename?: 'ContentPlayback', hlsUrl: any, thumbnailUrl: any } | null }> } };

export type CollectionOptionsQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type CollectionOptionsQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, title: string }> } };

export type CollectionQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CollectionQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, type: ContentTypeType, title: string, description?: string | null, publishAt?: any | null, accessStartAt?: any | null, hideInGeneralLists: boolean, onlyUsers: boolean, url?: any | null, path?: string | null, collectionIds: Array<string>, productIds: Array<string>, collectionTypeId?: string | null, collectionContentSort: CollectionContentSortType, hideChildrenContentFromLists: boolean, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, verticalPreview?: { __typename?: 'Image', id: string, url: any } | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }>, countryAccess?: { __typename?: 'CountryAccess', id: string, title: string } | null, collectionType?: { __typename?: 'CollectionType', id: string, title: string } | null } };

export type CollectionTypesQueryVariablesType = Exact<{ [key: string]: never; }>;


export type CollectionTypesQueryType = { __typename?: 'Query', collectionTypes: Array<{ __typename?: 'CollectionType', id: string, title: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null }> };

export type CollectionsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type CollectionsListQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, type: ContentTypeType, title: string, publishAt?: any | null, hideInGeneralLists: boolean, url?: any | null, path?: string | null, collectionIds: Array<string>, productIds: Array<string>, collectionTypeId?: string | null, collectionContentSort: CollectionContentSortType, totalViews: number, createdAt: any, updatedAt: any, videosCount: number, collectionsCount: number, preview?: { __typename?: 'Image', id: string, url: any } | null, collectionType?: { __typename?: 'CollectionType', id: string, title: string } | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }> }> } };

export type ContentQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, type: ContentTypeType, title: string, description?: string | null, processingStatus: ContentProcessingStatusType, transcodingError?: string | null, duration?: number | null, publishAt?: any | null, accessStartAt?: any | null, hideInGeneralLists: boolean, onlyUsers: boolean, ageRestrictions: number, collectionIds: Array<string>, productIds: Array<string>, url?: any | null, embedUrl?: any | null, createdAt: any, updatedAt: any, video?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null, readyToStream: boolean, duration?: number | null, transcodingError?: string | null, isChatEnabled: boolean } | null, pendingVideo?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null, isChatEnabled: boolean } | null, preview?: { __typename?: 'Image', id: string, url: any } | null, verticalPreview?: { __typename?: 'Image', id: string, url: any } | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }>, countryAccess?: { __typename?: 'CountryAccess', id: string, title: string } | null, widget?: { __typename?: 'Widget', id: string } | null, playback?: { __typename?: 'ContentPlayback', token: string, hlsUrl: any, iframeUrl?: any | null, thumbnailUrl: any } | null } };

export type ContentStatusQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentStatusQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, processingStatus: ContentProcessingStatusType, transcodingError?: string | null, duration?: number | null, video?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null, readyToStream: boolean, duration?: number | null, transcodingError?: string | null } | null, pendingVideo?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null } | null, playback?: { __typename?: 'ContentPlayback', token: string, hlsUrl: any, iframeUrl?: any | null } | null } };

export type ContentTimecodesQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentTimecodesQueryType = { __typename?: 'Query', contentTimecodes?: { __typename?: 'ContentTimecodes', id: string, updatedAt: any, timecodes: Array<{ __typename?: 'Timecode', id: string, type: TimecodeTypeType, time: number, title: string, description?: string | null, icon: TimecodeIconType, duration?: number | null, position?: AnnotationPositionType | null, linkedContent?: { __typename?: 'Content', id: string, title: string, preview?: { __typename?: 'Image', id: string, url: any } | null } | null }> } | null };

export type ContentTitlesQueryVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContentTitlesQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', nodes: Array<{ __typename?: 'Content', id: string, title: string }> } };

export type ContentsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type ContentsListQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, type: ContentTypeType, title: string, premium: boolean, collectionIds: Array<string>, productIds: Array<string>, processingStatus: ContentProcessingStatusType, transcodingError?: string | null, duration?: number | null, publishAt?: any | null, hideInGeneralLists: boolean, onlyUsers: boolean, url?: any | null, totalViews: number, viewersOnline: number, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, playback?: { __typename?: 'ContentPlayback', thumbnailUrl: any } | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }> }> } };

export type VideoDownloadQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VideoDownloadQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, videoDownload?: { __typename?: 'VideoDownload', status: VideoDownloadStatusType, percent?: number | null, url?: any | null, error?: string | null } | null } };

export type ContentStatusChangedSubscriptionVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentStatusChangedSubscriptionType = { __typename?: 'Subscription', contentStatusChanged: { __typename?: 'Content', id: string, processingStatus: ContentProcessingStatusType, transcodingError?: string | null, duration?: number | null, video?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null, readyToStream: boolean, duration?: number | null, transcodingError?: string | null } | null, pendingVideo?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null } | null } };

export type CreateCountryAccessMutationVariablesType = Exact<{
  input: CreateCountryAccessInputType;
}>;


export type CreateCountryAccessMutationType = { __typename?: 'Mutation', createCountryAccess: { __typename?: 'CountryAccess', id: string, title: string, type: CountryAccessTypeType, countries: Array<string>, isDefault: boolean } };

export type DeleteCountryAccessesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCountryAccessesMutationType = { __typename?: 'Mutation', deleteCountryAccesses: Array<{ __typename?: 'CountryAccess', id: string } | null> };

export type SetDefaultCountryAccessMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultCountryAccessMutationType = { __typename?: 'Mutation', setDefaultCountryAccess: { __typename?: 'CountryAccess', id: string, isDefault: boolean } };

export type UpdateCountryAccessMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCountryAccessInputType;
}>;


export type UpdateCountryAccessMutationType = { __typename?: 'Mutation', updateCountryAccess: { __typename?: 'CountryAccess', id: string, title: string, type: CountryAccessTypeType, countries: Array<string>, isDefault: boolean } };

export type CountryAccessQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CountryAccessQueryType = { __typename?: 'Query', countryAccess: { __typename?: 'CountryAccess', id: string, title: string, type: CountryAccessTypeType, countries: Array<string>, isDefault: boolean, createdAt: any, updatedAt: any } };

export type CountryAccessesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CountryAccessesListQueryType = { __typename?: 'Query', countryAccesses: { __typename?: 'CountryAccessConnection', count: number, nodes: Array<{ __typename?: 'CountryAccess', id: string, title: string, type: CountryAccessTypeType, countries: Array<string>, isDefault: boolean, contentsCount: number, createdAt: any, updatedAt: any }> } };

export type CountryAccessesSelectQueryVariablesType = Exact<{ [key: string]: never; }>;


export type CountryAccessesSelectQueryType = { __typename?: 'Query', countryAccesses: { __typename?: 'CountryAccessConnection', nodes: Array<{ __typename?: 'CountryAccess', id: string, title: string, isDefault: boolean }> } };

export type DisputesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DisputesFilterInputType>;
}>;


export type DisputesListQueryType = { __typename?: 'Query', disputes: { __typename?: 'DisputeConnection', count: number, nodes: Array<{ __typename?: 'Dispute', id: string, status: DisputeStatusType, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, payment?: { __typename?: 'Payment', buyerEmail?: string | null, userId: string, provider: PaymentProviderType, product?: { __typename?: 'Product', id: string, title: string, type: ProductTypeType } | null } | null }> } };

export type InstanceQueryVariablesType = Exact<{ [key: string]: never; }>;


export type InstanceQueryType = { __typename?: 'Query', instance: { __typename?: 'Instance', domainProvider: DomainProviderType, liveEnabled: boolean, videoProvider: VideoProviderType, paymentProviders: Array<PaymentProviderType> } };

export type LanguagesQueryVariablesType = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type LanguagesQueryType = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, code: string, title: string }> };

export type CreateLinkMutationVariablesType = Exact<{
  input: CreateLinkInputType;
}>;


export type CreateLinkMutationType = { __typename?: 'Mutation', createLink: { __typename?: 'Link', id: string, title: string, url?: string | null, slug: string, linkType: LinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, createdAt: any, updatedAt: any, reward?: { __typename?: 'LinkReward', type: LinkRewardTypeType, percent?: number | null, fixedAmount?: number | null, fixedCurrency?: PaymentCurrencyType | null } | null } };

export type DeleteLinksMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteLinksMutationType = { __typename?: 'Mutation', deleteLinks: Array<{ __typename?: 'Link', id: string } | null> };

export type RestoreLinksMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreLinksMutationType = { __typename?: 'Mutation', restoreLinks: Array<{ __typename?: 'Link', id: string } | null> };

export type UpdateLinkMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLinkInputType;
}>;


export type UpdateLinkMutationType = { __typename?: 'Mutation', updateLink: { __typename?: 'Link', id: string, title: string, url?: string | null, slug: string, linkType: LinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, utmTerm?: string | null, utmContent?: string | null, targetUrl?: string | null, createdAt: any, updatedAt: any, reward?: { __typename?: 'LinkReward', type: LinkRewardTypeType, percent?: number | null, fixedAmount?: number | null, fixedCurrency?: PaymentCurrencyType | null } | null } };

export type LinkQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LinkQueryType = { __typename?: 'Query', link: { __typename?: 'Link', id: string, title: string, slug: string, linkType: LinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, url?: string | null, targetUrl?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, utmTerm?: string | null, utmContent?: string | null, createdAt: any, updatedAt: any, reward?: { __typename?: 'LinkReward', type: LinkRewardTypeType, percent?: number | null, fixedAmount?: number | null, fixedCurrency?: PaymentCurrencyType | null } | null } };

export type LinksAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompleteLinksFilterInputType>;
}>;


export type LinksAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string, subtitle?: string | null } | null>, options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string, subtitle?: string | null } | null> } };

export type LinksListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LinksFilterInputType>;
}>;


export type LinksListQueryType = { __typename?: 'Query', links: { __typename?: 'LinkConnection', count: number, nodes: Array<{ __typename?: 'Link', id: string, title: string, slug: string, url?: string | null, linkType: LinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, createdAt: any, updatedAt: any, reward?: { __typename?: 'LinkReward', type: LinkRewardTypeType, percent?: number | null, fixedAmount?: number | null, fixedCurrency?: PaymentCurrencyType | null } | null, stats?: { __typename?: 'LinkStats', clicks: number, views: number, sales: number, revenue: number, reward: number, currency: PaymentCurrencyType, registrations: number } | null }> } };

export type AutomationEditorFieldsFragmentType = { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, templateKey?: string | null, createdAt: any, contactListIds: Array<string>, triggerEvent?: AutomationTriggerType | null, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null, graph: { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> }, graphRules?: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> } | null, graphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }>, exitRules: Array<{ __typename?: 'AutomationExitRule', id: string, name: string, kind: AutomationExitRuleKindType, event?: AutomationExitRuleEventType | null, scope: AutomationExitRuleScopeType, filter?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null }>, reentry: { __typename?: 'AutomationReentry', mode: AutomationReentryModeType, cooldownDays: number }, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> };

export type AutomationFieldsFragmentType = { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } };

export type AutomationFlowListFieldsFragmentType = { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, activatedAt?: any | null, createdAt: any, triggerEvent?: AutomationTriggerType | null, stats: { __typename?: 'AutomationStats', enrolled: number, sent: number, delivered: number, opened: number, clicked: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number } };

export type AutomationGraphFieldsFragmentType = { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> };

export type AutomationGraphRulesFieldsFragmentType = { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> };

export type AutomationListFieldsFragmentType = { __typename?: 'Automation', id: string, name: string, status: AutomationStatusType, state: BroadcastStateType, scheduledAt?: any | null, startedAt?: any | null, createdAt: any, stats: { __typename?: 'AutomationStats', sent: number, delivered: number, opened: number, clicked: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number } };

export type AutomationLiveFieldsFragmentType = { __typename?: 'Automation', id: string, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> };

export type ContactListFieldsFragmentType = { __typename?: 'ContactList', id: string, name: string, contactsCount: number, createdAt: any, updatedAt: any };

export type EmailBlockFieldsFragmentType = { __typename?: 'EmailBlock', id: string, type: EmailBlockTypeType, text?: string | null, label?: string | null, url?: string | null, imageId?: string | null, imageUrl?: string | null, alt?: string | null, contentId?: string | null, productId?: string | null, source?: EmailDynamicSourceType | null, required: boolean };

export type MarketingContactFieldsFragmentType = { __typename?: 'MarketingContact', id: string, email: string, name?: string | null, language?: string | null, status: MarketingContactStatusType, isViewer: boolean, source: MarketingContactSourceType, createdAt: any };

export type ActivateAutomationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActivateAutomationMutationType = { __typename?: 'Mutation', activateAutomation: { __typename?: 'AutomationMutationResult', automation: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, templateKey?: string | null, createdAt: any, contactListIds: Array<string>, triggerEvent?: AutomationTriggerType | null, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null, graph: { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> }, graphRules?: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> } | null, graphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }>, exitRules: Array<{ __typename?: 'AutomationExitRule', id: string, name: string, kind: AutomationExitRuleKindType, event?: AutomationExitRuleEventType | null, scope: AutomationExitRuleScopeType, filter?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null }>, reentry: { __typename?: 'AutomationReentry', mode: AutomationReentryModeType, cooldownDays: number }, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> }, issues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }> } };

export type ArchiveAutomationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveAutomationsMutationType = { __typename?: 'Mutation', archiveAutomations: Array<{ __typename?: 'Automation', id: string }> };

export type CancelBroadcastMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelBroadcastMutationType = { __typename?: 'Mutation', cancelBroadcast: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } } };

export type CreateAutomationMutationVariablesType = Exact<{
  input: CreateAutomationInputType;
}>;


export type CreateAutomationMutationType = { __typename?: 'Mutation', createAutomation: { __typename?: 'Automation', id: string } };

export type CreateBroadcastMutationVariablesType = Exact<{
  input: CreateBroadcastInputType;
}>;


export type CreateBroadcastMutationType = { __typename?: 'Mutation', createBroadcast: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } } };

export type CreateContactListMutationVariablesType = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateContactListMutationType = { __typename?: 'Mutation', createContactList: { __typename?: 'ContactList', id: string, name: string, contactsCount: number, createdAt: any, updatedAt: any } };

export type CreateEmailTemplateMutationVariablesType = Exact<{
  input: EmailTemplateInputType;
}>;


export type CreateEmailTemplateMutationType = { __typename?: 'Mutation', createEmailTemplate: { __typename?: 'EmailTemplate', id: string, name: string, updatedAt: any, variants: Array<{ __typename?: 'EmailTemplateVariant', language: MarketingLanguageType, subject: string, preheader: string, blocks: Array<{ __typename?: 'EmailBlock', id: string, type: EmailBlockTypeType, text?: string | null, label?: string | null, url?: string | null, imageId?: string | null, imageUrl?: string | null, alt?: string | null, contentId?: string | null, productId?: string | null, source?: EmailDynamicSourceType | null, required: boolean }> }> } };

export type DeleteAutomationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAutomationsMutationType = { __typename?: 'Mutation', deleteAutomations: Array<{ __typename?: 'Automation', id: string }> };

export type DeleteContactListsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContactListsMutationType = { __typename?: 'Mutation', deleteContactLists: Array<{ __typename?: 'ContactList', id: string }> };

export type DeleteEmailTemplatesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteEmailTemplatesMutationType = { __typename?: 'Mutation', deleteEmailTemplates: Array<{ __typename?: 'EmailTemplate', id: string }> };

export type DeleteMarketingContactsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteMarketingContactsMutationType = { __typename?: 'Mutation', deleteMarketingContacts: Array<{ __typename?: 'MarketingContact', id: string }> };

export type ImportMarketingContactsMutationVariablesType = Exact<{
  input: ImportMarketingContactsInputType;
}>;


export type ImportMarketingContactsMutationType = { __typename?: 'Mutation', importMarketingContacts: { __typename?: 'ContactImportResult', added: number, updated: number, invalid: number, duplicates: number, matchedViewers: number } };

export type PauseAutomationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PauseAutomationMutationType = { __typename?: 'Mutation', pauseAutomation: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, templateKey?: string | null, createdAt: any, contactListIds: Array<string>, triggerEvent?: AutomationTriggerType | null, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null, graph: { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> }, graphRules?: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> } | null, graphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }>, exitRules: Array<{ __typename?: 'AutomationExitRule', id: string, name: string, kind: AutomationExitRuleKindType, event?: AutomationExitRuleEventType | null, scope: AutomationExitRuleScopeType, filter?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null }>, reentry: { __typename?: 'AutomationReentry', mode: AutomationReentryModeType, cooldownDays: number }, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> } };

export type SendBroadcastMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SendBroadcastMutationType = { __typename?: 'Mutation', sendBroadcast: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } } };

export type SendTestEmailTemplateMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  language: MarketingLanguageType;
}>;


export type SendTestEmailTemplateMutationType = { __typename?: 'Mutation', sendTestEmailTemplate: boolean };

export type UpdateAutomationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: AutomationInputType;
}>;


export type UpdateAutomationMutationType = { __typename?: 'Mutation', updateAutomation: { __typename?: 'AutomationMutationResult', automation: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, templateKey?: string | null, createdAt: any, contactListIds: Array<string>, triggerEvent?: AutomationTriggerType | null, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null, graph: { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> }, graphRules?: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> } | null, graphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }>, exitRules: Array<{ __typename?: 'AutomationExitRule', id: string, name: string, kind: AutomationExitRuleKindType, event?: AutomationExitRuleEventType | null, scope: AutomationExitRuleScopeType, filter?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null }>, reentry: { __typename?: 'AutomationReentry', mode: AutomationReentryModeType, cooldownDays: number }, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> }, issues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }> } };

export type UpdateBroadcastMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: BroadcastInputType;
}>;


export type UpdateBroadcastMutationType = { __typename?: 'Mutation', updateBroadcast: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } } };

export type UpdateContactListMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateContactListMutationType = { __typename?: 'Mutation', updateContactList: { __typename?: 'ContactList', id: string, name: string, contactsCount: number, createdAt: any, updatedAt: any } };

export type UpdateEmailTemplateMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: EmailTemplateInputType;
}>;


export type UpdateEmailTemplateMutationType = { __typename?: 'Mutation', updateEmailTemplate: { __typename?: 'EmailTemplate', id: string, name: string, updatedAt: any, variants: Array<{ __typename?: 'EmailTemplateVariant', language: MarketingLanguageType, subject: string, preheader: string, blocks: Array<{ __typename?: 'EmailBlock', id: string, type: EmailBlockTypeType, text?: string | null, label?: string | null, url?: string | null, imageId?: string | null, imageUrl?: string | null, alt?: string | null, contentId?: string | null, productId?: string | null, source?: EmailDynamicSourceType | null, required: boolean }> }> } };

export type AudienceEstimateQueryVariablesType = Exact<{
  audience?: InputMaybe<AudienceFilterInputType>;
  contactListIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AudienceEstimateQueryType = { __typename?: 'Query', audienceEstimate: { __typename?: 'AudienceEstimate', viewers: number, contacts: number } };

export type AutomationEditorQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AutomationEditorQueryType = { __typename?: 'Query', automation: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, templateKey?: string | null, createdAt: any, contactListIds: Array<string>, triggerEvent?: AutomationTriggerType | null, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null, graph: { __typename?: 'AutomationGraph', nodes: Array<{ __typename?: 'AutomationNode', id: string, type: AutomationNodeTypeType, position?: { __typename?: 'AutomationNodePosition', x: number, y: number } | null, trigger?: { __typename?: 'AutomationTriggerConfig', event?: AutomationTriggerType | null, tagIds: Array<string>, productIds: Array<string>, contentIds: Array<string>, daysBefore?: number | null, reasons: Array<AutomationRenewalFailureReasonType> } | null, sendEmail?: { __typename?: 'AutomationSendEmailConfig', emailTemplateId?: string | null, emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string } | null } | null, wait?: { __typename?: 'AutomationWaitConfig', value: number, unit: AutomationWaitUnitType } | null, condition?: { __typename?: 'AutomationConditionConfig', filter: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } } | null }>, edges: Array<{ __typename?: 'AutomationEdge', id: string, source: string, sourceHandle?: string | null, target: string }> }, graphRules?: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, triggers: Array<AutomationTriggerType>, audienceRequired: boolean, contactLists: boolean, exitRules: boolean, exitRuleEvents: Array<AutomationExitRuleEventType>, renewalReasons: Array<AutomationRenewalFailureReasonType>, contextScopeEvents: Array<AutomationExitRuleEventType>, conditionFields: Array<AudienceFieldType>, nodeTypes: Array<{ __typename?: 'AutomationNodeRule', type: AutomationNodeTypeType, outputs: Array<string | null>, canEnd: boolean, acceptsInput: boolean, required: boolean, maxCount?: number | null }>, triggerRules: Array<{ __typename?: 'AutomationTriggerRule', event: AutomationTriggerType, supportsTagFilter: boolean, params: Array<AutomationTriggerParamType>, delayMinutes?: number | null }>, limits: { __typename?: 'AutomationGraphLimits', nodes: number, edges: number, maxEmailNodes: number, nameLength: number, positionAbs: number, exitRules: number, exitRuleNameLength: number, daysBeforeMax: number, cooldownDaysMax: number, triggerProducts: number, triggerContents: number, triggerTags: number }, waitUnits: Array<{ __typename?: 'AutomationWaitUnitLimit', unit: AutomationWaitUnitType, max: number }> } | null, graphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }>, exitRules: Array<{ __typename?: 'AutomationExitRule', id: string, name: string, kind: AutomationExitRuleKindType, event?: AutomationExitRuleEventType | null, scope: AutomationExitRuleScopeType, filter?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null, nodeId?: string | null }> } | null }>, reentry: { __typename?: 'AutomationReentry', mode: AutomationReentryModeType, cooldownDays: number }, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> } };

export type AutomationEnrollmentsQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
  status: AutomationEnrollmentStatusType;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationEnrollmentsQueryType = { __typename?: 'Query', automationEnrollments: { __typename?: 'AutomationEnrollmentPage', nextCursor?: string | null, nodes: Array<{ __typename?: 'AutomationEnrollment', id: string, status: AutomationEnrollmentStatusType, currentNodeId?: string | null, waitUntil?: any | null, exitReason?: AutomationEnrollmentExitReasonType | null, exitRuleId?: string | null, createdAt: any, finishedAt?: any | null, viewer?: { __typename?: 'AutomationEnrollmentViewer', id: string, email: string, firstName?: string | null } | null }> } };

export type AutomationFlowsListQueryVariablesType = Exact<{
  kinds: Array<AutomationKindType> | AutomationKindType;
  status?: InputMaybe<AutomationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationFlowsListQueryType = { __typename?: 'Query', automations: { __typename?: 'AutomationConnection', count: number, nodes: Array<{ __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, activatedAt?: any | null, createdAt: any, triggerEvent?: AutomationTriggerType | null, stats: { __typename?: 'AutomationStats', enrolled: number, sent: number, delivered: number, opened: number, clicked: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number } }> } };

export type AutomationGraphIssuesQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: AutomationInputType;
}>;


export type AutomationGraphIssuesQueryType = { __typename?: 'Query', automationGraphIssues: Array<{ __typename?: 'AutomationGraphIssue', nodeId?: string | null, code: AutomationGraphIssueCodeType, exitRuleId?: string | null }> };

export type AutomationGraphRulesQueryVariablesType = Exact<{
  kind: AutomationKindType;
}>;


export type AutomationGraphRulesQueryType = { __typename?: 'Query', automationGraphRules: { __typename?: 'AutomationGraphRules', kind: AutomationKindType, templates: Array<{ __typename?: 'AutomationTemplateOption', key: string, trigger?: AutomationTriggerType | null }> } };

export type AutomationLiveQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AutomationLiveQueryType = { __typename?: 'Query', automation: { __typename?: 'Automation', id: string, status: AutomationStatusType, allowedActions: Array<AutomationActionType>, revision: number, activatedAt?: any | null, entryToday: { __typename?: 'AutomationEntryLimit', day: string, count: number, limited: number, limit: number }, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, goalReached: number, stopped: number, entryLimited: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }, nodeStats: Array<{ __typename?: 'AutomationNodeStats', nodeId: string, sent: number, delivered: number, opened: number, clicked: number, entered: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> }>, eventRuns: Array<{ __typename?: 'AutomationEventRun', id: string, eventType: AutomationTriggerType, objectId: string, objectTitle: string, eventAt: any, status: AutomationEventRunStatusType, skipReason?: AutomationEventRunSkipReasonType | null, enrolled: number, skipped: number }> } };

export type AutomationNodeActiveCountQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
}>;


export type AutomationNodeActiveCountQueryType = { __typename?: 'Query', automationNodeActiveCount: number };

export type AutomationQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AutomationQueryType = { __typename?: 'Query', automation: { __typename?: 'Automation', id: string, name: string, kind: AutomationKindType, status: AutomationStatusType, state: BroadcastStateType, emailTemplateId?: string | null, contactListIds: Array<string>, scheduledAt?: any | null, startedAt?: any | null, templateKey?: string | null, createdAt: any, updatedAt: any, audience?: { __typename?: 'AudienceFilter', match: AudienceMatchType, conditions: Array<{ __typename?: 'AudienceCondition', field: AudienceFieldType, op: AudienceOpType, boolValue?: boolean | null, numberValue?: number | null, stringValues?: Array<string> | null }> } | null, stats: { __typename?: 'AutomationStats', enrolled: number, active: number, completed: number, exited: number, sent: number, failed: number, delivered: number, bounced: number, opened: number, clicked: number, unsubscribed: number, views: number, viewers: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number, skipped: Array<{ __typename?: 'AutomationSkipCount', reason: string, count: number }> } } };

export type AutomationsListQueryVariablesType = Exact<{
  status?: InputMaybe<AutomationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationsListQueryType = { __typename?: 'Query', automations: { __typename?: 'AutomationConnection', count: number, nodes: Array<{ __typename?: 'Automation', id: string, name: string, status: AutomationStatusType, state: BroadcastStateType, scheduledAt?: any | null, startedAt?: any | null, createdAt: any, stats: { __typename?: 'AutomationStats', sent: number, delivered: number, opened: number, clicked: number, purchases: number, revenueUSD: number, renewals: number, renewalRevenueUSD: number, revenueWithRenewalsUSD: number } }> } };

export type ContactListQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactListQueryType = { __typename?: 'Query', contactList: { __typename?: 'ContactList', id: string, name: string, contactsCount: number, createdAt: any, updatedAt: any } };

export type ContactListsQueryVariablesType = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactListsQueryType = { __typename?: 'Query', contactLists: { __typename?: 'ContactListConnection', count: number, nodes: Array<{ __typename?: 'ContactList', id: string, name: string, contactsCount: number, createdAt: any, updatedAt: any }> } };

export type EmailCampaignOptionsQueryVariablesType = Exact<{ [key: string]: never; }>;


export type EmailCampaignOptionsQueryType = { __typename?: 'Query', automations: { __typename?: 'AutomationConnection', nodes: Array<{ __typename?: 'Automation', id: string, name: string, kind: AutomationKindType }> } };

export type EmailTemplatePreviewQueryVariablesType = Exact<{
  input: EmailTemplateVariantInputType;
}>;


export type EmailTemplatePreviewQueryType = { __typename?: 'Query', emailTemplatePreview: { __typename?: 'EmailPreview', subject: string, html: string } };

export type EmailTemplateQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailTemplateQueryType = { __typename?: 'Query', emailTemplate: { __typename?: 'EmailTemplate', id: string, name: string, updatedAt: any, variants: Array<{ __typename?: 'EmailTemplateVariant', language: MarketingLanguageType, subject: string, preheader: string, blocks: Array<{ __typename?: 'EmailBlock', id: string, type: EmailBlockTypeType, text?: string | null, label?: string | null, url?: string | null, imageId?: string | null, imageUrl?: string | null, alt?: string | null, contentId?: string | null, productId?: string | null, source?: EmailDynamicSourceType | null, required: boolean }> }> } };

export type EmailTemplatesListQueryVariablesType = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmailTemplatesListQueryType = { __typename?: 'Query', emailTemplates: { __typename?: 'EmailTemplateConnection', count: number, nodes: Array<{ __typename?: 'EmailTemplate', id: string, name: string, updatedAt: any, variants: Array<{ __typename?: 'EmailTemplateVariant', language: MarketingLanguageType, subject: string }> }> } };

export type MarketingContactsQueryVariablesType = Exact<{
  listId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarketingContactsQueryType = { __typename?: 'Query', marketingContacts: { __typename?: 'MarketingContactConnection', count: number, nodes: Array<{ __typename?: 'MarketingContact', id: string, email: string, name?: string | null, language?: string | null, status: MarketingContactStatusType, isViewer: boolean, source: MarketingContactSourceType, createdAt: any }> } };

export type MarketingLimitsQueryVariablesType = Exact<{ [key: string]: never; }>;


export type MarketingLimitsQueryType = { __typename?: 'Query', marketingLimits: { __typename?: 'MarketingLimits', contactListsPerAudience: number, broadcastNameLength: number, audienceConditions: number, audienceValues: number, audienceMaxDays: number, audienceMaxNumber: number, emailUrlVariables: Array<string> } };

export type MarketingQuotaUsageQueryVariablesType = Exact<{ [key: string]: never; }>;


export type MarketingQuotaUsageQueryType = { __typename?: 'Query', marketingQuotaUsage: { __typename?: 'MarketingQuotaUsage', month: string, sent: number, quota: number } };

export type DisableOrganizationUserMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableOrganizationUserMutationType = { __typename?: 'Mutation', disableOrganizationUser: { __typename?: 'OrganizationUser', id: string, disabled: boolean } };

export type EnableOrganizationUserMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableOrganizationUserMutationType = { __typename?: 'Mutation', enableOrganizationUser: { __typename?: 'OrganizationUser', id: string, disabled: boolean } };

export type InviteOrganizationUserMutationVariablesType = Exact<{
  input: InviteOrganizationUserInputType;
}>;


export type InviteOrganizationUserMutationType = { __typename?: 'Mutation', inviteOrganizationUser: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, disabled: boolean, welcomeEmailSentAt?: any | null, createdAt: any, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } } };

export type ResendOrganizationUserInvitationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendOrganizationUserInvitationMutationType = { __typename?: 'Mutation', resendOrganizationUserInvitation: { __typename?: 'OrganizationUser', id: string, welcomeEmailSentAt?: any | null } };

export type UpdateOrganizationUserRolesMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  roles: Array<OrganizationRoleType> | OrganizationRoleType;
}>;


export type UpdateOrganizationUserRolesMutationType = { __typename?: 'Mutation', updateOrganizationUserRoles: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, disabled: boolean } };

export type OrganizationUserQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationUserQueryType = { __typename?: 'Query', organizationUser: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, disabled: boolean, welcomeEmailSentAt?: any | null, createdAt: any, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null }, invitedBy?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } };

export type OrganizationUsersListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationUsersFilterInputType>;
}>;


export type OrganizationUsersListQueryType = { __typename?: 'Query', organizationUsers: { __typename?: 'OrganizationUserConnection', count: number, nodes: Array<{ __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, disabled: boolean, welcomeEmailSentAt?: any | null, createdAt: any, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } }> } };

export type AvailableOrganizationsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AvailableOrganizationsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type PaymentsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PaymentsFilterInputType>;
}>;


export type PaymentsListQueryType = { __typename?: 'Query', payments: { __typename?: 'PaymentConnection', count: number, nodes: Array<{ __typename?: 'Payment', id: string, status: PaymentStatusType, provider: PaymentProviderType, buyerEmail?: string | null, userId: string, period: number, recurrent: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, providerFeeAmount?: { __typename?: 'Amount', value: number, currency: string } | null, ottkitFeeAmount?: { __typename?: 'Amount', value: number, currency: string } | null, organizationAmount?: { __typename?: 'Amount', value: number, currency: string } | null, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, product?: { __typename?: 'Product', id: string, title: string, type: ProductTypeType } | null, refunds: Array<{ __typename?: 'Refund', id: string, status: RefundStatusType, manual: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string } }> }> } };

export type CreatePlatformMenuItemMutationVariablesType = Exact<{
  input: CreatePlatformMenuItemInputType;
}>;


export type CreatePlatformMenuItemMutationType = { __typename?: 'Mutation', createPlatformMenuItem: { __typename?: 'PlatformMenuItem', id: string, index: number, label: string, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, publishAt?: any | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null } };

export type DeletePlatformMenuItemsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformMenuItemsMutationType = { __typename?: 'Mutation', deletePlatformMenuItems: Array<{ __typename?: 'PlatformMenuItem', id: string } | null> };

export type UpdatePlatformMenuItemMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformMenuItemInputType;
}>;


export type UpdatePlatformMenuItemMutationType = { __typename?: 'Mutation', updatePlatformMenuItem: { __typename?: 'PlatformMenuItem', id: string, index: number, label: string, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, publishAt?: any | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null } };

export type UpdatePlatformMenuItemsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdatePlatformMenuItemsInputType;
}>;


export type UpdatePlatformMenuItemsMutationType = { __typename?: 'Mutation', updatePlatformMenuItems: Array<{ __typename?: 'PlatformMenuItem', id: string, index: number, label: string, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, publishAt?: any | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null } | null> };

export type PlatformMenuItemQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformMenuItemQueryType = { __typename?: 'Query', platformMenuItem: { __typename?: 'PlatformMenuItem', id: string, index: number, label: string, publishAt?: any | null, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null } };

export type PlatformMenuItemsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformMenuItemsFilterInputType>;
}>;


export type PlatformMenuItemsListQueryType = { __typename?: 'Query', platformMenuItems: { __typename?: 'PlatformMenuItemConnection', count: number, nodes: Array<{ __typename?: 'PlatformMenuItem', id: string, index: number, label: string, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, publishAt?: any | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null }> } };

export type CreatePlatformPageMutationVariablesType = Exact<{
  input: CreatePlatformPageInputType;
}>;


export type CreatePlatformPageMutationType = { __typename?: 'Mutation', createPlatformPage: { __typename?: 'PlatformPage', id: string, title: string, path: string, url?: any | null, description?: string | null, publishAt?: any | null, isHomepage: boolean, countryCodes: Array<string>, image?: { __typename?: 'Banner', id: string, url: any } | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null, blocks: Array<{ __typename?: 'PlatformPageBlock', id: string, component: PlatformPageBlockTypeType, props: any, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type DeletePlatformPagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformPagesMutationType = { __typename?: 'Mutation', deletePlatformPages: Array<{ __typename?: 'PlatformPage', id: string } | null> };

export type UpdatePlatformPageMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformPageInputType;
}>;


export type UpdatePlatformPageMutationType = { __typename?: 'Mutation', updatePlatformPage: { __typename?: 'PlatformPage', id: string, title: string, path: string, url?: any | null, description?: string | null, publishAt?: any | null, isHomepage: boolean, countryCodes: Array<string>, image?: { __typename?: 'Banner', id: string, url: any } | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null, blocks: Array<{ __typename?: 'PlatformPageBlock', id: string, component: PlatformPageBlockTypeType, props: any, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type UpdatePlatformPagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdatePlatformPagesInputType;
}>;


export type UpdatePlatformPagesMutationType = { __typename?: 'Mutation', updatePlatformPages: Array<{ __typename?: 'PlatformPage', id: string, publishAt?: any | null } | null> };

export type PlatformPageQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformPageQueryType = { __typename?: 'Query', platformPage: { __typename?: 'PlatformPage', id: string, title: string, path: string, url?: any | null, description?: string | null, publishAt?: any | null, isHomepage: boolean, countryCodes: Array<string>, image?: { __typename?: 'Banner', id: string, url: any } | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null, blocks: Array<{ __typename?: 'PlatformPageBlock', id: string, component: PlatformPageBlockTypeType, props: any, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type PlatformPagesAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompletePlatformPagesFilterInputType>;
}>;


export type PlatformPagesAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type PlatformPagesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformPagesFilterInputType>;
}>;


export type PlatformPagesListQueryType = { __typename?: 'Query', platformPages: { __typename?: 'PlatformPageConnection', count: number, nodes: Array<{ __typename?: 'PlatformPage', id: string, title: string, path: string, url?: any | null, description?: string | null, publishAt?: any | null, createdAt: any, updatedAt: any, image?: { __typename?: 'Banner', id: string, url: any } | null, visibilityConditions?: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } | null }> } };

export type ConnectBunnyByAccountMutationVariablesType = Exact<{
  input: ConnectBunnyByAccountInputType;
}>;


export type ConnectBunnyByAccountMutationType = { __typename?: 'Mutation', connectBunnyByAccount: { __typename?: 'Platform', id: string, bunnySettings?: { __typename?: 'PlatformBunnySettings', libraryId: string, cdnHostname: string, apiKeyMask: string, connectedAt?: any | null } | null } };

export type ConnectCcBillMutationVariablesType = Exact<{
  input: ConnectCcBillInputType;
}>;


export type ConnectCcBillMutationType = { __typename?: 'Mutation', connectCCBill: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', provider?: PaymentProviderType | null, ccbill?: { __typename?: 'PlatformCCBillSettings', accnum: string, subaccount: string, flexFormId: string, saltMask: string, webhookUrl: string, supportUrl?: string | null, sandbox: boolean, connectedAt?: any | null } | null } | null } };

export type ConnectDomainMutationVariablesType = Exact<{
  input: ConnectDomainInputType;
}>;


export type ConnectDomainMutationType = { __typename?: 'Mutation', connectDomain: { __typename?: 'Platform', id: string, host?: string | null, domainSetup?: { __typename?: 'PlatformDomainSetup', host: string, status: PlatformDomainStatusType, zoneName?: string | null, lastError?: string | null, updatedAt: any, activatedAt?: any | null } | null } };

export type ConnectPayPalMutationVariablesType = Exact<{
  input: ConnectPayPalInputType;
}>;


export type ConnectPayPalMutationType = { __typename?: 'Mutation', connectPayPal: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', provider?: PaymentProviderType | null, paypal?: { __typename?: 'PlatformPayPalSettings', clientId: string, webhookUrl: string, sandbox: boolean, connectedAt?: any | null } | null } | null } };

export type ConnectPaynetMutationVariablesType = Exact<{
  input: ConnectPaynetInputType;
}>;


export type ConnectPaynetMutationType = { __typename?: 'Mutation', connectPaynet: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', publishableKey?: string | null, secretKeyMask?: string | null, connectedAt?: any | null, paynet?: { __typename?: 'PlatformPaynetSettings', merchantCode: string, secretKeyMask: string, saleArea?: string | null, connectedAt?: any | null } | null } | null } };

export type ConnectStripeMutationVariablesType = Exact<{
  input: ConnectStripeInputType;
}>;


export type ConnectStripeMutationType = { __typename?: 'Mutation', connectStripe: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', publishableKey?: string | null, secretKeyMask?: string | null, connectedAt?: any | null } | null } };

export type CreatePlatformCustomCoverMutationVariablesType = Exact<{
  input: CreatePlatformCustomCoverInputType;
}>;


export type CreatePlatformCustomCoverMutationType = { __typename?: 'Mutation', createPlatformCustomCover: { __typename?: 'PlatformCustomCover', id: string, buttonsColor: string, buttonsSize: string, brightness: number, align: string, alignMobile: string, verticalAlign: string, verticalAlignMobile: string, publishAt?: any | null, createdAt: any, updatedAt: any, title: { __typename?: 'PlatformCustomCoverTitle', text: string, color: string, size: string, weight: string }, subTitle: { __typename?: 'PlatformCustomCoverSubTitle', text: string, color: string, size: string, weight: string }, buttons: Array<{ __typename?: 'PlatformCustomCoverButton', text: string, link: string, variant: string, disabled: boolean }>, background: { __typename?: 'PlatformCustomCoverBackground', mobileImageId?: string | null, desktopImageId?: string | null, mobileVideoId?: string | null, desktopVideoId?: string | null } } };

export type DeletePlatformCustomCoversMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformCustomCoversMutationType = { __typename?: 'Mutation', deletePlatformCustomCovers: Array<{ __typename?: 'PlatformCustomCover', id: string } | null> };

export type DisconnectCcBillMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DisconnectCcBillMutationType = { __typename?: 'Mutation', disconnectCCBill: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', provider?: PaymentProviderType | null, ccbill?: { __typename?: 'PlatformCCBillSettings', accnum: string, subaccount: string, flexFormId: string, saltMask: string, webhookUrl: string, supportUrl?: string | null, sandbox: boolean, connectedAt?: any | null } | null } | null } };

export type DisconnectDomainMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DisconnectDomainMutationType = { __typename?: 'Mutation', disconnectDomain: { __typename?: 'Platform', id: string, host?: string | null, domainSetup?: { __typename?: 'PlatformDomainSetup', host: string, status: PlatformDomainStatusType, zoneName?: string | null, lastError?: string | null, updatedAt: any, activatedAt?: any | null } | null } };

export type DisconnectPayPalMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DisconnectPayPalMutationType = { __typename?: 'Mutation', disconnectPayPal: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', provider?: PaymentProviderType | null, paypal?: { __typename?: 'PlatformPayPalSettings', clientId: string, webhookUrl: string, sandbox: boolean, connectedAt?: any | null } | null } | null } };

export type DisconnectPaynetMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DisconnectPaynetMutationType = { __typename?: 'Mutation', disconnectPaynet: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', publishableKey?: string | null, secretKeyMask?: string | null, connectedAt?: any | null, paynet?: { __typename?: 'PlatformPaynetSettings', merchantCode: string, secretKeyMask: string, saleArea?: string | null, connectedAt?: any | null } | null } | null } };

export type DisconnectStripeMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DisconnectStripeMutationType = { __typename?: 'Mutation', disconnectStripe: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', publishableKey?: string | null, secretKeyMask?: string | null, connectedAt?: any | null } | null } };

export type RetryDomainSetupMutationVariablesType = Exact<{ [key: string]: never; }>;


export type RetryDomainSetupMutationType = { __typename?: 'Mutation', retryDomainSetup: { __typename?: 'Platform', id: string, host?: string | null, domainSetup?: { __typename?: 'PlatformDomainSetup', host: string, status: PlatformDomainStatusType, zoneName?: string | null, lastError?: string | null, updatedAt: any, activatedAt?: any | null } | null } };

export type RotateCcBillWebhookSecretMutationVariablesType = Exact<{ [key: string]: never; }>;


export type RotateCcBillWebhookSecretMutationType = { __typename?: 'Mutation', rotateCCBillWebhookSecret: { __typename?: 'Platform', id: string, paymentSettings?: { __typename?: 'PlatformPaymentSettings', ccbill?: { __typename?: 'PlatformCCBillSettings', webhookUrl: string } | null } | null } };

export type UpdateBunnySettingsMutationVariablesType = Exact<{
  input: UpdateBunnySettingsInputType;
}>;


export type UpdateBunnySettingsMutationType = { __typename?: 'Mutation', updateBunnySettings: { __typename?: 'Platform', id: string, bunnySettings?: { __typename?: 'PlatformBunnySettings', libraryId: string, cdnHostname: string, apiKeyMask: string, connectedAt?: any | null } | null } };

export type UpdateCurrentPlatformMutationVariablesType = Exact<{
  input: UpdateCurrentPlatformInputType;
}>;


export type UpdateCurrentPlatformMutationType = { __typename?: 'Mutation', updateCurrentPlatform: { __typename?: 'Platform', id: string, title: string, description?: string | null, gaId?: string | null, googleSiteVerification?: string | null, customHTML?: string | null, customHead?: string | null, logoId?: string | null, faviconId?: string | null, iconId?: string | null, languageId?: string | null, hideableHeader?: boolean | null, isLikesEnabled?: boolean | null, features: Array<PlatformFeatureType>, isLiveReactionsEnabled: boolean, liveReactionPhrases: Array<string>, liveReactionEmojis: Array<LiveReactionEmojiType>, parallelPremiumViewLimit?: number | null, streamSignalAlertsEnabled: boolean, isFavoritesEnabled?: boolean | null, isFeaturedVideosEnabled?: boolean | null, acceptTermsOfServiceOnSignIn?: boolean | null, defaultRowSize?: number | null, privacyPolicyUrl?: any | null, termsOfServiceUrl?: any | null, refundPolicyUrl?: any | null, language?: { __typename?: 'Language', id: string, code: string, title: string } | null, theme?: { __typename?: 'PlatformTheme', palette?: { __typename?: 'PlatformThemePalette', type: PlatformThemePaletteTypeType, primary?: string | null, secondary?: string | null, backgroundColor?: string | null } | null, typography?: { __typename?: 'PlatformThemeTypography', fontFamily?: string | null, headingFontFamily?: string | null } | null } | null, footer?: { __typename?: 'PlatformFooter', title?: string | null, subtitle?: string | null, social: Array<{ __typename?: 'PlatformSocial', type: PlatformSocialTypeType, link: any }> } | null, legalEntity?: { __typename?: 'PlatformLegalEntity', name: string, address: string, registrationNumber?: string | null, email?: string | null, phone?: string | null } | null, customTerms: Array<{ __typename?: 'PlatformCustomTerm', label: string, url: any }> } };

export type UpdatePlatformCustomCoverMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformCustomCoverInputType;
}>;


export type UpdatePlatformCustomCoverMutationType = { __typename?: 'Mutation', updatePlatformCustomCover: { __typename?: 'PlatformCustomCover', id: string, buttonsColor: string, buttonsSize: string, brightness: number, align: string, alignMobile: string, verticalAlign: string, verticalAlignMobile: string, publishAt?: any | null, createdAt: any, updatedAt: any, title: { __typename?: 'PlatformCustomCoverTitle', text: string, color: string, size: string, weight: string }, subTitle: { __typename?: 'PlatformCustomCoverSubTitle', text: string, color: string, size: string, weight: string }, buttons: Array<{ __typename?: 'PlatformCustomCoverButton', text: string, link: string, variant: string, disabled: boolean }>, background: { __typename?: 'PlatformCustomCoverBackground', mobileImageId?: string | null, desktopImageId?: string | null, mobileVideoId?: string | null, desktopVideoId?: string | null } } };

export type UpdatePlatformCustomCoversMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdatePlatformCustomCoversInputType;
}>;


export type UpdatePlatformCustomCoversMutationType = { __typename?: 'Mutation', updatePlatformCustomCovers: Array<{ __typename?: 'PlatformCustomCover', id: string, publishAt?: any | null } | null> };

export type UpdateStreamingSettingsMutationVariablesType = Exact<{
  input: UpdateStreamingSettingsInputType;
}>;


export type UpdateStreamingSettingsMutationType = { __typename?: 'Mutation', updateStreamingSettings: { __typename?: 'Platform', id: string, streamingSettings?: { __typename?: 'PlatformStreamingSettings', accountId: string, apiTokenMask: string, connectedAt?: any | null } | null } };

export type BunnyAccountLibrariesQueryVariablesType = Exact<{
  accountApiKey: Scalars['String']['input'];
}>;


export type BunnyAccountLibrariesQueryType = { __typename?: 'Query', bunnyAccountLibraries: Array<{ __typename?: 'BunnyAccountLibrary', id: string, name: string, videoCount: number, replicationRegions: Array<string> }> };

export type CurrentPlatformQueryVariablesType = Exact<{ [key: string]: never; }>;


export type CurrentPlatformQueryType = { __typename?: 'Query', currentPlatform?: { __typename?: 'Platform', id: string, title: string, slug: string, host?: string | null, url?: any | null, description?: string | null, gaId?: string | null, googleSiteVerification?: string | null, customHTML?: string | null, customHead?: string | null, logoId?: string | null, faviconId?: string | null, iconId?: string | null, languageId?: string | null, hideableHeader?: boolean | null, isLikesEnabled?: boolean | null, isFavoritesEnabled?: boolean | null, isFeaturedVideosEnabled?: boolean | null, isVideoChatEnabled?: boolean | null, isStreamChatEnabled?: boolean | null, isComplianceEnabled?: boolean | null, features: Array<PlatformFeatureType>, isLiveReactionsEnabled: boolean, liveReactionPhrases: Array<string>, liveReactionEmojis: Array<LiveReactionEmojiType>, parallelPremiumViewLimit?: number | null, streamSignalAlertsEnabled: boolean, complianceCustodianName?: string | null, complianceCustodianAddress?: string | null, acceptTermsOfServiceOnSignIn?: boolean | null, defaultRowSize?: number | null, privacyPolicyUrl?: any | null, termsOfServiceUrl?: any | null, refundPolicyUrl?: any | null, effectiveVideoProvider: VideoProviderType, streamingAvailable: boolean, logo?: { __typename?: 'Avatar', url: any } | null, language?: { __typename?: 'Language', id: string, code: string, title: string } | null, marketingSettings: { __typename?: 'MarketingSettings', consentMode: MarketingConsentModeType, frequencyCapCount: number, frequencyCapDays: number, consentModeChangedAt?: any | null }, theme?: { __typename?: 'PlatformTheme', palette?: { __typename?: 'PlatformThemePalette', type: PlatformThemePaletteTypeType, primary?: string | null, secondary?: string | null, backgroundColor?: string | null } | null, typography?: { __typename?: 'PlatformThemeTypography', fontFamily?: string | null, headingFontFamily?: string | null } | null } | null, footer?: { __typename?: 'PlatformFooter', title?: string | null, subtitle?: string | null, social: Array<{ __typename?: 'PlatformSocial', type: PlatformSocialTypeType, link: any }> } | null, legalEntity?: { __typename?: 'PlatformLegalEntity', name: string, address: string, registrationNumber?: string | null, email?: string | null, phone?: string | null } | null, customTerms: Array<{ __typename?: 'PlatformCustomTerm', label: string, url: any }>, streamingSettings?: { __typename?: 'PlatformStreamingSettings', accountId: string, apiTokenMask: string, connectedAt?: any | null } | null, bunnySettings?: { __typename?: 'PlatformBunnySettings', libraryId: string, cdnHostname: string, apiKeyMask: string, connectedAt?: any | null } | null, paymentSettings?: { __typename?: 'PlatformPaymentSettings', publishableKey?: string | null, secretKeyMask?: string | null, connectedAt?: any | null, provider?: PaymentProviderType | null, paynet?: { __typename?: 'PlatformPaynetSettings', merchantCode: string, secretKeyMask: string, saleArea?: string | null, connectedAt?: any | null } | null, ccbill?: { __typename?: 'PlatformCCBillSettings', accnum: string, subaccount: string, flexFormId: string, saltMask: string, webhookUrl: string, supportUrl?: string | null, sandbox: boolean, connectedAt?: any | null } | null, paypal?: { __typename?: 'PlatformPayPalSettings', clientId: string, webhookUrl: string, sandbox: boolean, connectedAt?: any | null } | null } | null, domainSetup?: { __typename?: 'PlatformDomainSetup', host: string, status: PlatformDomainStatusType, provider: DomainProviderType, zoneName?: string | null, dnsManaged: boolean, lastError?: string | null, previousStatus?: PlatformDomainStatusType | null, statusChangedAt: any, updatedAt: any, activatedAt?: any | null, manualRecords: Array<{ __typename?: 'DomainDnsRecord', type: string, name: string, value: string }> } | null } | null };

export type PlatformCustomCoverQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformCustomCoverQueryType = { __typename?: 'Query', platformCustomCover: { __typename?: 'PlatformCustomCover', id: string, buttonsColor: string, buttonsSize: string, brightness: number, align: string, alignMobile: string, verticalAlign: string, verticalAlignMobile: string, publishAt?: any | null, createdAt: any, updatedAt: any, title: { __typename?: 'PlatformCustomCoverTitle', text: string, color: string, size: string, weight: string }, subTitle: { __typename?: 'PlatformCustomCoverSubTitle', text: string, color: string, size: string, weight: string }, buttons: Array<{ __typename?: 'PlatformCustomCoverButton', text: string, link: string, variant: string, disabled: boolean }>, background: { __typename?: 'PlatformCustomCoverBackground', mobileImageId?: string | null, desktopImageId?: string | null, mobileVideoId?: string | null, desktopVideoId?: string | null }, mobileImage?: { __typename?: 'Banner', id: string, url: any } | null, desktopImage?: { __typename?: 'Banner', id: string, url: any } | null, mobileVideo?: { __typename?: 'VideoFile', id: string, status: VideoFileStatusType, playlistUrl?: any | null, posterUrl?: any | null } | null, desktopVideo?: { __typename?: 'VideoFile', id: string, status: VideoFileStatusType, playlistUrl?: any | null, posterUrl?: any | null } | null } };

export type PlatformCustomCoversQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformCustomCoversFilterInputType>;
}>;


export type PlatformCustomCoversQueryType = { __typename?: 'Query', platformCustomCovers: { __typename?: 'PlatformCustomCoverConnection', count: number, nodes: Array<{ __typename?: 'PlatformCustomCover', id: string, buttonsColor: string, buttonsSize: string, brightness: number, align: string, alignMobile: string, verticalAlign: string, verticalAlignMobile: string, publishAt?: any | null, createdAt: any, updatedAt: any, title: { __typename?: 'PlatformCustomCoverTitle', text: string, color: string, size: string, weight: string }, subTitle: { __typename?: 'PlatformCustomCoverSubTitle', text: string, color: string, size: string, weight: string }, buttons: Array<{ __typename?: 'PlatformCustomCoverButton', text: string, link: string, variant: string, disabled: boolean }>, background: { __typename?: 'PlatformCustomCoverBackground', mobileImageId?: string | null, desktopImageId?: string | null, mobileVideoId?: string | null, desktopVideoId?: string | null } }> } };

export type CloseContentPollMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloseContentPollMutationType = { __typename?: 'Mutation', closeContentPoll: { __typename?: 'ContentPoll', id: string, status?: PollStatusType | null, closedAt?: any | null } };

export type CreateContentPollMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  input: ContentPollScheduleInputType;
}>;


export type CreateContentPollMutationType = { __typename?: 'Mutation', createContentPoll: { __typename?: 'ContentPoll', id: string } };

export type CreatePollMutationVariablesType = Exact<{
  input: CreatePollInputType;
}>;


export type CreatePollMutationType = { __typename?: 'Mutation', createPoll: { __typename?: 'Poll', id: string, question: string } };

export type DeleteContentPollMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContentPollMutationType = { __typename?: 'Mutation', deleteContentPoll: { __typename?: 'ContentPoll', id: string } };

export type DeletePollsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePollsMutationType = { __typename?: 'Mutation', deletePolls: Array<{ __typename?: 'Poll', id: string }> };

export type OpenContentPollMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpenContentPollMutationType = { __typename?: 'Mutation', openContentPoll: { __typename?: 'ContentPoll', id: string, status?: PollStatusType | null, openedAt?: any | null } };

export type UpdateContentPollMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: ContentPollScheduleInputType;
}>;


export type UpdateContentPollMutationType = { __typename?: 'Mutation', updateContentPoll: { __typename?: 'ContentPoll', id: string, trigger: PollTriggerType, offsetSeconds?: number | null, startsAt?: any | null, autoCloseSeconds?: number | null, status?: PollStatusType | null } };

export type UpdatePollMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePollInputType;
}>;


export type UpdatePollMutationType = { __typename?: 'Mutation', updatePoll: { __typename?: 'Poll', id: string, question: string, isMultiple: boolean, resultsMode: PollResultsModeType, updatedAt: any, options: Array<{ __typename?: 'PollOption', id: string, text: string, isCorrect: boolean }>, usage: { __typename?: 'PollUsage', attachmentsCount: number, isLocked: boolean } } };

export type ContentPollsQueryVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type ContentPollsQueryType = { __typename?: 'Query', contentPolls: Array<{ __typename?: 'ContentPoll', id: string, contentId: string, pollId: string, question: string, isMultiple: boolean, resultsMode: PollResultsModeType, trigger: PollTriggerType, offsetSeconds?: number | null, startsAt?: any | null, autoCloseSeconds?: number | null, status?: PollStatusType | null, openedAt?: any | null, closedAt?: any | null, votersCount: number, correctVotersCount: number, createdAt: any, options: Array<{ __typename?: 'ContentPollOption', id: string, text: string, isCorrect: boolean, votes: number }> }> };

export type PollQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PollQueryType = { __typename?: 'Query', poll: { __typename?: 'Poll', id: string, question: string, isMultiple: boolean, resultsMode: PollResultsModeType, createdAt: any, updatedAt: any, options: Array<{ __typename?: 'PollOption', id: string, text: string, isCorrect: boolean }>, usage: { __typename?: 'PollUsage', attachmentsCount: number, isLocked: boolean } } };

export type PollsListQueryVariablesType = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PollsListQueryType = { __typename?: 'Query', polls: { __typename?: 'PollConnection', count: number, nodes: Array<{ __typename?: 'Poll', id: string, question: string, isMultiple: boolean, resultsMode: PollResultsModeType, createdAt: any, options: Array<{ __typename?: 'PollOption', id: string, text: string, isCorrect: boolean }>, usage: { __typename?: 'PollUsage', attachmentsCount: number, isLocked: boolean } }> } };

export type CreatePostMutationVariablesType = Exact<{
  input: CreatePostInputType;
}>;


export type CreatePostMutationType = { __typename?: 'Mutation', createPost: { __typename?: 'Post', id: string, title: string, description?: string | null, text?: string | null, slug?: string | null, publishAt?: any | null, accessOnlyViaLink: boolean, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', id: string, title: string }, image: { __typename?: 'Image', id: string, url: any }, tags: Array<{ __typename?: 'Tag', id: string, title: string }> } };

export type DeletePostsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePostsMutationType = { __typename?: 'Mutation', deletePosts: Array<{ __typename?: 'Post', id: string } | null> };

export type UpdatePostMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePostInputType;
}>;


export type UpdatePostMutationType = { __typename?: 'Mutation', updatePost: { __typename?: 'Post', id: string, title: string, description?: string | null, text?: string | null, slug?: string | null, publishAt?: any | null, accessOnlyViaLink: boolean, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', id: string, title: string }, image: { __typename?: 'Image', id: string, url: any }, tags: Array<{ __typename?: 'Tag', id: string, title: string }> } };

export type UpdatePostsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdatePostsInputType;
}>;


export type UpdatePostsMutationType = { __typename?: 'Mutation', updatePosts: Array<{ __typename?: 'Post', id: string, title: string, description?: string | null, text?: string | null, slug?: string | null, publishAt?: any | null, accessOnlyViaLink: boolean, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', id: string, title: string }, image: { __typename?: 'Image', id: string, url: any }, tags: Array<{ __typename?: 'Tag', id: string, title: string }> } | null> };

export type PostQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostQueryType = { __typename?: 'Query', post: { __typename?: 'Post', id: string, title: string, description?: string | null, text?: string | null, slug?: string | null, path?: string | null, url?: any | null, publishAt?: any | null, accessOnlyViaLink: boolean, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', id: string, title: string }, image: { __typename?: 'Image', id: string, url: any }, tags: Array<{ __typename?: 'Tag', id: string, title: string }> } };

export type PostsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PostsFilterInputType>;
}>;


export type PostsListQueryType = { __typename?: 'Query', posts: { __typename?: 'PostConnection', count: number, nodes: Array<{ __typename?: 'Post', id: string, title: string, path?: string | null, url?: any | null, publishAt?: any | null, accessOnlyViaLink: boolean, createdAt: any, updatedAt: any, image: { __typename?: 'Image', id: string, url: any }, tags: Array<{ __typename?: 'Tag', id: string, title: string }> }> } };

export type EventCancelItemFieldsFragmentType = { __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null };

export type EventCancelProgressFieldsFragmentType = { __typename?: 'EventCancelProgress', startedAt: any, finishedAt?: any | null, message?: string | null, total: number, refunded: number, manual: number, free: number, disputed: number, failed: number, pending: number, failures: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }>, manualItems: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> };

export type CancelEventMutationVariablesType = Exact<{
  input: CancelEventInputType;
}>;


export type CancelEventMutationType = { __typename?: 'Mutation', cancelEvent: { __typename?: 'Product', id: string, eventCancel?: { __typename?: 'ProductEventCancel', startedAt: any, finishedAt?: any | null, message?: string | null } | null } };

export type CreateProductMutationVariablesType = Exact<{
  input: CreateProductInputType;
}>;


export type CreateProductMutationType = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, type: ProductTypeType, title: string, description?: string | null, status: ProductStatusType, publishAt?: any | null, eventStartAt?: any | null, eventFinishAt?: any | null, startAt: any, finishAt: any, finishSalesAt?: any | null, showContent: boolean, hideInGeneralLists: boolean, perContentPurchase: boolean, siteUrl: string, videosCount: number, streamsCount: number, collectionsCount: number, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, prices: Array<{ __typename?: 'ProductPrice', id: string, currency: ProductCurrencyType, period: number, trialPeriod: number, trialValue: number, countryAccessId?: string | null, periods: Array<{ __typename?: 'ProductPricePeriod', id: string, dateFrom: any, value: number, oldValue?: number | null }> }> } };

export type DeleteProductsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteProductsMutationType = { __typename?: 'Mutation', deleteProducts: Array<string> };

export type RetryEventCancelMutationVariablesType = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type RetryEventCancelMutationType = { __typename?: 'Mutation', retryEventCancel?: { __typename?: 'EventCancelProgress', startedAt: any, finishedAt?: any | null, message?: string | null, total: number, refunded: number, manual: number, free: number, disputed: number, failed: number, pending: number, failures: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }>, manualItems: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> } | null };

export type UpdateProductMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProductInputType;
}>;


export type UpdateProductMutationType = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, type: ProductTypeType, title: string, description?: string | null, status: ProductStatusType, publishAt?: any | null, eventStartAt?: any | null, eventFinishAt?: any | null, startAt: any, finishAt: any, finishSalesAt?: any | null, showContent: boolean, hideInGeneralLists: boolean, perContentPurchase: boolean, siteUrl: string, videosCount: number, streamsCount: number, collectionsCount: number, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, prices: Array<{ __typename?: 'ProductPrice', id: string, currency: ProductCurrencyType, period: number, trialPeriod: number, trialValue: number, countryAccessId?: string | null, periods: Array<{ __typename?: 'ProductPricePeriod', id: string, dateFrom: any, value: number, oldValue?: number | null }> }> } };

export type UpdateProductsMutationVariablesType = Exact<{
  input: Array<UpdateProductsInputType> | UpdateProductsInputType;
}>;


export type UpdateProductsMutationType = { __typename?: 'Mutation', updateProducts: Array<{ __typename?: 'Product', id: string, publishAt?: any | null }> };

export type AutocompleteProductsQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  type?: InputMaybe<ProductTypeType>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AutocompleteProductsQueryType = { __typename?: 'Query', autocompleteProducts: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type EventCancelPreviewQueryVariablesType = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type EventCancelPreviewQueryType = { __typename?: 'Query', eventCancelPreview: { __typename?: 'EventCancelPreview', productTitle: string, purchases: number, free: number, liveStreams: number, pendingStreams: number, sharedStreams: number, unknownPayments: number, amount?: { __typename?: 'Amount', value: number, currency: string } | null, byProvider: Array<{ __typename?: 'EventCancelProviderTotal', provider: PaymentProviderType, count: number, amount?: { __typename?: 'Amount', value: number, currency: string } | null }>, manualItems: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> } };

export type EventCancelProgressQueryVariablesType = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type EventCancelProgressQueryType = { __typename?: 'Query', eventCancelProgress?: { __typename?: 'EventCancelProgress', startedAt: any, finishedAt?: any | null, message?: string | null, total: number, refunded: number, manual: number, free: number, disputed: number, failed: number, pending: number, failures: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }>, manualItems: Array<{ __typename?: 'EventCancelItem', purchaseId: string, buyerEmail?: string | null, provider?: PaymentProviderType | null, providerPaymentId?: string | null, error?: string | null, pendingRefundId?: string | null, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> } | null };

export type ProductQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductQueryType = { __typename?: 'Query', product: { __typename?: 'Product', id: string, type: ProductTypeType, title: string, description?: string | null, status: ProductStatusType, publishAt?: any | null, eventStartAt?: any | null, eventFinishAt?: any | null, startAt: any, finishAt: any, finishSalesAt?: any | null, showContent: boolean, hideInGeneralLists: boolean, perContentPurchase: boolean, siteUrl: string, videosCount: number, streamsCount: number, collectionsCount: number, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, prices: Array<{ __typename?: 'ProductPrice', id: string, currency: ProductCurrencyType, period: number, trialPeriod: number, trialValue: number, countryAccessId?: string | null, periods: Array<{ __typename?: 'ProductPricePeriod', id: string, dateFrom: any, value: number, oldValue?: number | null }> }>, eventCancel?: { __typename?: 'ProductEventCancel', startedAt: any, finishedAt?: any | null, message?: string | null } | null } };

export type ProductsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  countryAccessId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ProductStatusType>;
  types?: InputMaybe<Array<ProductTypeType> | ProductTypeType>;
}>;


export type ProductsListQueryType = { __typename?: 'Query', products: { __typename?: 'ProductConnection', count: number, nodes: Array<{ __typename?: 'Product', id: string, type: ProductTypeType, title: string, status: ProductStatusType, publishAt?: any | null, startAt: any, finishAt: any, finishSalesAt?: any | null, showContent: boolean, hideInGeneralLists: boolean, perContentPurchase: boolean, siteUrl: string, videosCount: number, streamsCount: number, collectionsCount: number, createdAt: any, updatedAt: any, preview?: { __typename?: 'Image', id: string, url: any } | null, prices: Array<{ __typename?: 'ProductPrice', id: string, currency: ProductCurrencyType, period: number, trialPeriod: number, trialValue: number, countryAccessId?: string | null, periods: Array<{ __typename?: 'ProductPricePeriod', id: string, dateFrom: any, value: number, oldValue?: number | null }> }> }> } };

export type StreamEventProductsQueryVariablesType = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type StreamEventProductsQueryType = { __typename?: 'Query', products: { __typename?: 'ProductConnection', nodes: Array<{ __typename?: 'Product', id: string, title: string, eventCancel?: { __typename?: 'ProductEventCancel', startedAt: any } | null }> } };

export type CreateMultiplePromocodesMutationVariablesType = Exact<{
  input: CreateMultiplePromocodesInputType;
}>;


export type CreateMultiplePromocodesMutationType = { __typename?: 'Mutation', createMultiplePromocodes: Array<{ __typename?: 'Promocode', id: string, title: string, createdAt: any, updatedAt: any, promocodeCampaign?: { __typename?: 'PromocodeCampaign', id: string, title: string } | null }> };

export type CreatePromocodeMutationVariablesType = Exact<{
  input: CreatePromocodeInputType;
}>;


export type CreatePromocodeMutationType = { __typename?: 'Mutation', createPromocode: { __typename?: 'Promocode', id: string, title: string, createdAt: any, updatedAt: any } };

export type DeletePromocodesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePromocodesMutationType = { __typename?: 'Mutation', deletePromocodes: Array<string> };

export type UpdatePromocodeMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePromocodeInputType;
}>;


export type UpdatePromocodeMutationType = { __typename?: 'Mutation', updatePromocode: { __typename?: 'Promocode', id: string, title: string, createdAt: any, updatedAt: any } };

export type AutocompletePromocodeCampaignsQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AutocompletePromocodeCampaignsQueryType = { __typename?: 'Query', autocompletePromocodeCampaigns: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type PromocodeQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromocodeQueryType = { __typename?: 'Query', promocode?: { __typename?: 'Promocode', id: string, title: string, code: string, productIds: Array<string>, limit?: number | null, amount?: number | null, discount?: number | null, activations: number, trialPeriod?: number | null, type: PromocodeTypeType, startAt?: any | null, finishAt?: any | null, createdAt: any, updatedAt: any, totalRevenue: { __typename?: 'PromocodeRevenue', value: number, currency: ProductCurrencyType }, promocodeCampaign?: { __typename?: 'PromocodeCampaign', id: string, title: string } | null } | null };

export type PromocodesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PromocodesFilterInputType>;
}>;


export type PromocodesListQueryType = { __typename?: 'Query', promocodes: { __typename?: 'PromocodeConnection', count: number, nodes: Array<{ __typename?: 'Promocode', id: string, title: string, code: string, productIds: Array<string>, limit?: number | null, amount?: number | null, discount?: number | null, activations: number, trialPeriod?: number | null, type: PromocodeTypeType, startAt?: any | null, finishAt?: any | null, createdAt: any, updatedAt: any, totalRevenue: { __typename?: 'PromocodeRevenue', value: number, currency: ProductCurrencyType }, promocodeCampaign?: { __typename?: 'PromocodeCampaign', id: string, title: string } | null }> } };

export type TerminateProductPurchaseMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TerminateProductPurchaseMutationType = { __typename?: 'Mutation', terminateProductPurchase: { __typename?: 'ProductPurchase', id: string, startAt: any, expiredAt: any } };

export type UpdateProductPurchaseMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProductPurchaseInputType;
}>;


export type UpdateProductPurchaseMutationType = { __typename?: 'Mutation', updateProductPurchase: { __typename?: 'ProductPurchase', id: string, startAt: any, expiredAt: any } };

export type PurchasesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductPurchasesFilterInputType>;
}>;


export type PurchasesListQueryType = { __typename?: 'Query', productPurchases: { __typename?: 'ProductPurchaseConnection', count: number, nodes: Array<{ __typename?: 'ProductPurchase', id: string, type: ProductPurchaseTypeType, startAt: any, expiredAt: any, refunded: boolean, disputed: boolean, buyerEmail?: string | null, userId: string, linkReward?: { __typename?: 'Amount', value: number, currency: string } | null, product: { __typename?: 'Product', id: string, title: string }, payment?: { __typename?: 'Payment', id: string, provider: PaymentProviderType, period: number, recurrent: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, providerFeeAmount?: { __typename?: 'Amount', value: number, currency: string } | null, ottkitFeeAmount?: { __typename?: 'Amount', value: number, currency: string } | null, organizationAmount?: { __typename?: 'Amount', value: number, currency: string } | null, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, refunds: Array<{ __typename?: 'Refund', id: string, status: RefundStatusType, manual: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string } }> } | null, subscription?: { __typename?: 'ProductSubscription', id: string, status: SubscriptionStatusType, renewSubscription: boolean, billingCyclesComplete: number, renewAttempts: number, nextRenewAttemptAt?: any | null, renewErrorReason?: RenewErrorReasonType | null, renewDeadlineAt?: any | null } | null }> } };

export type CreateRefundMutationVariablesType = Exact<{
  input: CreateRefundInputType;
}>;


export type CreateRefundMutationType = { __typename?: 'Mutation', createRefund: { __typename?: 'Refund', id: string, status: RefundStatusType, manual: boolean, amount: { __typename?: 'Amount', value: number, currency: string }, payment?: { __typename?: 'Payment', id: string, status: PaymentStatusType, refunds: Array<{ __typename?: 'Refund', id: string, status: RefundStatusType, manual: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string } }> } | null } };

export type ReconcileRefundMutationVariablesType = Exact<{
  refundId: Scalars['ID']['input'];
  refunded: Scalars['Boolean']['input'];
}>;


export type ReconcileRefundMutationType = { __typename?: 'Mutation', reconcileRefund: { __typename?: 'Refund', id: string, status: RefundStatusType, reconciledAt?: any | null } };

export type RefundsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RefundsFilterInputType>;
}>;


export type RefundsListQueryType = { __typename?: 'Query', refunds: { __typename?: 'RefundConnection', count: number, nodes: Array<{ __typename?: 'Refund', id: string, status: RefundStatusType, manual: boolean, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string }, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, payment?: { __typename?: 'Payment', buyerEmail?: string | null, userId: string, provider: PaymentProviderType, product?: { __typename?: 'Product', id: string, title: string, type: ProductTypeType } | null } | null }> } };

export type CreateReportMutationVariablesType = Exact<{
  input: CreateReportInputType;
}>;


export type CreateReportMutationType = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string, status: ReportStatusType, progress: number } };

export type DownloadReportMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadReportMutationType = { __typename?: 'Mutation', downloadReport: { __typename?: 'ReportDownload', url: any } };

export type ReportQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQueryType = { __typename?: 'Query', report: { __typename?: 'Report', id: string, type: ReportTypeType, widget?: AnalyticsWidgetType | null, status: ReportStatusType, progress: number, rowCount?: number | null, fileName: string, createdAt: any, completedAt?: any | null, expiresAt: any, error?: { __typename?: 'ReportError', code: string, message: string } | null } };

export type ReportsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ReportsFilterInputType>;
}>;


export type ReportsListQueryType = { __typename?: 'Query', reports: { __typename?: 'ReportConnection', count: number, nodes: Array<{ __typename?: 'Report', id: string, type: ReportTypeType, widget?: AnalyticsWidgetType | null, filter?: any | null, status: ReportStatusType, progress: number, rowCount?: number | null, fileName: string, createdAt: any, completedAt?: any | null, downloadedAt?: any | null, expiresAt: any, error?: { __typename?: 'ReportError', code: string, message: string } | null, creator?: { __typename?: 'User', id: string, email?: string | null } | null }> } };

export type StorageBreakdownQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StorageBreakdownSortType>;
  onlyUnwatched?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StorageBreakdownQueryType = { __typename?: 'Query', storageBreakdown: { __typename?: 'StorageBreakdown', totalCount: number, items: Array<{ __typename?: 'StorageBreakdownItem', contentId: string, title: string, createdAt: any, durationSeconds: number, storageMinutes: number, storageBytes?: number | null, estimated: boolean, storageCostUsdMonth: number, viewsLast90Days: number, watchedMinutesLast90Days: number, onSale: boolean, hasPurchases: boolean }>, totals: { __typename?: 'StorageBreakdownTotals', contentsCount: number, durationSeconds: number, storageMinutes: number, storageBytes?: number | null, storageCostUsdMonth: number, unwatchedCount: number, unwatchedCostUsdMonth: number } } };

export type UsageHistoryQueryVariablesType = Exact<{
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  calendarInterval?: InputMaybe<CalendarIntervalType>;
}>;


export type UsageHistoryQueryType = { __typename?: 'Query', usageHistory: { __typename?: 'AnalyticsChart', calendarInterval: CalendarIntervalType, items: Array<{ __typename?: 'AnalyticsChartItem', label: string, displayCurrency?: PaymentCurrencyType | null, data: Array<{ __typename?: 'AnalyticsChartPoint', x: any, y: number }> }> } };

export type AttachStreamEntrypointMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  contentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AttachStreamEntrypointMutationType = { __typename?: 'Mutation', attachStreamEntrypoint: { __typename?: 'StreamEntrypoint', id: string, stream?: { __typename?: 'Content', id: string, title: string } | null } };

export type CreateStreamEntrypointMutationVariablesType = Exact<{
  input: CreateStreamEntrypointInputType;
}>;


export type CreateStreamEntrypointMutationType = { __typename?: 'Mutation', createStreamEntrypoint: { __typename?: 'StreamEntrypoint', id: string } };

export type DeleteStreamEntrypointsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteStreamEntrypointsMutationType = { __typename?: 'Mutation', deleteStreamEntrypoints: boolean };

export type StartEntrypointPullMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  sourceUrl: Scalars['String']['input'];
}>;


export type StartEntrypointPullMutationType = { __typename?: 'Mutation', startEntrypointPull: { __typename?: 'StreamEntrypoint', id: string, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } };

export type StopEntrypointPullMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopEntrypointPullMutationType = { __typename?: 'Mutation', stopEntrypointPull: { __typename?: 'StreamEntrypoint', id: string, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } };

export type UpdateStreamEntrypointMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateStreamEntrypointInputType;
}>;


export type UpdateStreamEntrypointMutationType = { __typename?: 'Mutation', updateStreamEntrypoint: { __typename?: 'StreamEntrypoint', id: string, title: string } };

export type StreamEntrypointMonitoringQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type StreamEntrypointMonitoringQueryType = { __typename?: 'Query', streamEntrypoint: { __typename?: 'StreamEntrypoint', id: string, signal?: { __typename?: 'StreamSignal', state: StreamSignalStateType, since: any, checkedAt: any } | null, stream?: { __typename?: 'Content', id: string, viewersOnline: number } | null, monitoring: { __typename?: 'LiveInputMonitoring', available: boolean, unavailableReason?: MonitoringUnavailableReasonType | null, granularity: MonitoringGranularityType, status?: { __typename?: 'LiveInputStatus', connected: boolean, protocol?: string | null, since?: any | null, reason?: string | null } | null, points: Array<{ __typename?: 'LiveInputMetricsPoint', at: any, bitRateKbps?: number | null, keyframeIntervalSeconds?: number | null, uploadSpeedPercent?: number | null }>, events: Array<{ __typename?: 'LiveInputEvent', at: any, code: string, description: string, isWarning: boolean }>, sessions: Array<{ __typename?: 'LiveInputSession', start: any, end?: any | null, outcome: LiveInputSessionOutcomeType, eventCount: number, warningCount: number, hadStartupWarnings: boolean }>, outages: { __typename?: 'LiveInputOutages', count: number, totalSeconds: number, lastAt?: any | null, periods: Array<{ __typename?: 'LiveInputOutagePeriod', start: any, end: any }> }, player?: { __typename?: 'PlayerMetrics', points: Array<{ __typename?: 'PlayerMetricsPoint', at: any, viewers: number, bufferLengthSeconds?: number | null, bufferStarvationSeconds?: number | null }>, byResolution: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }>, byCountry: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }> } | null } } };

export type StreamEntrypointQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StreamEntrypointQueryType = { __typename?: 'Query', streamEntrypoint: { __typename?: 'StreamEntrypoint', id: string, title: string, rtmpsUrl: any, rtmpsStreamKey: string, srtUrl: any, srtStreamId: string, srtPassphrase: string, rtmpsPlaybackUrl?: string | null, rtmpsPlaybackStreamKey?: string | null, srtPlaybackUrl?: string | null, srtPlaybackStreamId?: string | null, srtPlaybackPassphrase?: string | null, liveConnected: boolean, createdAt: any, updatedAt: any, stream?: { __typename?: 'Content', id: string, title: string } | null, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null, playback?: { __typename?: 'ContentPlayback', token: string, hlsUrl: any, dashUrl?: any | null, iframeUrl?: any | null, thumbnailUrl: any } | null } };

export type StreamEntrypointsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type StreamEntrypointsListQueryType = { __typename?: 'Query', streamEntrypoints: { __typename?: 'StreamEntrypointConnection', count: number, nodes: Array<{ __typename?: 'StreamEntrypoint', id: string, title: string, rtmpsUrl: any, liveConnected: boolean, createdAt: any, stream?: { __typename?: 'Content', id: string, title: string } | null }> } };

export type StreamingUsageQueryVariablesType = Exact<{ [key: string]: never; }>;


export type StreamingUsageQueryType = { __typename?: 'Query', streamingUsage: { __typename?: 'StreamingUsage', connected: boolean, viewedMinutes?: number | null, periodStart?: any | null, periodEnd?: any | null, billingScopeMissing: boolean, analyticsScopeMissing: boolean, storage?: { __typename?: 'StreamingUsageStorage', usedMinutes: number, limitMinutes: number, videoCount: number, usedBytes?: number | null } | null, subscription?: { __typename?: 'StreamingUsageSubscription', planName?: string | null, price: number, currency: string, frequency: string } | null, cost?: { __typename?: 'StreamingUsageCost', subscription?: number | null, delivery?: number | null, storage?: number | null, total?: number | null } | null, alerts: Array<{ __typename?: 'UsageAlert', kind: UsageAlertKindType, severity: UsageAlertSeverityType, value: number, threshold: number }> } };

export type LiveInputMonitoringFieldsFragmentType = { __typename?: 'LiveInputMonitoring', available: boolean, unavailableReason?: MonitoringUnavailableReasonType | null, granularity: MonitoringGranularityType, status?: { __typename?: 'LiveInputStatus', connected: boolean, protocol?: string | null, since?: any | null, reason?: string | null } | null, points: Array<{ __typename?: 'LiveInputMetricsPoint', at: any, bitRateKbps?: number | null, keyframeIntervalSeconds?: number | null, uploadSpeedPercent?: number | null }>, events: Array<{ __typename?: 'LiveInputEvent', at: any, code: string, description: string, isWarning: boolean }>, sessions: Array<{ __typename?: 'LiveInputSession', start: any, end?: any | null, outcome: LiveInputSessionOutcomeType, eventCount: number, warningCount: number, hadStartupWarnings: boolean }>, outages: { __typename?: 'LiveInputOutages', count: number, totalSeconds: number, lastAt?: any | null, periods: Array<{ __typename?: 'LiveInputOutagePeriod', start: any, end: any }> }, player?: { __typename?: 'PlayerMetrics', points: Array<{ __typename?: 'PlayerMetricsPoint', at: any, viewers: number, bufferLengthSeconds?: number | null, bufferStarvationSeconds?: number | null }>, byResolution: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }>, byCountry: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }> } | null };

export type CheckStreamConnectionMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type CheckStreamConnectionMutationType = { __typename?: 'Mutation', checkStreamConnection: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, liveConnected: boolean } | null } };

export type CreateRestreamDestinationMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  input: CreateRestreamDestinationInputType;
}>;


export type CreateRestreamDestinationMutationType = { __typename?: 'Mutation', createRestreamDestination: { __typename?: 'Content', id: string } };

export type CreateStreamClipMutationVariablesType = Exact<{
  input: CreateStreamClipInputType;
}>;


export type CreateStreamClipMutationType = { __typename?: 'Mutation', createStreamClip: { __typename?: 'StreamClip', content: { __typename?: 'Content', id: string } } };

export type CreateStreamMutationVariablesType = Exact<{
  input: CreateStreamInputType;
}>;


export type CreateStreamMutationType = { __typename?: 'Mutation', createStream: { __typename?: 'Content', id: string } };

export type DeleteRestreamDestinationMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteRestreamDestinationMutationType = { __typename?: 'Mutation', deleteRestreamDestination: { __typename?: 'Content', id: string } };

export type DeleteStreamClipMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type DeleteStreamClipMutationType = { __typename?: 'Mutation', deleteStreamClip: boolean };

export type FinishStreamMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type FinishStreamMutationType = { __typename?: 'Mutation', finishStream: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType } | null } };

export type ReopenStreamMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type ReopenStreamMutationType = { __typename?: 'Mutation', reopenStream: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, startAt?: any | null, finishAt?: any | null } | null } };

export type ResetStreamKeyMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type ResetStreamKeyMutationType = { __typename?: 'Mutation', resetStreamKey: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, rtmpsUrl: any, rtmpsStreamKey: string, srtUrl: any, srtStreamId: string, srtPassphrase: string } | null } };

export type StartStreamMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type StartStreamMutationType = { __typename?: 'Mutation', startStream: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType } | null } };

export type StartStreamPullMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  sourceUrl: Scalars['String']['input'];
}>;


export type StartStreamPullMutationType = { __typename?: 'Mutation', startStreamPull: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } | null } };

export type StopStreamPullMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type StopStreamPullMutationType = { __typename?: 'Mutation', stopStreamPull: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } | null } };

export type UpdateRestreamDestinationMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: UpdateRestreamDestinationInputType;
}>;


export type UpdateRestreamDestinationMutationType = { __typename?: 'Mutation', updateRestreamDestination: { __typename?: 'Content', id: string } };

export type UpdateStreamMutationVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  input: UpdateStreamInputType;
}>;


export type UpdateStreamMutationType = { __typename?: 'Mutation', updateStream: { __typename?: 'Content', id: string } };

export type StreamClipsQueryVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type StreamClipsQueryType = { __typename?: 'Query', streamClips: Array<{ __typename?: 'StreamClip', startSeconds: number, durationSeconds: number, previewUrl?: any | null, downloadUrl?: any | null, content: { __typename?: 'Content', id: string, title: string, publishAt?: any | null, duration?: number | null, transcodingError?: string | null, preview?: { __typename?: 'Image', url: any } | null, playback?: { __typename?: 'ContentPlayback', thumbnailUrl: any } | null, video?: { __typename?: 'Video', id: string, readyToStream: boolean } | null } }> };

export type StreamMonitoringQueryVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type StreamMonitoringQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, viewersOnline: number, stream?: { __typename?: 'Stream', id: string, monitoring: { __typename?: 'LiveInputMonitoring', available: boolean, unavailableReason?: MonitoringUnavailableReasonType | null, granularity: MonitoringGranularityType, status?: { __typename?: 'LiveInputStatus', connected: boolean, protocol?: string | null, since?: any | null, reason?: string | null } | null, points: Array<{ __typename?: 'LiveInputMetricsPoint', at: any, bitRateKbps?: number | null, keyframeIntervalSeconds?: number | null, uploadSpeedPercent?: number | null }>, events: Array<{ __typename?: 'LiveInputEvent', at: any, code: string, description: string, isWarning: boolean }>, sessions: Array<{ __typename?: 'LiveInputSession', start: any, end?: any | null, outcome: LiveInputSessionOutcomeType, eventCount: number, warningCount: number, hadStartupWarnings: boolean }>, outages: { __typename?: 'LiveInputOutages', count: number, totalSeconds: number, lastAt?: any | null, periods: Array<{ __typename?: 'LiveInputOutagePeriod', start: any, end: any }> }, player?: { __typename?: 'PlayerMetrics', points: Array<{ __typename?: 'PlayerMetricsPoint', at: any, viewers: number, bufferLengthSeconds?: number | null, bufferStarvationSeconds?: number | null }>, byResolution: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }>, byCountry: Array<{ __typename?: 'PlayerMetricsBucket', key: string, viewers: number }> } | null } } | null } };

export type StreamQueryVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type StreamQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, title: string, description?: string | null, publishAt?: any | null, accessStartAt?: any | null, hideInGeneralLists: boolean, onlyUsers: boolean, ageRestrictions: number, viewersOnline: number, productIds: Array<string>, url?: any | null, embedUrl?: any | null, widget?: { __typename?: 'Widget', id: string } | null, preview?: { __typename?: 'Image', id: string, url: any } | null, verticalPreview?: { __typename?: 'Image', id: string, url: any } | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }>, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, liveConnected: boolean, lastPublishAt?: any | null, startAt?: any | null, startedAt?: any | null, finishAt?: any | null, rtmpsUrl: any, rtmpsStreamKey: string, srtUrl: any, srtStreamId: string, srtPassphrase: string, enableRecord: boolean, autoPublishRecord: boolean, isChatEnabled: boolean, dvrEnabled: boolean, recordContentId?: string | null, restreamDestinationsLimit: number, signal?: { __typename?: 'StreamSignal', state: StreamSignalStateType, since: any, checkedAt: any } | null, entrypoint?: { __typename?: 'StreamEntrypoint', id: string, title: string } | null, recordingTrim?: { __typename?: 'RecordingTrim', status: RecordingTrimStatusType, startSeconds: number, endSeconds: number, progress?: number | null, error?: { __typename?: 'RecordingTrimError', code: RecordingTrimErrorCodeType, message: string } | null } | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null, playback?: { __typename?: 'ContentPlayback', token: string, hlsUrl: any, dashUrl?: any | null, iframeUrl?: any | null, thumbnailUrl: any } | null, recordPlayback?: { __typename?: 'ContentPlayback', token: string, hlsUrl: any, dashUrl?: any | null, iframeUrl?: any | null, thumbnailUrl: any } | null, restreamDestinations: Array<{ __typename?: 'RestreamDestination', id: string, title: string, url: string, streamKey: string, enabled: boolean }>, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } | null } };

export type StreamRecordingTrimQueryVariablesType = Exact<{
  contentId: Scalars['ID']['input'];
}>;


export type StreamRecordingTrimQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, recordingTrim?: { __typename?: 'RecordingTrim', status: RecordingTrimStatusType, startSeconds: number, endSeconds: number, progress?: number | null, error?: { __typename?: 'RecordingTrimError', code: RecordingTrimErrorCodeType, message: string } | null } | null } | null } };

export type StreamsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type StreamsListQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, title: string, premium: boolean, publishAt?: any | null, url?: any | null, totalViews: number, viewersOnline: number, liveState?: ContentLiveStateType | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }>, countryAccess?: { __typename?: 'CountryAccess', id: string, title: string } | null, preview?: { __typename?: 'Image', id: string, url: any } | null, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, liveConnected: boolean, startAt?: any | null, finishAt?: any | null, signal?: { __typename?: 'StreamSignal', state: StreamSignalStateType, since: any, checkedAt: any } | null, playback?: { __typename?: 'ContentPlayback', hlsUrl: any, thumbnailUrl: any } | null } | null }> } };

export type ContentStreamStatusChangedSubscriptionVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentStreamStatusChangedSubscriptionType = { __typename?: 'Subscription', contentStreamStatusChanged: { __typename?: 'Content', id: string, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, liveConnected: boolean, signal?: { __typename?: 'StreamSignal', state: StreamSignalStateType, since: any, checkedAt: any } | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', code: string, message: string } | null } | null } | null } };

export type SubscriptionPurchasesQueryVariablesType = Exact<{
  subscriptionId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SubscriptionPurchasesQueryType = { __typename?: 'Query', productPurchases: { __typename?: 'ProductPurchaseConnection', count: number, nodes: Array<{ __typename?: 'ProductPurchase', id: string, startAt: any, expiredAt: any, refunded: boolean, disputed: boolean, payment?: { __typename?: 'Payment', id: string, period: number, amount: { __typename?: 'Amount', value: number, currency: string }, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null } | null }> } };

export type SubscriptionsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SubscriptionsFilterInputType>;
}>;


export type SubscriptionsListQueryType = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', count: number, nodes: Array<{ __typename?: 'ProductSubscription', id: string, status: SubscriptionStatusType, startAt: any, currentPeriodEnd: any, billingCyclesComplete: number, renewSubscription: boolean, buyerEmail?: string | null, userId: string, renewAttempts: number, nextRenewAttemptAt?: any | null, pastDueSince?: any | null, renewErrorReason?: RenewErrorReasonType | null, renewDeadlineAt?: any | null, product: { __typename?: 'Product', id: string, title: string }, promocode?: { __typename?: 'SubscriptionPromocode', code: string, title?: string | null } | null, revenue: { __typename?: 'Amount', value: number, currency: string } }> } };

export type CreateTagMutationVariablesType = Exact<{
  input: CreateTagInputType;
}>;


export type CreateTagMutationType = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, title: string, description?: string | null, createdAt: any, updatedAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null, image?: { __typename?: 'Image', id: string, url: any } | null, verticalImage?: { __typename?: 'Image', id: string, url: any } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', name: string, value?: any | null }>, platformPage?: { __typename?: 'PlatformPage', id: string, title: string, path: string } | null } };

export type DeleteTagsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteTagsMutationType = { __typename?: 'Mutation', deleteTags: Array<{ __typename?: 'Tag', id: string } | null> };

export type UpdateTagMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTagInputType;
}>;


export type UpdateTagMutationType = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', id: string, title: string, description?: string | null, createdAt: any, updatedAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null, image?: { __typename?: 'Image', id: string, url: any } | null, verticalImage?: { __typename?: 'Image', id: string, url: any } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', name: string, value?: any | null }>, platformPage?: { __typename?: 'PlatformPage', id: string, title: string, path: string } | null } };

export type UpdateTagsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateTagsInputType;
}>;


export type UpdateTagsMutationType = { __typename?: 'Mutation', updateTags: Array<{ __typename?: 'Tag', id: string, title: string, type?: { __typename?: 'TagType', id: string, title: string } | null } | null> };

export type TagQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagQueryType = { __typename?: 'Query', tag: { __typename?: 'Tag', id: string, title: string, description?: string | null, path?: string | null, platformPageId?: string | null, createdAt: any, updatedAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null, image?: { __typename?: 'Image', id: string, url: any } | null, verticalImage?: { __typename?: 'Image', id: string, url: any } | null, customFieldValues: Array<{ __typename?: 'CustomFieldValue', name: string, value?: any | null }>, platformPage?: { __typename?: 'PlatformPage', id: string, title: string, path: string, publishAt?: any | null } | null } };

export type TagTypeQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagTypeQueryType = { __typename?: 'Query', tagType: { __typename?: 'TagType', id: string, title: string, defaultPreviewType: TagPreviewTypeType, customFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }> } };

export type TagTypesAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompleteTagTypesFilterInputType>;
}>;


export type TagTypesAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type TagsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompleteTagsFilterInputType>;
}>;


export type TagsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type TagsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TagsFilterInputType>;
}>;


export type TagsListQueryType = { __typename?: 'Query', tags: { __typename?: 'TagConnection', count: number, nodes: Array<{ __typename?: 'Tag', id: string, title: string, path?: string | null, url?: any | null, createdAt: any, updatedAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null }> } };

export type UserQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQueryType = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, agreeToMarketingNewsletters?: boolean | null, language?: string | null, country?: string | null, timeZone?: string | null, createdAt: any, updatedAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null, registrationUtm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, lastUtm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, marketingConsent?: { __typename?: 'MarketingConsent', at: any } | null } };

export type UsersListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UsersFilterInputType>;
}>;


export type UsersListQueryType = { __typename?: 'Query', users: { __typename?: 'UserConnection', count: number, nodes: Array<{ __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, agreeToMarketingNewsletters?: boolean | null, language?: string | null, country?: string | null, timeZone?: string | null, createdAt: any, updatedAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null }> } };

export type CreateWidgetMutationVariablesType = Exact<{
  input: CreateWidgetInputType;
}>;


export type CreateWidgetMutationType = { __typename?: 'Mutation', createWidget: { __typename?: 'Widget', id: string, title: string, buttonUrl: string, buttonText: string, buttonColor: string, buttonTextColor: string, hits: number, clicks: number, ctr: number, createdAt: any } };

export type DeleteWidgetsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteWidgetsMutationType = { __typename?: 'Mutation', deleteWidgets: Array<{ __typename?: 'Widget', id: string } | null> };

export type SetDefaultWidgetMutationVariablesType = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetDefaultWidgetMutationType = { __typename?: 'Mutation', setDefaultWidget: boolean };

export type UpdateWidgetMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateWidgetInputType;
}>;


export type UpdateWidgetMutationType = { __typename?: 'Mutation', updateWidget: { __typename?: 'Widget', id: string, title: string, buttonUrl: string, buttonText: string, buttonColor: string, buttonTextColor: string, hits: number, clicks: number, ctr: number, createdAt: any } };

export type WidgetQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetQueryType = { __typename?: 'Query', widget: { __typename?: 'Widget', id: string, title: string, buttonUrl: string, buttonText: string, buttonColor: string, buttonTextColor: string } };

export type WidgetsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WidgetsListQueryType = { __typename?: 'Query', widgets: { __typename?: 'WidgetConnection', count: number, nodes: Array<{ __typename?: 'Widget', id: string, title: string, buttonUrl: string, buttonText: string, buttonColor: string, buttonTextColor: string, hits: number, clicks: number, ctr: number, isDefault: boolean, createdAt: any }> } };

export type CreateVideoFileUploadMutationVariablesType = Exact<{
  input: CreateVideoFileUploadInputType;
}>;


export type CreateVideoFileUploadMutationType = { __typename?: 'Mutation', createVideoFileUpload: { __typename?: 'VideoFileUpload', uploadUrl: any, videoFile: { __typename?: 'VideoFile', id: string, status: VideoFileStatusType, fileName: string }, headers: Array<{ __typename?: 'VideoFileUploadHeader', name: string, value: string }> } };

export type DeleteVideoFilesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteVideoFilesMutationType = { __typename?: 'Mutation', deleteVideoFiles: Array<{ __typename?: 'VideoFile', id: string } | null> };

export type FinishVideoFileUploadMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishVideoFileUploadMutationType = { __typename?: 'Mutation', finishVideoFileUpload: { __typename?: 'VideoFile', id: string, status: VideoFileStatusType, error?: string | null } };

export type UploadAvatarMutationVariablesType = Exact<{
  input: UploadAvatarInputType;
}>;


export type UploadAvatarMutationType = { __typename?: 'Mutation', file: { __typename?: 'Avatar', id: string, url: any } };

export type UploadBannerMutationVariablesType = Exact<{
  input: UploadBannerInputType;
}>;


export type UploadBannerMutationType = { __typename?: 'Mutation', file: { __typename?: 'Banner', id: string, url: any } };

export type UploadFileMutationVariablesType = Exact<{
  input: UploadFileInputType;
}>;


export type UploadFileMutationType = { __typename?: 'Mutation', file: { __typename?: 'File', id: string, url: any } };

export type UploadImageMutationVariablesType = Exact<{
  input: UploadImageInputType;
}>;


export type UploadImageMutationType = { __typename?: 'Mutation', file: { __typename?: 'Image', id: string, url: any } };

export type UploadPrivateFileMutationVariablesType = Exact<{
  input: UploadPrivateFileInputType;
}>;


export type UploadPrivateFileMutationType = { __typename?: 'Mutation', file: { __typename?: 'PrivateFile', id: string, url: any } };

export type AvatarQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AvatarQueryType = { __typename?: 'Query', file: { __typename?: 'Avatar', id: string, url: any } };

export type BannerFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BannerFileQueryType = { __typename?: 'Query', file: { __typename?: 'Banner', id: string, url: any } };

export type DaDataFindOrganizationByInnQueryVariablesType = Exact<{
  inn: Scalars['String']['input'];
  kpp?: InputMaybe<Scalars['String']['input']>;
}>;


export type DaDataFindOrganizationByInnQueryType = { __typename?: 'Query', dadataFindOrganizationByInn: { __typename?: 'DaDataOrganizationResponse', suggestions: Array<{ __typename?: 'DaDataOrganizationSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataOrganization', inn: string, kpp: string, ogrn: string, name: { __typename?: 'DaDataOrganizationName', full_with_opf: string, short_with_opf: string, full: string, short: string }, address: { __typename?: 'DaDataOrganizationAddress', value: string, unrestricted_value: string }, management?: { __typename?: 'DaDataOrganizationManagement', name: string, post: string } | null, state: { __typename?: 'DaDataOrganizationState', status: string } } }> } };

export type DaDataSuggestAddressQueryVariablesType = Exact<{
  query: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>> | InputMaybe<DaDataLocationInputType>>;
}>;


export type DaDataSuggestAddressQueryType = { __typename?: 'Query', dadataSuggestAddress: { __typename?: 'DaDataAddressResponse', suggestions: Array<{ __typename?: 'DaDataAddressSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataAddress', postal_code?: string | null, country: string, region: string, city?: string | null, street?: string | null, house?: string | null, flat?: string | null, fias_id: string, geo_lat?: string | null, geo_lon?: string | null } }> } };

export type DaDataSuggestOrganizationQueryVariablesType = Exact<{
  query: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DaDataSuggestOrganizationQueryType = { __typename?: 'Query', dadataSuggestOrganization: { __typename?: 'DaDataOrganizationResponse', suggestions: Array<{ __typename?: 'DaDataOrganizationSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataOrganization', inn: string, kpp: string, ogrn: string, name: { __typename?: 'DaDataOrganizationName', full_with_opf: string, short_with_opf: string, full: string, short: string }, address: { __typename?: 'DaDataOrganizationAddress', value: string, unrestricted_value: string }, management?: { __typename?: 'DaDataOrganizationManagement', name: string, post: string } | null, state: { __typename?: 'DaDataOrganizationState', status: string } } }> } };

export type FileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileQueryType = { __typename?: 'Query', file: { __typename?: 'File', id: string, url: any } };

export type ImageFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ImageFileQueryType = { __typename?: 'Query', file: { __typename?: 'Image', id: string, url: any } };

export type PrivateFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PrivateFileQueryType = { __typename?: 'Query', file: { __typename?: 'PrivateFile', id: string, url: any } };

export type VideoFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VideoFileQueryType = { __typename?: 'Query', videoFile?: { __typename?: 'VideoFile', id: string, status: VideoFileStatusType, fileName: string, size: number, duration?: number | null, width?: number | null, height?: number | null, playlistUrl?: any | null, posterUrl?: any | null, error?: string | null, createdAt: any } | null };
